(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire491f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire491f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
'use strict';

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRegister("6cds3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gx6CV"));

});
parcelRegister("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
'use strict';
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
'use strict';

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    function b(b) {
        return $e8dfc29dafb3bbd7$var$ad(b, a);
    }
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    }
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var d = f, e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) d = $e8dfc29dafb3bbd7$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Mg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Ng = null, $e8dfc29dafb3bbd7$var$Og = null, $e8dfc29dafb3bbd7$var$Pg = null;
function $e8dfc29dafb3bbd7$var$Qg() {
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Ng = null;
}
function $e8dfc29dafb3bbd7$var$Rg(a) {
    var b = $e8dfc29dafb3bbd7$var$Mg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Mg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$Tg(a, b) {
    $e8dfc29dafb3bbd7$var$Ng = a;
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$Ug = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$Vg(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Og) {
            if (null === $e8dfc29dafb3bbd7$var$Ng) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Og = a;
            $e8dfc29dafb3bbd7$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Og.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Wg = null;
function $e8dfc29dafb3bbd7$var$Xg(a) {
    null === $e8dfc29dafb3bbd7$var$Wg ? $e8dfc29dafb3bbd7$var$Wg = [
        a
    ] : $e8dfc29dafb3bbd7$var$Wg.push(a);
}
function $e8dfc29dafb3bbd7$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$Zg(a, d);
}
function $e8dfc29dafb3bbd7$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$$g = !1;
function $e8dfc29dafb3bbd7$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$Zg(a, c);
}
function $e8dfc29dafb3bbd7$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$jh = (new $6cds3.Component).refs;
function $e8dfc29dafb3bbd7$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$L(), d = $e8dfc29dafb3bbd7$var$lh(a), e = $e8dfc29dafb3bbd7$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$dh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, d, c), $e8dfc29dafb3bbd7$var$eh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$ph(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$Vg(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8dfc29dafb3bbd7$var$jh;
    $e8dfc29dafb3bbd7$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$Vg(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e8dfc29dafb3bbd7$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$sh(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$zh(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Bh = $e8dfc29dafb3bbd7$var$vh(!0), $e8dfc29dafb3bbd7$var$Ch = $e8dfc29dafb3bbd7$var$vh(!1), $e8dfc29dafb3bbd7$var$Dh = {}, $e8dfc29dafb3bbd7$var$Eh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh);
function $e8dfc29dafb3bbd7$var$Hh(a) {
    if (a === $e8dfc29dafb3bbd7$var$Dh) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$Ih(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Gh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, $e8dfc29dafb3bbd7$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, b);
}
function $e8dfc29dafb3bbd7$var$Jh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Gh);
}
function $e8dfc29dafb3bbd7$var$Kh(a) {
    $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
    var b = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, c));
}
function $e8dfc29dafb3bbd7$var$Lh(a) {
    $e8dfc29dafb3bbd7$var$Fh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh));
}
var $e8dfc29dafb3bbd7$var$M = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nh = [];
function $e8dfc29dafb3bbd7$var$Oh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Nh.length; a++)$e8dfc29dafb3bbd7$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Nh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Ph = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Qh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Rh = 0, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$P = null, $e8dfc29dafb3bbd7$var$Sh = !1, $e8dfc29dafb3bbd7$var$Th = !1, $e8dfc29dafb3bbd7$var$Uh = 0, $e8dfc29dafb3bbd7$var$Vh = 0;
function $e8dfc29dafb3bbd7$var$Q() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Rh = f;
    $e8dfc29dafb3bbd7$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Ph.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Yh : $e8dfc29dafb3bbd7$var$Zh;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Th) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$$h;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Th);
    }
    $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
    b = null !== $e8dfc29dafb3bbd7$var$O && null !== $e8dfc29dafb3bbd7$var$O.next;
    $e8dfc29dafb3bbd7$var$Rh = 0;
    $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
    $e8dfc29dafb3bbd7$var$Sh = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$bi() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Uh;
    $e8dfc29dafb3bbd7$var$Uh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$di() {
    if (null === $e8dfc29dafb3bbd7$var$O) {
        var a = $e8dfc29dafb3bbd7$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$O.next;
    var b = null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState : $e8dfc29dafb3bbd7$var$P.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$P = b, $e8dfc29dafb3bbd7$var$O = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$O = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$O.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$O.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$O.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$O.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    }
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$N.lanes |= m;
                $e8dfc29dafb3bbd7$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$N.lanes |= f, $e8dfc29dafb3bbd7$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$gi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$hi() {}
function $e8dfc29dafb3bbd7$var$ii(a, b) {
    var c = $e8dfc29dafb3bbd7$var$N, d = $e8dfc29dafb3bbd7$var$di(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$Ug = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$ji($e8dfc29dafb3bbd7$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$P && $e8dfc29dafb3bbd7$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
    });
}
function $e8dfc29dafb3bbd7$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$pi(a) {
    var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$mh(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$qi(a) {
    var b = $e8dfc29dafb3bbd7$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ri.bind(null, $e8dfc29dafb3bbd7$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$si() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ti(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$ci();
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$O) {
        var g = $e8dfc29dafb3bbd7$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Wh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$li(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    return $e8dfc29dafb3bbd7$var$ti(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ji(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$wi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$xi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$ui(4, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$Ai() {}
function $e8dfc29dafb3bbd7$var$Bi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$Ug = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$N.lanes |= c, $e8dfc29dafb3bbd7$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ei(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Qh.transition;
    $e8dfc29dafb3bbd7$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Qh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$Fi() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$Yg(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$L();
        $e8dfc29dafb3bbd7$var$mh(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Ji(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ri(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$Yg(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$L(), $e8dfc29dafb3bbd7$var$mh(c, a, d, e), $e8dfc29dafb3bbd7$var$Ji(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$Hi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$N || null !== b && b === $e8dfc29dafb3bbd7$var$N;
}
function $e8dfc29dafb3bbd7$var$Ii(a, b) {
    $e8dfc29dafb3bbd7$var$Th = $e8dfc29dafb3bbd7$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$ai = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Q,
    useContext: $e8dfc29dafb3bbd7$var$Q,
    useEffect: $e8dfc29dafb3bbd7$var$Q,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$Q,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$Q,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$Q,
    useMemo: $e8dfc29dafb3bbd7$var$Q,
    useReducer: $e8dfc29dafb3bbd7$var$Q,
    useRef: $e8dfc29dafb3bbd7$var$Q,
    useState: $e8dfc29dafb3bbd7$var$Q,
    useDebugValue: $e8dfc29dafb3bbd7$var$Q,
    useDeferredValue: $e8dfc29dafb3bbd7$var$Q,
    useTransition: $e8dfc29dafb3bbd7$var$Q,
    useMutableSource: $e8dfc29dafb3bbd7$var$Q,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Q,
    useId: $e8dfc29dafb3bbd7$var$Q,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Yh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: function(a, b) {
        $e8dfc29dafb3bbd7$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$Gi.bind(null, $e8dfc29dafb3bbd7$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e8dfc29dafb3bbd7$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$qi,
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        return $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$qi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$Ei.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$N, e = $e8dfc29dafb3bbd7$var$ci();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$vi($e8dfc29dafb3bbd7$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e8dfc29dafb3bbd7$var$ci(), b = $e8dfc29dafb3bbd7$var$R.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Zh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$fi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$$h = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$gi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return null === $e8dfc29dafb3bbd7$var$O ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Oi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Pi || ($e8dfc29dafb3bbd7$var$Pi = !0, $e8dfc29dafb3bbd7$var$Qi = d);
        $e8dfc29dafb3bbd7$var$Mi(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Ri(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Mi(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Si ? $e8dfc29dafb3bbd7$var$Si = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$ch(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Xi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$Ug = !1;
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Ch(b, null, c, d) : $e8dfc29dafb3bbd7$var$Bh(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    d = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$cj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$Ug = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$$i(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj);
            $e8dfc29dafb3bbd7$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= d;
    $e8dfc29dafb3bbd7$var$Yi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    c = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$jj(a, b), $e8dfc29dafb3bbd7$var$ph(b, c, d), $e8dfc29dafb3bbd7$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$Vg(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$qh(b, g, d, l);
        $e8dfc29dafb3bbd7$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$Vg(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$qh(b, g, d, k);
        $e8dfc29dafb3bbd7$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$kj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$kj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$$i(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$Ih(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$mj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$qj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$nj, a) : $e8dfc29dafb3bbd7$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$wh(h, f) : (f = $e8dfc29dafb3bbd7$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$rj(a, b) {
    b = $e8dfc29dafb3bbd7$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$tj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Li(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$Ug || h) {
        d = $e8dfc29dafb3bbd7$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$Zg(a, e), $e8dfc29dafb3bbd7$var$mh(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$uj();
        d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$Sg(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$lj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Kh(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$pj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
                a = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$$i(a, b, c);
}
var $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj, $e8dfc29dafb3bbd7$var$Dj;
$e8dfc29dafb3bbd7$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Bj = function() {};
$e8dfc29dafb3bbd7$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Ej(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$Jh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Bj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Lh(b);
            var e = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
                $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$M.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$Bj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Ej(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Hj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$M.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$gj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Jj(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Lh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Kj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Oj = !1;
function $e8dfc29dafb3bbd7$var$Pj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Oj;
    $e8dfc29dafb3bbd7$var$Oj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Yj = !1;
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$ak(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$ak(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Mj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Yj = !0;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Nj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Zj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Lj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Yj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$ak(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$ek(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Qj(3, a, a.return), $e8dfc29dafb3bbd7$var$Rj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$gk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$fk(a);
    }
}
function $e8dfc29dafb3bbd7$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$jk(a, b, c);
}
function $e8dfc29dafb3bbd7$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Kj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Kj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$kk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$kk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$jk(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Kj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$lk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$lk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Sj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$hk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$mk = Math.ceil, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$pk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$gj = 0, $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$qk = null, $e8dfc29dafb3bbd7$var$hh = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = 0, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$gk = 0, $e8dfc29dafb3bbd7$var$Hj = Infinity, $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Pi = !1, $e8dfc29dafb3bbd7$var$Qi = null, $e8dfc29dafb3bbd7$var$Si = null, $e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = null, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, $e8dfc29dafb3bbd7$var$Bk = -1, $e8dfc29dafb3bbd7$var$Ck = 0;
function $e8dfc29dafb3bbd7$var$L() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Bk ? $e8dfc29dafb3bbd7$var$Bk : $e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Ck && ($e8dfc29dafb3bbd7$var$Ck = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Ck;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$mh(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$zk) throw $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$R) a === $e8dfc29dafb3bbd7$var$R && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$rk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Ek(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Fk.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Fk.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Gk(c, $e8dfc29dafb3bbd7$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Hk(a, b) {
    $e8dfc29dafb3bbd7$var$Bk = -1;
    $e8dfc29dafb3bbd7$var$Ck = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Jk(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Kk();
        if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Lk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Mk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Nk(a, h);
        }
        $e8dfc29dafb3bbd7$var$Qg();
        $e8dfc29dafb3bbd7$var$nk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Ok(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Pk(e) && (b = $e8dfc29dafb3bbd7$var$Jk(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Ok(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$gk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Hk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Ok(a, b) {
    var c = $e8dfc29dafb3bbd7$var$tk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Lk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Jk(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$uk = c, null !== b && $e8dfc29dafb3bbd7$var$Gj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Gj(a) {
    null === $e8dfc29dafb3bbd7$var$uk ? $e8dfc29dafb3bbd7$var$uk = a : $e8dfc29dafb3bbd7$var$uk.push.apply($e8dfc29dafb3bbd7$var$uk, a);
}
function $e8dfc29dafb3bbd7$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$sk;
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Fk(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, b), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Rk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    null !== $e8dfc29dafb3bbd7$var$xk && 0 === $e8dfc29dafb3bbd7$var$xk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$pk.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$pk.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Ij() {
    $e8dfc29dafb3bbd7$var$gj = $e8dfc29dafb3bbd7$var$fj.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$fj);
}
function $e8dfc29dafb3bbd7$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$Jh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Oh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Lh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$Jh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Ij();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$R = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$wh(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$gj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$qk = null;
    $e8dfc29dafb3bbd7$var$sk = $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$hh = 0;
    $e8dfc29dafb3bbd7$var$uk = $e8dfc29dafb3bbd7$var$tk = null;
    if (null !== $e8dfc29dafb3bbd7$var$Wg) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$Wg.length; b++)if (c = $e8dfc29dafb3bbd7$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$Wg = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$Qg();
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
            if ($e8dfc29dafb3bbd7$var$Sh) {
                for(var d = $e8dfc29dafb3bbd7$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Sh = !1;
            }
            $e8dfc29dafb3bbd7$var$Rh = 0;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            $e8dfc29dafb3bbd7$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$qk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                            $e8dfc29dafb3bbd7$var$uj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Wi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ki(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Oi(f, k, b);
                            $e8dfc29dafb3bbd7$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Ri(f, h, b);
                                $e8dfc29dafb3bbd7$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Tk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Kk() {
    var a = $e8dfc29dafb3bbd7$var$nk.current;
    $e8dfc29dafb3bbd7$var$nk.current = $e8dfc29dafb3bbd7$var$ai;
    return null === a ? $e8dfc29dafb3bbd7$var$ai : a;
}
function $e8dfc29dafb3bbd7$var$uj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$R || 0 === ($e8dfc29dafb3bbd7$var$hh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$rk & 268435455) || $e8dfc29dafb3bbd7$var$Dk($e8dfc29dafb3bbd7$var$R, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Jk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Kk();
    if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Lk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Uk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Nk(a, e);
    }
    $e8dfc29dafb3bbd7$var$Qg();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$nk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$R = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Uk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Mk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Vk(a) {
    var b = $e8dfc29dafb3bbd7$var$Wk(a.alternate, a, $e8dfc29dafb3bbd7$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Tk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$ok.current = null;
}
function $e8dfc29dafb3bbd7$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Fj(c, b, $e8dfc29dafb3bbd7$var$gj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Qk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$pk.transition;
    try {
        $e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Xk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$pk.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Ik();
    while (null !== $e8dfc29dafb3bbd7$var$xk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$R && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$wk || ($e8dfc29dafb3bbd7$var$wk = !0, $e8dfc29dafb3bbd7$var$Gk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$pk.transition;
        $e8dfc29dafb3bbd7$var$pk.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$ok.current = null;
        $e8dfc29dafb3bbd7$var$Pj(a, c);
        $e8dfc29dafb3bbd7$var$ek(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$ik(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$pk.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$wk && ($e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = a, $e8dfc29dafb3bbd7$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Si = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Pi) throw $e8dfc29dafb3bbd7$var$Pi = !1, a = $e8dfc29dafb3bbd7$var$Qi, $e8dfc29dafb3bbd7$var$Qi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$yk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$zk++ : ($e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = a) : $e8dfc29dafb3bbd7$var$zk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Ik() {
    if (null !== $e8dfc29dafb3bbd7$var$xk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$yk), b = $e8dfc29dafb3bbd7$var$pk.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$pk.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$xk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$xk;
                $e8dfc29dafb3bbd7$var$xk = null;
                $e8dfc29dafb3bbd7$var$yk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Tj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Yk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ki(c, b);
    b = $e8dfc29dafb3bbd7$var$Oi(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$dh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$L();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Ek(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ki(c, a);
                a = $e8dfc29dafb3bbd7$var$Ri(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$dh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$L();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$R === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$gk ? $e8dfc29dafb3bbd7$var$Lk(a, 0) : $e8dfc29dafb3bbd7$var$sk |= c);
    $e8dfc29dafb3bbd7$var$Ek(a, b);
}
function $e8dfc29dafb3bbd7$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$L();
    a = $e8dfc29dafb3bbd7$var$Zg(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Ek(a, c));
}
function $e8dfc29dafb3bbd7$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
var $e8dfc29dafb3bbd7$var$Wk;
$e8dfc29dafb3bbd7$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$zj(a, b, c);
            $e8dfc29dafb3bbd7$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$Tg(b, c);
            e = $e8dfc29dafb3bbd7$var$Xh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$ah(b), e.updater = $e8dfc29dafb3bbd7$var$nh, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$rh(b, d, a, c), b = $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$$k(d);
                a = $e8dfc29dafb3bbd7$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$aj(null, b, d, $e8dfc29dafb3bbd7$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$lj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$bh(a, b);
                $e8dfc29dafb3bbd7$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Kh(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$hj(a, b), $e8dfc29dafb3bbd7$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$pj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, d, c) : $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$Zi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$Tg(b, c), e = $e8dfc29dafb3bbd7$var$Vg(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Lg(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Lg(d.type, e), $e8dfc29dafb3bbd7$var$aj(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$jj(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$Tg(b, c), $e8dfc29dafb3bbd7$var$ph(b, d, e), $e8dfc29dafb3bbd7$var$rh(b, d, e, c), $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$yj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$al(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$$k(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Ah(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ah(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$qj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$xh(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$zh(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$ah(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$el(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$el(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$L();
    e = $e8dfc29dafb3bbd7$var$lh(c);
    f = $e8dfc29dafb3bbd7$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$dh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Ek(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$gl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$L(), g = $e8dfc29dafb3bbd7$var$lh(e);
    c = $e8dfc29dafb3bbd7$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$dh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$mh(a, e, g, f), $e8dfc29dafb3bbd7$var$eh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$jl(a, b) {
    $e8dfc29dafb3bbd7$var$il(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$il(a, b);
}
function $e8dfc29dafb3bbd7$var$kl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.render = $e8dfc29dafb3bbd7$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$gl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$nl.prototype.unmount = $e8dfc29dafb3bbd7$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Sk(function() {
            $e8dfc29dafb3bbd7$var$gl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$ql() {}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                f.call(a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$fl(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e8dfc29dafb3bbd7$var$hl(k);
            h.call(a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$cl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$gl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                h.call(a);
            };
        }
        $e8dfc29dafb3bbd7$var$gl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$rl(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$hl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Ek(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Sk(function() {
                var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$L();
                    $e8dfc29dafb3bbd7$var$mh(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$jl(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$jl(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$lh(a), c = $e8dfc29dafb3bbd7$var$Zg(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$jl(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Sk;
var $e8dfc29dafb3bbd7$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Rk
    ]
}, $e8dfc29dafb3bbd7$var$ul = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$vl = {
    bundleType: $e8dfc29dafb3bbd7$var$ul.bundleType,
    version: $e8dfc29dafb3bbd7$var$ul.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$ul.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$ul.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$wl.isDisabled && $e8dfc29dafb3bbd7$var$wl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$wl.inject($e8dfc29dafb3bbd7$var$vl), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$wl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$tl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$dl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Sk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$nl(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$pl(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$pl(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$sl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("1c9zD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lffg4"));

});
parcelRegister("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
'use strict';
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRegister("hj6t9", function(module, exports) {

module.exports = (parcelRequire("8xQ7e"))($parcel$resolve("kWRtk")).then(()=>parcelRequire('cNIke'));

});
parcelRegister("8xQ7e", function(module, exports) {
"use strict";

var $erm87 = parcelRequire("erm87");
module.exports = $erm87(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("erm87", function(module, exports) {
"use strict";
var $a834c0da6d99fec1$var$cachedBundles = {};
var $a834c0da6d99fec1$var$cachedPreloads = {};
var $a834c0da6d99fec1$var$cachedPrefetches = {};
function $a834c0da6d99fec1$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a834c0da6d99fec1$var$cachedPreloads;
        case 'prefetch':
            return $a834c0da6d99fec1$var$cachedPrefetches;
        default:
            return $a834c0da6d99fec1$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a834c0da6d99fec1$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("g8ZYZ", function(module, exports) {
/* global window */ 
var $10jgr = parcelRequire("10jgr");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $10jgr.default)(root);
var $bc0d792ece629357$export$2e2bcd8739ae039 = result;

});
parcelRegister("10jgr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bb4bbf9bf76679b$export$2e2bcd8739ae039; });
function $0bb4bbf9bf76679b$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});


var $1e03f9e36444a813$exports = {};
$parcel$extendImportMap({
    "kWRtk": "web-vitals.7f21e881.js"
});

var $fba0f23e9e6a11bb$exports = {};
'use strict';

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));



var $6cds3 = parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
'use strict';
var $6d4849ee44552f5f$exports = {};
'use strict';
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));


var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $6d4849ee44552f5f$exports.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $6d4849ee44552f5f$exports.hydrateRoot;





var $6cds3 = parcelRequire("6cds3");


// Assumendo che `locale` venga passato come proprietà o gestito nello stato globale


var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
var $ba34d1ebd6528b77$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $ba34d1ebd6528b77$var$isDateObject = (value1)=>value1 instanceof Date;
var $ba34d1ebd6528b77$var$isNullOrUndefined = (value1)=>value1 == null;
const $ba34d1ebd6528b77$var$isObjectType = (value1)=>typeof value1 === 'object';
var $ba34d1ebd6528b77$var$isObject = (value1)=>!$ba34d1ebd6528b77$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $ba34d1ebd6528b77$var$isObjectType(value1) && !$ba34d1ebd6528b77$var$isDateObject(value1);
var $ba34d1ebd6528b77$var$getEventValue = (event)=>$ba34d1ebd6528b77$var$isObject(event) && event.target ? $ba34d1ebd6528b77$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $ba34d1ebd6528b77$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $ba34d1ebd6528b77$var$isNameInFieldArray = (names, name)=>names.has($ba34d1ebd6528b77$var$getNodeParentName(name));
var $ba34d1ebd6528b77$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $ba34d1ebd6528b77$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $ba34d1ebd6528b77$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $ba34d1ebd6528b77$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($ba34d1ebd6528b77$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $ba34d1ebd6528b77$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$ba34d1ebd6528b77$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $ba34d1ebd6528b77$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $ba34d1ebd6528b77$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $ba34d1ebd6528b77$var$isUndefined = (val)=>val === undefined;
var $ba34d1ebd6528b77$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$ba34d1ebd6528b77$var$isObject(object)) return defaultValue;
    const result = $ba34d1ebd6528b77$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$ba34d1ebd6528b77$var$isNullOrUndefined(result) ? result : result[key], object);
    return $ba34d1ebd6528b77$var$isUndefined(result) || result === object ? $ba34d1ebd6528b77$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $ba34d1ebd6528b77$var$isBoolean = (value1)=>typeof value1 === 'boolean';
const $ba34d1ebd6528b77$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $ba34d1ebd6528b77$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $ba34d1ebd6528b77$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ba34d1ebd6528b77$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($ba34d1ebd6528b77$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ba34d1ebd6528b77$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($ba34d1ebd6528b77$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $ba34d1ebd6528b77$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $ba34d1ebd6528b77$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $ba34d1ebd6528b77$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $ba34d1ebd6528b77$var$isEmptyObject = (value1)=>$ba34d1ebd6528b77$var$isObject(value1) && !Object.keys(value1).length;
var $ba34d1ebd6528b77$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $ba34d1ebd6528b77$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $ba34d1ebd6528b77$var$VALIDATION_MODE.all));
};
var $ba34d1ebd6528b77$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $ba34d1ebd6528b77$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $ba34d1ebd6528b77$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $ba34d1ebd6528b77$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$606f11b2eb45ecc6(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(name);
    _name.current = name;
    $ba34d1ebd6528b77$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $ba34d1ebd6528b77$var$shouldSubscribeByName(_name.current, value1.name, exact) && $ba34d1ebd6528b77$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $ba34d1ebd6528b77$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $ba34d1ebd6528b77$var$isString = (value1)=>typeof value1 === 'string';
var $ba34d1ebd6528b77$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($ba34d1ebd6528b77$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $ba34d1ebd6528b77$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $ba34d1ebd6528b77$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $ba34d1ebd6528b77$export$3c773aa2b84f29e0(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(name);
    _name.current = name;
    $ba34d1ebd6528b77$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($ba34d1ebd6528b77$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($ba34d1ebd6528b77$var$cloneObject($ba34d1ebd6528b77$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $ba34d1ebd6528b77$var$isKey = (value1)=>/^\w*$/.test(value1);
var $ba34d1ebd6528b77$var$stringToPath = (input)=>$ba34d1ebd6528b77$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $ba34d1ebd6528b77$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $ba34d1ebd6528b77$var$isKey(path) ? [
        path
    ] : $ba34d1ebd6528b77$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $ba34d1ebd6528b77$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$e8c786024a2b0a79(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $ba34d1ebd6528b77$var$isNameInFieldArray(control._names.array, name);
    const value1 = $ba34d1ebd6528b77$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $ba34d1ebd6528b77$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$ba34d1ebd6528b77$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $ba34d1ebd6528b77$var$cloneObject($ba34d1ebd6528b77$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($ba34d1ebd6528b77$var$isUndefined($ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name))) $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if ($ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$ba34d1ebd6528b77$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $ba34d1ebd6528b77$var$getEventValue(event),
                        name: name
                    },
                    type: $ba34d1ebd6528b77$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $ba34d1ebd6528b77$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $ba34d1ebd6528b77$export$bd0bf19f25da8474 = (props)=>props.render($ba34d1ebd6528b77$export$e8c786024a2b0a79(props));
const $ba34d1ebd6528b77$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$a7fed597f4b8afd8(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $ba34d1ebd6528b77$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $ba34d1ebd6528b77$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $ba34d1ebd6528b77$var$generateId = ()=>{
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $ba34d1ebd6528b77$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $ba34d1ebd6528b77$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$ba34d1ebd6528b77$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $ba34d1ebd6528b77$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.all,
        isOnTouch: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onTouched
    });
var $ba34d1ebd6528b77$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $ba34d1ebd6528b77$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
                else $ba34d1ebd6528b77$var$iterateFieldsByAction(currentField, action);
            } else if ($ba34d1ebd6528b77$var$isObject(currentField)) $ba34d1ebd6528b77$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $ba34d1ebd6528b77$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $ba34d1ebd6528b77$var$compact($ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name));
    $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $ba34d1ebd6528b77$var$isFileInput = (element)=>element.type === 'file';
var $ba34d1ebd6528b77$var$isFunction = (value1)=>typeof value1 === 'function';
var $ba34d1ebd6528b77$var$isHTMLElement = (value1)=>{
    if (!$ba34d1ebd6528b77$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $ba34d1ebd6528b77$var$isMessage = (value1)=>$ba34d1ebd6528b77$var$isString(value1);
var $ba34d1ebd6528b77$var$isRadioInput = (element)=>element.type === 'radio';
var $ba34d1ebd6528b77$var$isRegex = (value1)=>value1 instanceof RegExp;
const $ba34d1ebd6528b77$var$defaultResult = {
    value: false,
    isValid: false
};
const $ba34d1ebd6528b77$var$validResult = {
    value: true,
    isValid: true
};
var $ba34d1ebd6528b77$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$ba34d1ebd6528b77$var$isUndefined(options[0].attributes.value) ? $ba34d1ebd6528b77$var$isUndefined(options[0].value) || options[0].value === '' ? $ba34d1ebd6528b77$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $ba34d1ebd6528b77$var$validResult : $ba34d1ebd6528b77$var$defaultResult;
    }
    return $ba34d1ebd6528b77$var$defaultResult;
};
const $ba34d1ebd6528b77$var$defaultReturn = {
    isValid: false,
    value: null
};
var $ba34d1ebd6528b77$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $ba34d1ebd6528b77$var$defaultReturn) : $ba34d1ebd6528b77$var$defaultReturn;
function $ba34d1ebd6528b77$var$getValidateError(result, ref, type = 'validate') {
    if ($ba34d1ebd6528b77$var$isMessage(result) || Array.isArray(result) && result.every($ba34d1ebd6528b77$var$isMessage) || $ba34d1ebd6528b77$var$isBoolean(result) && !result) return {
        type: type,
        message: $ba34d1ebd6528b77$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $ba34d1ebd6528b77$var$getValueAndMessage = (validationData)=>$ba34d1ebd6528b77$var$isObject(validationData) && !$ba34d1ebd6528b77$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $ba34d1ebd6528b77$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $ba34d1ebd6528b77$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($ba34d1ebd6528b77$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $ba34d1ebd6528b77$var$isRadioInput(ref);
    const isCheckBox = $ba34d1ebd6528b77$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $ba34d1ebd6528b77$var$isFileInput(ref)) && $ba34d1ebd6528b77$var$isUndefined(ref.value) && $ba34d1ebd6528b77$var$isUndefined(inputValue) || $ba34d1ebd6528b77$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $ba34d1ebd6528b77$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.maxLength, minType = $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $ba34d1ebd6528b77$var$isNullOrUndefined(inputValue)) || $ba34d1ebd6528b77$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$ba34d1ebd6528b77$var$getCheckboxValue(refs).isValid || isRadio && !$ba34d1ebd6528b77$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $ba34d1ebd6528b77$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $ba34d1ebd6528b77$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$ba34d1ebd6528b77$var$isNullOrUndefined(min) || !$ba34d1ebd6528b77$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $ba34d1ebd6528b77$var$getValueAndMessage(max);
        const minOutput = $ba34d1ebd6528b77$var$getValueAndMessage(min);
        if (!$ba34d1ebd6528b77$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$ba34d1ebd6528b77$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$ba34d1ebd6528b77$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($ba34d1ebd6528b77$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($ba34d1ebd6528b77$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.max, $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($ba34d1ebd6528b77$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $ba34d1ebd6528b77$var$getValueAndMessage(maxLength);
        const minLengthOutput = $ba34d1ebd6528b77$var$getValueAndMessage(minLength);
        const exceedMax = !$ba34d1ebd6528b77$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$ba34d1ebd6528b77$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $ba34d1ebd6528b77$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $ba34d1ebd6528b77$var$getValueAndMessage(pattern);
        if ($ba34d1ebd6528b77$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($ba34d1ebd6528b77$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $ba34d1ebd6528b77$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($ba34d1ebd6528b77$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$ba34d1ebd6528b77$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $ba34d1ebd6528b77$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$ba34d1ebd6528b77$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $ba34d1ebd6528b77$var$appendAt = (data, value1)=>[
        ...data,
        ...$ba34d1ebd6528b77$var$convertToArrayPayload(value1)
    ];
var $ba34d1ebd6528b77$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $ba34d1ebd6528b77$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$ba34d1ebd6528b77$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $ba34d1ebd6528b77$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($ba34d1ebd6528b77$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $ba34d1ebd6528b77$var$prependAt = (data, value1)=>[
        ...$ba34d1ebd6528b77$var$convertToArrayPayload(value1),
        ...$ba34d1ebd6528b77$var$convertToArrayPayload(data)
    ];
function $ba34d1ebd6528b77$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $ba34d1ebd6528b77$var$compact(temp).length ? temp : [];
}
var $ba34d1ebd6528b77$var$removeArrayAt = (data, index)=>$ba34d1ebd6528b77$var$isUndefined(index) ? [] : $ba34d1ebd6528b77$var$removeAtIndexes(data, $ba34d1ebd6528b77$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $ba34d1ebd6528b77$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $ba34d1ebd6528b77$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $ba34d1ebd6528b77$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $ba34d1ebd6528b77$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$ba34d1ebd6528b77$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $ba34d1ebd6528b77$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $ba34d1ebd6528b77$var$isKey(path) ? [
        path
    ] : $ba34d1ebd6528b77$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $ba34d1ebd6528b77$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($ba34d1ebd6528b77$var$isObject(childObject) && $ba34d1ebd6528b77$var$isEmptyObject(childObject) || Array.isArray(childObject) && $ba34d1ebd6528b77$var$isEmptyArray(childObject))) $ba34d1ebd6528b77$var$unset(object, paths.slice(0, -1));
    return object;
}
var $ba34d1ebd6528b77$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$310131896651d559(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(control._getFieldArray(name).map($ba34d1ebd6528b77$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $ba34d1ebd6528b77$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($ba34d1ebd6528b77$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $ba34d1ebd6528b77$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $ba34d1ebd6528b77$var$appendAt(ids.current, appendValue.map($ba34d1ebd6528b77$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$appendAt, {
            argA: $ba34d1ebd6528b77$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $ba34d1ebd6528b77$var$getFocusFieldName(name, 0, options);
        ids.current = $ba34d1ebd6528b77$var$prependAt(ids.current, prependValue.map($ba34d1ebd6528b77$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$prependAt, {
            argA: $ba34d1ebd6528b77$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $ba34d1ebd6528b77$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $ba34d1ebd6528b77$var$getFocusFieldName(name, index, options);
        ids.current = $ba34d1ebd6528b77$var$insert(ids.current, index, insertValue.map($ba34d1ebd6528b77$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$insert, {
            argA: index,
            argB: $ba34d1ebd6528b77$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ba34d1ebd6528b77$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $ba34d1ebd6528b77$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ba34d1ebd6528b77$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $ba34d1ebd6528b77$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $ba34d1ebd6528b77$var$cloneObject(value1);
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $ba34d1ebd6528b77$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($ba34d1ebd6528b77$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        control._state.action = false;
        $ba34d1ebd6528b77$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$ba34d1ebd6528b77$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $ba34d1ebd6528b77$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $ba34d1ebd6528b77$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($ba34d1ebd6528b77$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $ba34d1ebd6528b77$var$getValidationModes(control._options.mode).isOnSubmit)) $ba34d1ebd6528b77$var$validateField(field, control._formValues, control._options.criteriaMode === $ba34d1ebd6528b77$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$ba34d1ebd6528b77$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $ba34d1ebd6528b77$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $ba34d1ebd6528b77$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        !$ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $ba34d1ebd6528b77$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $ba34d1ebd6528b77$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $ba34d1ebd6528b77$var$isPrimitive = (value1)=>$ba34d1ebd6528b77$var$isNullOrUndefined(value1) || !$ba34d1ebd6528b77$var$isObjectType(value1);
function $ba34d1ebd6528b77$var$deepEqual(object1, object2) {
    if ($ba34d1ebd6528b77$var$isPrimitive(object1) || $ba34d1ebd6528b77$var$isPrimitive(object2)) return object1 === object2;
    if ($ba34d1ebd6528b77$var$isDateObject(object1) && $ba34d1ebd6528b77$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($ba34d1ebd6528b77$var$isDateObject(val1) && $ba34d1ebd6528b77$var$isDateObject(val2) || $ba34d1ebd6528b77$var$isObject(val1) && $ba34d1ebd6528b77$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$ba34d1ebd6528b77$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $ba34d1ebd6528b77$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $ba34d1ebd6528b77$var$isRadioOrCheckbox = (ref)=>$ba34d1ebd6528b77$var$isRadioInput(ref) || $ba34d1ebd6528b77$var$isCheckBoxInput(ref);
var $ba34d1ebd6528b77$var$live = (ref)=>$ba34d1ebd6528b77$var$isHTMLElement(ref) && ref.isConnected;
var $ba34d1ebd6528b77$var$objectHasTruthyValue = (value1)=>$ba34d1ebd6528b77$var$isObject(value1) && Object.values(value1).some((val)=>val);
var $ba34d1ebd6528b77$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($ba34d1ebd6528b77$var$isFunction(data[key])) return true;
    }
    return false;
};
function $ba34d1ebd6528b77$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($ba34d1ebd6528b77$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $ba34d1ebd6528b77$var$isObject(data[key]) && !$ba34d1ebd6528b77$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $ba34d1ebd6528b77$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$ba34d1ebd6528b77$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $ba34d1ebd6528b77$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($ba34d1ebd6528b77$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $ba34d1ebd6528b77$var$isObject(data[key]) && !$ba34d1ebd6528b77$var$objectHasFunction(data[key])) {
            if ($ba34d1ebd6528b77$var$isUndefined(formValues) || $ba34d1ebd6528b77$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $ba34d1ebd6528b77$var$markFieldsDirty(data[key], []) : {
                ...$ba34d1ebd6528b77$var$markFieldsDirty(data[key])
            };
            else $ba34d1ebd6528b77$var$getDirtyFieldsFromDefaultValues(data[key], $ba34d1ebd6528b77$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$ba34d1ebd6528b77$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $ba34d1ebd6528b77$var$getDirtyFields = (defaultValues, formValues)=>$ba34d1ebd6528b77$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $ba34d1ebd6528b77$var$markFieldsDirty(formValues));
var $ba34d1ebd6528b77$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$ba34d1ebd6528b77$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $ba34d1ebd6528b77$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $ba34d1ebd6528b77$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($ba34d1ebd6528b77$var$isFileInput(ref)) return ref.files;
    if ($ba34d1ebd6528b77$var$isRadioInput(ref)) return $ba34d1ebd6528b77$var$getRadioValue(_f.refs).value;
    if ($ba34d1ebd6528b77$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($ba34d1ebd6528b77$var$isCheckBoxInput(ref)) return $ba34d1ebd6528b77$var$getCheckboxValue(_f.refs).value;
    return $ba34d1ebd6528b77$var$getFieldValueAs($ba34d1ebd6528b77$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $ba34d1ebd6528b77$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        field && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $ba34d1ebd6528b77$var$getRuleValue = (rule)=>$ba34d1ebd6528b77$var$isUndefined(rule) ? rule : $ba34d1ebd6528b77$var$isRegex(rule) ? rule.source : $ba34d1ebd6528b77$var$isObject(rule) ? $ba34d1ebd6528b77$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $ba34d1ebd6528b77$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $ba34d1ebd6528b77$var$schemaErrorLookup(errors, _fields, name) {
    const error = $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name);
    if (error || $ba34d1ebd6528b77$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $ba34d1ebd6528b77$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $ba34d1ebd6528b77$var$unsetEmptyArray = (ref, name)=>!$ba34d1ebd6528b77$var$compact($ba34d1ebd6528b77$export$3988ae62b71be9a3(ref, name)).length && $ba34d1ebd6528b77$var$unset(ref, name);
const $ba34d1ebd6528b77$var$defaultOptions = {
    mode: $ba34d1ebd6528b77$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $ba34d1ebd6528b77$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $ba34d1ebd6528b77$var$createFormControl(props = {}) {
    let _options = {
        ...$ba34d1ebd6528b77$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $ba34d1ebd6528b77$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $ba34d1ebd6528b77$var$isObject(_options.defaultValues) || $ba34d1ebd6528b77$var$isObject(_options.values) ? $ba34d1ebd6528b77$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $ba34d1ebd6528b77$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $ba34d1ebd6528b77$var$createSubject(),
        array: $ba34d1ebd6528b77$var$createSubject(),
        state: $ba34d1ebd6528b77$var$createSubject()
    };
    const validationModeBeforeSubmit = $ba34d1ebd6528b77$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $ba34d1ebd6528b77$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $ba34d1ebd6528b77$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $ba34d1ebd6528b77$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (isValidating, names)=>{
        if (!(_proxyFormState.isValidating || _proxyFormState.validatingFields)) return;
        names.forEach((name)=>{
            $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating);
        });
        _formState.isValidating = $ba34d1ebd6528b77$var$objectHasTruthyValue(_formState.validatingFields);
        _subjects.state.next({
            validatingFields: _formState.validatingFields,
            isValidating: _formState.isValidating
        });
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $ba34d1ebd6528b77$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, name, $ba34d1ebd6528b77$var$isUndefined(value1) ? $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $ba34d1ebd6528b77$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $ba34d1ebd6528b77$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        const disabledField = !!($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name) && $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || $ba34d1ebd6528b77$var$deepEqual($ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? $ba34d1ebd6528b77$var$unset(_formState.dirtyFields, name) : $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $ba34d1ebd6528b77$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ba34d1ebd6528b77$var$unset(_formState.errors, name);
        }
        if ((error ? !$ba34d1ebd6528b77$var$deepEqual(previousFieldError, error) : previousFieldError) || !$ba34d1ebd6528b77$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $ba34d1ebd6528b77$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false, Object.keys(_formState.validatingFields).filter((key)=>key === name));
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $ba34d1ebd6528b77$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name);
            error ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ba34d1ebd6528b77$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $ba34d1ebd6528b77$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($ba34d1ebd6528b77$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $ba34d1ebd6528b77$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $ba34d1ebd6528b77$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$ba34d1ebd6528b77$var$live(ref)) : !$ba34d1ebd6528b77$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, data), !$ba34d1ebd6528b77$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$ba34d1ebd6528b77$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $ba34d1ebd6528b77$var$isUndefined(defaultValue) ? _defaultValues : $ba34d1ebd6528b77$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$ba34d1ebd6528b77$var$compact($ba34d1ebd6528b77$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, $ba34d1ebd6528b77$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $ba34d1ebd6528b77$var$isHTMLElement(fieldReference.ref) && $ba34d1ebd6528b77$var$isNullOrUndefined(value1) ? '' : value1;
                if ($ba34d1ebd6528b77$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($ba34d1ebd6528b77$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($ba34d1ebd6528b77$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$ba34d1ebd6528b77$var$isPrimitive(fieldValue) || field && !field._f) && !$ba34d1ebd6528b77$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $ba34d1ebd6528b77$var$cloneObject(value1);
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$ba34d1ebd6528b77$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $ba34d1ebd6528b77$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $ba34d1ebd6528b77$var$getFieldValue(field._f) : $ba34d1ebd6528b77$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $ba34d1ebd6528b77$var$EVENTS.BLUR || event.type === $ba34d1ebd6528b77$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$ba34d1ebd6528b77$var$hasValidation(field._f) && !_options.resolver && !$ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $ba34d1ebd6528b77$var$skipValidation(isBlurEvent, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $ba34d1ebd6528b77$var$isWatched(name, _names, isBlurEvent);
            $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$ba34d1ebd6528b77$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true, [
                name
            ]);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $ba34d1ebd6528b77$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $ba34d1ebd6528b77$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $ba34d1ebd6528b77$var$isEmptyObject(errors);
                }
            } else {
                error = (await $ba34d1ebd6528b77$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $ba34d1ebd6528b77$var$convertToArrayPayload(name);
        _updateIsValidating(true, fieldNames);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($ba34d1ebd6528b77$var$isUndefined(name) ? name : fieldNames);
            isValid = $ba34d1ebd6528b77$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$ba34d1ebd6528b77$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $ba34d1ebd6528b77$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $ba34d1ebd6528b77$var$isUndefined(fieldNames) ? values : $ba34d1ebd6528b77$var$isString(fieldNames) ? $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$ba34d1ebd6528b77$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            isValidating: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).validatingFields, name),
            error: $ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $ba34d1ebd6528b77$var$convertToArrayPayload(name).forEach((inputName)=>$ba34d1ebd6528b77$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$ba34d1ebd6528b77$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $ba34d1ebd6528b77$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $ba34d1ebd6528b77$var$unset(_fields, fieldName);
                $ba34d1ebd6528b77$var$unset(_formValues, fieldName);
            }
            !options.keepError && $ba34d1ebd6528b77$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $ba34d1ebd6528b77$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $ba34d1ebd6528b77$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $ba34d1ebd6528b77$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $ba34d1ebd6528b77$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($ba34d1ebd6528b77$var$isBoolean(disabled)) {
            const inputValue = disabled ? undefined : $ba34d1ebd6528b77$var$isUndefined(value1) ? $ba34d1ebd6528b77$var$getFieldValue(field ? field._f : $ba34d1ebd6528b77$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $ba34d1ebd6528b77$var$isBoolean(options.disabled);
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $ba34d1ebd6528b77$var$getRuleValue(options.min),
                max: $ba34d1ebd6528b77$var$getRuleValue(options.max),
                minLength: $ba34d1ebd6528b77$var$getRuleValue(options.minLength),
                maxLength: $ba34d1ebd6528b77$var$getRuleValue(options.maxLength),
                pattern: $ba34d1ebd6528b77$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $ba34d1ebd6528b77$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $ba34d1ebd6528b77$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($ba34d1ebd6528b77$var$live),
                                    fieldRef,
                                    ...Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($ba34d1ebd6528b77$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $ba34d1ebd6528b77$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($ba34d1ebd6528b77$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $ba34d1ebd6528b77$var$iterateFieldsByAction(_fields, (ref, name)=>{
                let requiredDisabledState = disabled;
                const currentField = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
                if (currentField && $ba34d1ebd6528b77$var$isBoolean(currentField._f.disabled)) requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $ba34d1ebd6528b77$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $ba34d1ebd6528b77$var$unset(_formState.errors, 'root');
            if ($ba34d1ebd6528b77$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $ba34d1ebd6528b77$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name)) {
            if ($ba34d1ebd6528b77$var$isUndefined(options.defaultValue)) setValue(name, $ba34d1ebd6528b77$var$cloneObject($ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_defaultValues, name, $ba34d1ebd6528b77$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $ba34d1ebd6528b77$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $ba34d1ebd6528b77$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $ba34d1ebd6528b77$var$cloneObject($ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $ba34d1ebd6528b77$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $ba34d1ebd6528b77$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $ba34d1ebd6528b77$var$cloneObject(updatedValues);
        const isEmptyResetValues = $ba34d1ebd6528b77$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)$ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(values, fieldName, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($ba34d1ebd6528b77$var$isWeb && $ba34d1ebd6528b77$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($ba34d1ebd6528b77$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $ba34d1ebd6528b77$var$cloneObject(_defaultValues) : {} : $ba34d1ebd6528b77$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$ba34d1ebd6528b77$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? [] : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($ba34d1ebd6528b77$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$ba34d1ebd6528b77$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $ba34d1ebd6528b77$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $ba34d1ebd6528b77$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$ba34d1ebd6528b77$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $ba34d1ebd6528b77$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($ba34d1ebd6528b77$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if (props.values && !$ba34d1ebd6528b77$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = $ba34d1ebd6528b77$var$getProxyFormState(formState, control);
    return _formControl.current;
}


'use strict';
function $b4293b0eb4c07151$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $4457f145f4fd6a49$var$toString } = Object.prototype;
const { getPrototypeOf: $4457f145f4fd6a49$var$getPrototypeOf } = Object;
const $4457f145f4fd6a49$var$kindOf = ((cache)=>(thing)=>{
        const str = $4457f145f4fd6a49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4457f145f4fd6a49$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4457f145f4fd6a49$var$kindOf(thing) === type;
};
const $4457f145f4fd6a49$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4457f145f4fd6a49$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4457f145f4fd6a49$var$isUndefined = $4457f145f4fd6a49$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4457f145f4fd6a49$var$isBuffer(val) {
    return val !== null && !$4457f145f4fd6a49$var$isUndefined(val) && val.constructor !== null && !$4457f145f4fd6a49$var$isUndefined(val.constructor) && $4457f145f4fd6a49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4457f145f4fd6a49$var$isArrayBuffer = $4457f145f4fd6a49$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4457f145f4fd6a49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4457f145f4fd6a49$var$isString = $4457f145f4fd6a49$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4457f145f4fd6a49$var$isFunction = $4457f145f4fd6a49$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4457f145f4fd6a49$var$isNumber = $4457f145f4fd6a49$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4457f145f4fd6a49$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4457f145f4fd6a49$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4457f145f4fd6a49$var$isPlainObject = (val)=>{
    if ($4457f145f4fd6a49$var$kindOf(val) !== 'object') return false;
    const prototype = $4457f145f4fd6a49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4457f145f4fd6a49$var$isDate = $4457f145f4fd6a49$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFile = $4457f145f4fd6a49$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4457f145f4fd6a49$var$isBlob = $4457f145f4fd6a49$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFileList = $4457f145f4fd6a49$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4457f145f4fd6a49$var$isStream = (val)=>$4457f145f4fd6a49$var$isObject(val) && $4457f145f4fd6a49$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $4457f145f4fd6a49$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $4457f145f4fd6a49$var$isFunction(thing.append) && ((kind = $4457f145f4fd6a49$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $4457f145f4fd6a49$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4457f145f4fd6a49$var$isURLSearchParams = $4457f145f4fd6a49$var$kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4457f145f4fd6a49$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4457f145f4fd6a49$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4457f145f4fd6a49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4457f145f4fd6a49$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4457f145f4fd6a49$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $4457f145f4fd6a49$var$isContextDefined = (context)=>!$4457f145f4fd6a49$var$isUndefined(context) && context !== $4457f145f4fd6a49$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4457f145f4fd6a49$var$merge() {
    const { caseless: caseless } = $4457f145f4fd6a49$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $4457f145f4fd6a49$var$findKey(result, key) || key;
        if ($4457f145f4fd6a49$var$isPlainObject(result[targetKey]) && $4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge(result[targetKey], val);
        else if ($4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge({}, val);
        else if ($4457f145f4fd6a49$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $4457f145f4fd6a49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4457f145f4fd6a49$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4457f145f4fd6a49$var$forEach(b, (val, key)=>{
        if (thisArg && $4457f145f4fd6a49$var$isFunction(val)) a[key] = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4457f145f4fd6a49$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4457f145f4fd6a49$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4457f145f4fd6a49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4457f145f4fd6a49$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4457f145f4fd6a49$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4457f145f4fd6a49$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4457f145f4fd6a49$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4457f145f4fd6a49$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $4457f145f4fd6a49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4457f145f4fd6a49$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4457f145f4fd6a49$var$isHTMLForm = $4457f145f4fd6a49$var$kindOfTest('HTMLFormElement');
const $4457f145f4fd6a49$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $4457f145f4fd6a49$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4457f145f4fd6a49$var$isRegExp = $4457f145f4fd6a49$var$kindOfTest('RegExp');
const $4457f145f4fd6a49$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4457f145f4fd6a49$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4457f145f4fd6a49$var$freezeMethods = (obj)=>{
    $4457f145f4fd6a49$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4457f145f4fd6a49$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$4457f145f4fd6a49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $4457f145f4fd6a49$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4457f145f4fd6a49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4457f145f4fd6a49$var$noop = ()=>{};
const $4457f145f4fd6a49$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $4457f145f4fd6a49$var$ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const $4457f145f4fd6a49$var$DIGIT = '0123456789';
const $4457f145f4fd6a49$var$ALPHABET = {
    DIGIT: $4457f145f4fd6a49$var$DIGIT,
    ALPHA: $4457f145f4fd6a49$var$ALPHA,
    ALPHA_DIGIT: $4457f145f4fd6a49$var$ALPHA + $4457f145f4fd6a49$var$ALPHA.toUpperCase() + $4457f145f4fd6a49$var$DIGIT
};
const $4457f145f4fd6a49$var$generateString = (size = 16, alphabet = $4457f145f4fd6a49$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = '';
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4457f145f4fd6a49$var$isSpecCompliantForm(thing) {
    return !!(thing && $4457f145f4fd6a49$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $4457f145f4fd6a49$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($4457f145f4fd6a49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $4457f145f4fd6a49$var$isArray(source) ? [] : {};
                $4457f145f4fd6a49$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$4457f145f4fd6a49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $4457f145f4fd6a49$var$isAsyncFn = $4457f145f4fd6a49$var$kindOfTest('AsyncFunction');
const $4457f145f4fd6a49$var$isThenable = (thing)=>thing && ($4457f145f4fd6a49$var$isObject(thing) || $4457f145f4fd6a49$var$isFunction(thing)) && $4457f145f4fd6a49$var$isFunction(thing.then) && $4457f145f4fd6a49$var$isFunction(thing.catch);
var $4457f145f4fd6a49$export$2e2bcd8739ae039 = {
    isArray: $4457f145f4fd6a49$var$isArray,
    isArrayBuffer: $4457f145f4fd6a49$var$isArrayBuffer,
    isBuffer: $4457f145f4fd6a49$var$isBuffer,
    isFormData: $4457f145f4fd6a49$var$isFormData,
    isArrayBufferView: $4457f145f4fd6a49$var$isArrayBufferView,
    isString: $4457f145f4fd6a49$var$isString,
    isNumber: $4457f145f4fd6a49$var$isNumber,
    isBoolean: $4457f145f4fd6a49$var$isBoolean,
    isObject: $4457f145f4fd6a49$var$isObject,
    isPlainObject: $4457f145f4fd6a49$var$isPlainObject,
    isUndefined: $4457f145f4fd6a49$var$isUndefined,
    isDate: $4457f145f4fd6a49$var$isDate,
    isFile: $4457f145f4fd6a49$var$isFile,
    isBlob: $4457f145f4fd6a49$var$isBlob,
    isRegExp: $4457f145f4fd6a49$var$isRegExp,
    isFunction: $4457f145f4fd6a49$var$isFunction,
    isStream: $4457f145f4fd6a49$var$isStream,
    isURLSearchParams: $4457f145f4fd6a49$var$isURLSearchParams,
    isTypedArray: $4457f145f4fd6a49$var$isTypedArray,
    isFileList: $4457f145f4fd6a49$var$isFileList,
    forEach: $4457f145f4fd6a49$var$forEach,
    merge: $4457f145f4fd6a49$var$merge,
    extend: $4457f145f4fd6a49$var$extend,
    trim: $4457f145f4fd6a49$var$trim,
    stripBOM: $4457f145f4fd6a49$var$stripBOM,
    inherits: $4457f145f4fd6a49$var$inherits,
    toFlatObject: $4457f145f4fd6a49$var$toFlatObject,
    kindOf: $4457f145f4fd6a49$var$kindOf,
    kindOfTest: $4457f145f4fd6a49$var$kindOfTest,
    endsWith: $4457f145f4fd6a49$var$endsWith,
    toArray: $4457f145f4fd6a49$var$toArray,
    forEachEntry: $4457f145f4fd6a49$var$forEachEntry,
    matchAll: $4457f145f4fd6a49$var$matchAll,
    isHTMLForm: $4457f145f4fd6a49$var$isHTMLForm,
    hasOwnProperty: $4457f145f4fd6a49$var$hasOwnProperty,
    hasOwnProp: $4457f145f4fd6a49$var$hasOwnProperty,
    reduceDescriptors: $4457f145f4fd6a49$var$reduceDescriptors,
    freezeMethods: $4457f145f4fd6a49$var$freezeMethods,
    toObjectSet: $4457f145f4fd6a49$var$toObjectSet,
    toCamelCase: $4457f145f4fd6a49$var$toCamelCase,
    noop: $4457f145f4fd6a49$var$noop,
    toFiniteNumber: $4457f145f4fd6a49$var$toFiniteNumber,
    findKey: $4457f145f4fd6a49$var$findKey,
    global: $4457f145f4fd6a49$var$_global,
    isContextDefined: $4457f145f4fd6a49$var$isContextDefined,
    ALPHABET: $4457f145f4fd6a49$var$ALPHABET,
    generateString: $4457f145f4fd6a49$var$generateString,
    isSpecCompliantForm: $4457f145f4fd6a49$var$isSpecCompliantForm,
    toJSONObject: $4457f145f4fd6a49$var$toJSONObject,
    isAsyncFn: $4457f145f4fd6a49$var$isAsyncFn,
    isThenable: $4457f145f4fd6a49$var$isThenable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ed5f7e2522a0b703$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($ed5f7e2522a0b703$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $ed5f7e2522a0b703$var$prototype = $ed5f7e2522a0b703$var$AxiosError.prototype;
const $ed5f7e2522a0b703$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $ed5f7e2522a0b703$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ed5f7e2522a0b703$var$AxiosError, $ed5f7e2522a0b703$var$descriptors);
Object.defineProperty($ed5f7e2522a0b703$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$ed5f7e2522a0b703$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($ed5f7e2522a0b703$var$prototype);
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $ed5f7e2522a0b703$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ed5f7e2522a0b703$export$2e2bcd8739ae039 = $ed5f7e2522a0b703$var$AxiosError;


// eslint-disable-next-line strict
var $1b5ae82d1edb0249$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
'use strict';
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
'use strict';
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup['-'.charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup['_'.charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $c114c26e12685207$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
const $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    let buf = $c114c26e12685207$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    const buf = $c114c26e12685207$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        const len = $c114c26e12685207$var$checked(obj.length) | 0;
        const buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) buf = $c114c26e12685207$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case 'ascii':
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case 'base64':
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf);
    else return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c114c26e12685207$var$Buffer.prototype.readBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c114c26e12685207$var$Buffer.prototype.readBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c114c26e12685207$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$c114c26e12685207$var$Buffer.prototype.writeBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c114c26e12685207$var$errors = {};
function $c114c26e12685207$var$E(sym, getMessage, Base) {
    $c114c26e12685207$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$c114c26e12685207$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$c114c26e12685207$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c114c26e12685207$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c114c26e12685207$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c114c26e12685207$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c114c26e12685207$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c114c26e12685207$var$checkBounds(buf, offset, byteLength) {
    $c114c26e12685207$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c114c26e12685207$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $c114c26e12685207$var$checkBounds(buf, offset, byteLength);
}
function $c114c26e12685207$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $c114c26e12685207$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $c114c26e12685207$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c114c26e12685207$var$validateNumber(value, type);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $c114c26e12685207$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $5a7d4ee62d502cb1$export$d622b2ad8d90c771($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c114c26e12685207$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c114c26e12685207$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $c114c26e12685207$var$BufferBigIntNotDefined : fn;
}
function $c114c26e12685207$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $5dbdf283f7ef4044$require$Buffer = $c114c26e12685207$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isVisitable(thing) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5dbdf283f7ef4044$var$removeBrackets(key) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5dbdf283f7ef4044$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5dbdf283f7ef4044$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isFlatArray(arr) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(arr) && !arr.some($5dbdf283f7ef4044$var$isVisitable);
}
const $5dbdf283f7ef4044$var$predicates = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject((0, $4457f145f4fd6a49$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5dbdf283f7ef4044$var$toFormData(obj, formData, options) {
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $1b5ae82d1edb0249$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $5dbdf283f7ef4044$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) && $5dbdf283f7ef4044$var$isFlatArray(value) || ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5dbdf283f7ef4044$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5dbdf283f7ef4044$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($5dbdf283f7ef4044$var$isVisitable(value)) return true;
        formData.append($5dbdf283f7ef4044$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($5dbdf283f7ef4044$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5dbdf283f7ef4044$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $5dbdf283f7ef4044$export$2e2bcd8739ae039 = $5dbdf283f7ef4044$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $23a6a9f2f50fe381$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $23a6a9f2f50fe381$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(params, this, options);
}
const $23a6a9f2f50fe381$var$prototype = $23a6a9f2f50fe381$var$AxiosURLSearchParams.prototype;
$23a6a9f2f50fe381$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$23a6a9f2f50fe381$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $23a6a9f2f50fe381$var$encode);
    } : $23a6a9f2f50fe381$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $23a6a9f2f50fe381$export$2e2bcd8739ae039 = $23a6a9f2f50fe381$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $12c2c95c1ed3c980$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $12c2c95c1ed3c980$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $12c2c95c1ed3c980$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $ca291930ae00924d$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $ca291930ae00924d$export$2e2bcd8739ae039 = $ca291930ae00924d$var$InterceptorManager;





'use strict';
var $796c18463ea25502$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $a084e346ccf1414e$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039);


'use strict';
var $4d02f3c5e9d23987$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $7320e56e0494b653$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $933095d2c2007f0e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a084e346ccf1414e$export$2e2bcd8739ae039,
        FormData: $4d02f3c5e9d23987$export$2e2bcd8739ae039,
        Blob: $7320e56e0494b653$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $e7f6cfbce8ef57c2$exports = {};

$parcel$export($e7f6cfbce8ef57c2$exports, "hasBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c0bcc9250309d66; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserWebWorkerEnv", function () { return $e7f6cfbce8ef57c2$export$c81692cf5af97dac; });
const $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e7f6cfbce8ef57c2$export$c0bcc9250309d66 = ((product)=>{
    return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && [
        'ReactNative',
        'NativeScript',
        'NS'
    ].indexOf(product) < 0;
})(typeof navigator !== 'undefined' && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e7f6cfbce8ef57c2$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();


var $7bb33b7264aaaf86$export$2e2bcd8739ae039 = {
    ...$e7f6cfbce8ef57c2$exports,
    ...(0, $933095d2c2007f0e$export$2e2bcd8739ae039)
};


'use strict';
function $c6537084d1761b1c$export$2e2bcd8739ae039(data, options) {
    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(data, new (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).isNode && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a91febb88049dece$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a91febb88049dece$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a91febb88049dece$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a91febb88049dece$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(formData) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a91febb88049dece$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a91febb88049dece$export$2e2bcd8739ae039 = $a91febb88049dece$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f671d6c34fc96548$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f671d6c34fc96548$var$defaults = {
    transitional: (0, $796c18463ea25502$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $a91febb88049dece$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isStream(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFile(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $c6537084d1761b1c$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $f671d6c34fc96548$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f671d6c34fc96548$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if (data && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).from(e, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $f671d6c34fc96548$var$defaults.headers[method] = {};
});
var $f671d6c34fc96548$export$2e2bcd8739ae039 = $f671d6c34fc96548$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $993ca9e2d6767cd4$var$ignoreDuplicateOf = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $993ca9e2d6767cd4$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $993ca9e2d6767cd4$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $97723c9940354b38$var$$internals = Symbol('internals');
function $97723c9940354b38$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $97723c9940354b38$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.map($97723c9940354b38$var$normalizeValue) : String(value);
}
function $97723c9940354b38$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $97723c9940354b38$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $97723c9940354b38$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $97723c9940354b38$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $97723c9940354b38$var$buildAccessors(obj, header) {
    const accessorName = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $97723c9940354b38$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $97723c9940354b38$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$97723c9940354b38$var$isValidHeaderName(header)) setHeaders((0, $993ca9e2d6767cd4$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $97723c9940354b38$var$parseTokens(value);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $97723c9940354b38$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $97723c9940354b38$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $97723c9940354b38$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $97723c9940354b38$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $97723c9940354b38$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$97723c9940354b38$var$$internals] = this[$97723c9940354b38$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $97723c9940354b38$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$97723c9940354b38$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).reduceDescriptors($97723c9940354b38$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).freezeMethods($97723c9940354b38$var$AxiosHeaders);
var $97723c9940354b38$export$2e2bcd8739ae039 = $97723c9940354b38$var$AxiosHeaders;


'use strict';
function $2b2db412c73efddc$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $f671d6c34fc96548$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5f032fd5b915e863$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $844e24f044f60b67$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($844e24f044f60b67$var$CanceledError, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $844e24f044f60b67$export$2e2bcd8739ae039 = $844e24f044f60b67$var$CanceledError;







'use strict';
function $b1fb368c37c1823a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $8292dca2fe19e2c0$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $de0137e96012432b$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $4226547004fa4063$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $55a6f18683d9f888$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $de0137e96012432b$export$2e2bcd8739ae039)(requestedURL)) return (0, $4226547004fa4063$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
var $2d50534f56617a3d$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





'use strict';
function $9a3acc13c385c3d9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3fe2722b85f27cc8$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3fe2722b85f27cc8$export$2e2bcd8739ae039 = $3fe2722b85f27cc8$var$speedometer;


'use strict';
function $089238041fc30567$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $3fe2722b85f27cc8$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? 'download' : 'upload'] = true;
        listener(data);
    };
}
const $089238041fc30567$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $089238041fc30567$export$2e2bcd8739ae039 = $089238041fc30567$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        let contentType;
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || 'multipart/form-data',
                    ...tokens
                ].join('; '));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || '';
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
        }
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $b1fb368c37c1823a$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Request aborted', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Network Error', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = config.transitional || (0, $796c18463ea25502$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $2d50534f56617a3d$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $8292dca2fe19e2c0$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', $089238041fc30567$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', $089238041fc30567$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $9a3acc13c385c3d9$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $f311d0388b14bc21$var$knownAdapters = {
    http: (0, $1b5ae82d1edb0249$export$2e2bcd8739ae039),
    xhr: (0, $089238041fc30567$export$2e2bcd8739ae039)
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach($f311d0388b14bc21$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $f311d0388b14bc21$var$renderReason = (reason)=>`- ${reason}`;
const $f311d0388b14bc21$var$isResolvedHandle = (adapter)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $f311d0388b14bc21$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f311d0388b14bc21$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f311d0388b14bc21$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($f311d0388b14bc21$var$renderReason).join('\n') : ' ' + $f311d0388b14bc21$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $f311d0388b14bc21$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1ba4fe270146b4e2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config);
}
function $1ba4fe270146b4e2$export$2e2bcd8739ae039(config) {
    $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
    config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $f671d6c34fc96548$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5f032fd5b915e863$export$2e2bcd8739ae039)(reason)) {
            $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




'use strict';
const $142febf2fa493ec7$var$headersToObject = (thing)=>thing instanceof (0, $97723c9940354b38$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $142febf2fa493ec7$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($142febf2fa493ec7$var$headersToObject(a), $142febf2fa493ec7$var$headersToObject(b), true)
    };
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $0c953052fb93d857$export$a4ad2735b021c132 = "1.6.7";



'use strict';
const $153d7c57f809624c$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $153d7c57f809624c$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $153d7c57f809624c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $153d7c57f809624c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $0c953052fb93d857$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$153d7c57f809624c$var$deprecatedWarnings[opt]) {
            $153d7c57f809624c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $153d7c57f809624c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('options must be an object', (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $153d7c57f809624c$export$2e2bcd8739ae039 = {
    assertOptions: $153d7c57f809624c$var$assertOptions,
    validators: $153d7c57f809624c$var$validators
};



'use strict';
const $d31ac3bc8d454bec$var$validators = (0, $153d7c57f809624c$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $d31ac3bc8d454bec$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)(),
            response: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            forcedJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            clarifyTimeoutError: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $d31ac3bc8d454bec$var$validators.function,
                serialize: $d31ac3bc8d454bec$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $d31ac3bc8d454bec$var$Axios.prototype[method] = generateHTTPMethod();
    $d31ac3bc8d454bec$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $d31ac3bc8d454bec$export$2e2bcd8739ae039 = $d31ac3bc8d454bec$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c9dbae5aa50ec7c7$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c9dbae5aa50ec7c7$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $c9dbae5aa50ec7c7$export$2e2bcd8739ae039 = $c9dbae5aa50ec7c7$var$CancelToken;






'use strict';
function $cbed9dfdab194748$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $48132dea419dd2c0$export$2e2bcd8739ae039(payload) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $9f6607e590634381$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($9f6607e590634381$var$HttpStatusCode).forEach(([key, value])=>{
    $9f6607e590634381$var$HttpStatusCode[value] = key;
});
var $9f6607e590634381$export$2e2bcd8739ae039 = $9f6607e590634381$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c9a85f19e57c70f8$var$createInstance(defaultConfig) {
    const context = new (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)((0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c9a85f19e57c70f8$var$createInstance((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c9a85f19e57c70f8$var$axios = $c9a85f19e57c70f8$var$createInstance((0, $f671d6c34fc96548$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c9a85f19e57c70f8$var$axios.Axios = (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c9a85f19e57c70f8$var$axios.CanceledError = (0, $844e24f044f60b67$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.CancelToken = (0, $c9dbae5aa50ec7c7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.isCancel = (0, $5f032fd5b915e863$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.VERSION = (0, $0c953052fb93d857$export$a4ad2735b021c132);
$c9a85f19e57c70f8$var$axios.toFormData = (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039);
// Expose AxiosError class
$c9a85f19e57c70f8$var$axios.AxiosError = (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c9a85f19e57c70f8$var$axios.Cancel = $c9a85f19e57c70f8$var$axios.CanceledError;
// Expose all/spread
$c9a85f19e57c70f8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c9a85f19e57c70f8$var$axios.spread = (0, $cbed9dfdab194748$export$2e2bcd8739ae039);
// Expose isAxiosError
$c9a85f19e57c70f8$var$axios.isAxiosError = (0, $48132dea419dd2c0$export$2e2bcd8739ae039);
// Expose mergeConfig
$c9a85f19e57c70f8$var$axios.mergeConfig = (0, $142febf2fa493ec7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.AxiosHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.formToJSON = (thing)=>(0, $a91febb88049dece$export$2e2bcd8739ae039)((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c9a85f19e57c70f8$var$axios.getAdapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter;
$c9a85f19e57c70f8$var$axios.HttpStatusCode = (0, $9f6607e590634381$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.default = $c9a85f19e57c70f8$var$axios;
var // this module should only have a default export
$c9a85f19e57c70f8$export$2e2bcd8739ae039 = $c9a85f19e57c70f8$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $18d826a12788a23d$export$1c00760e9e5a4e95, AxiosError: $18d826a12788a23d$export$c1fbed17c2f6a328, CanceledError: $18d826a12788a23d$export$1ab0c6b20d94fa14, isCancel: $18d826a12788a23d$export$3b22524397b493c6, CancelToken: $18d826a12788a23d$export$fd08e3cb425f0d61, VERSION: $18d826a12788a23d$export$a4ad2735b021c132, all: $18d826a12788a23d$export$84bf76cd7afc7469, Cancel: $18d826a12788a23d$export$848c9b7ead0df967, isAxiosError: $18d826a12788a23d$export$fbafdbe06a5b5a9a, spread: $18d826a12788a23d$export$3ae0fd4797ed47c8, toFormData: $18d826a12788a23d$export$10ae0d317ea97f8b, AxiosHeaders: $18d826a12788a23d$export$4e7d6ff0f3e6520, HttpStatusCode: $18d826a12788a23d$export$a972f69c851492b3, formToJSON: $18d826a12788a23d$export$86d7c59254d6a2c9, getAdapter: $18d826a12788a23d$export$17ddc20a97d669e2, mergeConfig: $18d826a12788a23d$export$7ec1ebcfa9d8bd6a } = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039);


const $4a0bba175813fd04$var$token = "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";
const $4a0bba175813fd04$var$autocompleteMockData = {
    products: []
};
function $4a0bba175813fd04$export$2e2bcd8739ae039() {
    const { register: register, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors } } = (0, $ba34d1ebd6528b77$export$87c0cf8eb5a167e0)();
    const [autocompleteData, setAutocompleteData] = (0, $6cds3.useState)();
    const [suggestions, setSuggestions] = (0, $6cds3.useState)([]);
    const [locale, setLocale] = (0, $6cds3.useState)("it");
    (0, $6cds3.useEffect)(()=>{
        const _loc = window?.Shopify?.locale;
        if (_loc) setLocale(_loc);
    }, []);
    const onSubmit = (data)=>{
        console.log(data);
        if (locale === "it") window.location.href = `/search?q=${data.search}`;
        else window.location.href = `/en/search?q=${data.search}`;
    };
    const autocomplete = async (q)=>{
        const response = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).get(`https://gp.bkt.studio/shopify/products`, {
            headers: {
                "X-Shopify-Access-Token": $4a0bba175813fd04$var$token,
                "Content-Type": "application/json"
            }
        }).catch((err)=>{});
        try {
            setAutocompleteData(response.data.products);
        } catch (err) {
            setAutocompleteData($4a0bba175813fd04$var$autocompleteMockData.products);
        }
    };
    const performSearch = (q)=>{
        const _suggestions = [];
        autocompleteData?.filter((p)=>p.status === 'active').forEach((product)=>{
            product.variants.forEach((variant)=>{
                if (variant.sku?.toLowerCase().includes(q.toLowerCase())) _suggestions.push(product);
            });
        });
        setSuggestions(_suggestions);
    };
    (0, $6cds3.useEffect)(()=>{
        const _q = watch("search");
        if (_q?.length > 2) {
            if (!autocompleteData) autocomplete(_q);
            else performSearch(_q);
        } else setSuggestions([]);
    }, [
        watch("search")
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (autocompleteData) performSearch(watch("search"));
    }, [
        autocompleteData
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("form", {
                role: "search",
                method: "get",
                className: "searchform",
                onSubmit: handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                            type: "search",
                            className: "search-field",
                            placeholder: locale === "it" ? "Cerca per Codice Prodotto" : "Search by Product Code",
                            ...register("search", {
                                required: true
                            }),
                            autoComplete: "off",
                            style: {
                                background: "rgba(0,0,0,.7)",
                                borderRadius: 0
                            }
                        }),
                        errors.search && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            children: locale === "it" ? "Questo campo \xe8 obbligatorio" : "This field is required"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            type: "submit",
                            className: "thb-search-submit"
                        })
                    ]
                })
            }),
            suggestions.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                style: {
                    background: "rgba(0,0,0,.7)"
                },
                children: suggestions.map((product)=>{
                    return product.variants.map((variant)=>{
                        if (!variant.sku) return null;
                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            onClick: ()=>{
                                if (locale === "it") window.location.href = `/products/${product.handle}?variant=${variant.id}`;
                                else window.location.href = `/en/products/${product.handle}?variant=${variant.id}`;
                            },
                            style: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "row",
                                    padding: "5px 10px",
                                    borderBottom: "none",
                                    width: "100%",
                                    justifyContent: "space-around"
                                },
                                children: [
                                    product?.image && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                        src: product.image.src,
                                        alt: product.title,
                                        style: {
                                            width: "100px",
                                            marginRight: "10px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                style: {
                                                    marginBottom: 0
                                                },
                                                children: product.title
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                style: {
                                                    marginBottom: 0,
                                                    opacity: 0.8
                                                },
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                                                    children: variant.sku
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                            style: {
                                                marginBottom: 0,
                                                textAlign: "right"
                                            },
                                            children: [
                                                "\u20AC",
                                                variant.price
                                            ]
                                        })
                                    })
                                ]
                            })
                        }, variant.id);
                    });
                })
            })
        ]
    });
}




var $6cds3 = parcelRequire("6cds3");


const $8dfcdff4de2a5aa7$var$token = "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";
const $8dfcdff4de2a5aa7$var$autocompleteMockData = {
    products: []
};
function $8dfcdff4de2a5aa7$export$2e2bcd8739ae039() {
    const { register: register, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors } } = (0, $ba34d1ebd6528b77$export$87c0cf8eb5a167e0)();
    const [autocompleteData, setAutocompleteData] = (0, $6cds3.useState)();
    const [suggestions, setSuggestions] = (0, $6cds3.useState)([]);
    const [locale, setLocale] = (0, $6cds3.useState)("it");
    (0, $6cds3.useEffect)(()=>{
        const _loc = window?.Shopify?.locale;
        if (_loc) setLocale(_loc);
    }, []);
    const onSubmit = (data)=>{
        console.log(data);
        if (locale === "it") window.location.href = `/search?q=${data.search}`;
        else window.location.href = `/en/search?q=${data.search}`;
    };
    const autocomplete = async (q)=>{
        const response = await (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).get(`https://gp.bkt.studio/shopify/products`, {
            headers: {
                "X-Shopify-Access-Token": $8dfcdff4de2a5aa7$var$token,
                "Content-Type": "application/json"
            }
        }).catch((err)=>{});
        try {
            setAutocompleteData(response.data.products);
        } catch (err) {
            setAutocompleteData($8dfcdff4de2a5aa7$var$autocompleteMockData.products);
        }
    };
    const performSearch = (q)=>{
        const _suggestions = [];
        autocompleteData?.filter((p)=>p.status === "active").forEach((product)=>{
            if (product.title?.toLowerCase().includes(q.toLowerCase())) {
                console.log("PRODOTTO", product);
                _suggestions.push(product);
            }
        });
        setSuggestions(_suggestions);
    };
    (0, $6cds3.useEffect)(()=>{
        const _q = watch("search");
        if (_q?.length > 2) {
            if (!autocompleteData) autocomplete(_q);
            else performSearch(_q);
        } else setSuggestions([]);
    }, [
        watch("search")
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (autocompleteData) performSearch(watch("search"));
    }, [
        autocompleteData
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("form", {
                role: "search",
                method: "get",
                className: "searchform",
                onSubmit: handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                            type: "search",
                            className: "search-field",
                            placeholder: locale === "it" ? "Cerca per Nome" : "Search by Name",
                            ...register("search", {
                                required: true
                            }),
                            autoComplete: "off",
                            style: {
                                background: "rgba(0,0,0,.7)",
                                borderRadius: 0
                            }
                        }),
                        errors.search && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            children: locale === "it" ? "Questo campo \xe8 obbligatorio" : "This field is required"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            type: "submit",
                            className: "thb-search-submit",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                    d: "M8.97208 0C4.0309 0 0 4.03029 0 8.97187C0 13.9135 4.03038 17.9437 8.97208 17.9437C11.0258 17.9437 12.9198 17.249 14.4348 16.0808L18.0149 19.6608C18.4672 20.1131 19.209 20.1131 19.6608 19.6608C20.1131 19.2085 20.1131 18.476 19.6608 18.0238L16.0714 14.4438C17.2422 12.9282 17.9436 11.0281 17.9436 8.97187C17.9436 4.0308 13.9138 0 8.97208 0ZM8.97208 2.3152C12.6618 2.3152 15.6284 5.2817 15.6284 8.97135C15.6284 12.661 12.6618 15.6275 8.97208 15.6275C5.28235 15.6275 2.31578 12.661 2.31578 8.97135C2.31578 5.2817 5.28235 2.3152 8.97208 2.3152Z",
                                    fill: "#fff"
                                })
                            })
                        })
                    ]
                })
            }),
            suggestions.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                style: {
                    background: "rgba(0,0,0,.7)"
                },
                children: suggestions.map((product)=>{
                    return product.variants.map((variant)=>{
                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            onClick: ()=>{
                                if (locale === "it") window.location.href = `/products/${product.handle}?variant=${variant.id}`;
                                else window.location.href = `/en/products/${product.handle}?variant=${variant.id}`;
                            },
                            style: {
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "row",
                                    padding: "5px 10px",
                                    borderBottom: "none",
                                    width: "100%",
                                    justifyContent: "space-around"
                                },
                                children: [
                                    product?.image && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                        src: product.image.src,
                                        alt: product.title,
                                        style: {
                                            width: "100px",
                                            marginRight: "10px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                style: {
                                                    marginBottom: 0
                                                },
                                                children: product.title
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                                style: {
                                                    marginBottom: 0,
                                                    opacity: 0.8
                                                },
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                                                    children: variant.sku
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                                            style: {
                                                marginBottom: 0,
                                                textAlign: "right"
                                            },
                                            children: [
                                                "\u20AC",
                                                variant.price
                                            ]
                                        })
                                    })
                                ]
                            })
                        }, variant.id);
                    });
                })
            })
        ]
    });
}




var $6cds3 = parcelRequire("6cds3");



parcelRequire("6cds3");
function $ba60cbdac98c6712$var$Loading() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "30",
        display: "block",
        preserveAspectRatio: "xMidYMid",
        viewBox: "0 0 100 100",
        style: {},
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.9166666666666666s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(30 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.8333333333333334s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(60 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.75s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(90 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.6666666666666666s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(120 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.5833333333333334s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(150 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.5s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(180 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.4166666666666667s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(210 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.3333333333333333s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(240 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.25s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(270 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.16666666666666666s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(300 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "-0.08333333333333333s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("rect", {
                width: "6",
                height: "12",
                x: "47",
                y: "24",
                fill: "#fff",
                rx: "3",
                ry: "6",
                transform: "rotate(330 50 50)",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("animate", {
                    attributeName: "opacity",
                    begin: "0s",
                    dur: "1s",
                    keyTimes: "0;1",
                    repeatCount: "indefinite",
                    values: "1;0"
                })
            })
        ]
    });
}
var $ba60cbdac98c6712$export$2e2bcd8739ae039 = $ba60cbdac98c6712$var$Loading;


const $ea27d83049e40393$var$retryRequest = async (axiosCall, retries = 3, delay = 1000)=>{
    let lastError;
    for(let i = 0; i < retries; i++)try {
        return await axiosCall();
    } catch (error) {
        lastError = error;
        console.warn(`Retry ${i + 1} failed. Retrying in ${delay}ms...`);
        await new Promise((resolve)=>setTimeout(resolve, delay));
    }
    throw lastError;
};
const $ea27d83049e40393$var$BrandSelect = ({ cb: cb, queryObject: queryObject, setQueryObject: setQueryObject })=>{
    const [data, setData] = (0, $6cds3.useState)();
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [locale, setLocale] = (0, $6cds3.useState)("it");
    (0, $6cds3.useEffect)(()=>{
        const _loc = window?.Shopify?.locale;
        if (_loc) setLocale(_loc);
    }, []);
    const retrieveData = async ()=>{
        setLoading(true);
        try {
            const response = await $ea27d83049e40393$var$retryRequest(()=>(0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).get("https://gp.bkt.studio/entity"));
            setData(response.data);
        } catch (e) {
            console.log("Final error retrieving brand data", e);
        }
        setLoading(false);
    };
    (0, $6cds3.useEffect)(()=>{
        retrieveData();
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
        style: {
            flex: 1,
            maxWidth: "100px"
        },
        onChange: (e)=>{
            cb(e.target.value);
            setQueryObject({
                ...queryObject,
                casa: e.target.value
            });
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                selected: true,
                disabled: true,
                children: locale === "it" ? "Produttore" : "Brand"
            }),
            [
                ...new Set(data?.map((d)=>d.casa))
            ]?.sort((a, b)=>a.localeCompare(b)).map((brand, id)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                    value: brand,
                    children: brand
                }, "casa-" + id))
        ]
    });
};
const $ea27d83049e40393$var$ModelliSelect = ({ cb: cb, dependency: dependency, queryObject: queryObject, setQueryObject: setQueryObject })=>{
    const [data, setData] = (0, $6cds3.useState)();
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [locale, setLocale] = (0, $6cds3.useState)("it");
    (0, $6cds3.useEffect)(()=>{
        const _loc = window?.Shopify?.locale;
        if (_loc) setLocale(_loc);
    }, []);
    const retrieveData = async ()=>{
        setLoading(true);
        try {
            const response = await $ea27d83049e40393$var$retryRequest(()=>(0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://gp.bkt.studio/entity/find", {
                    casa: queryObject.casa
                }));
            setData(response.data);
        } catch (e) {
            console.log("Final error retrieving model data", e);
        }
        setLoading(false);
    };
    (0, $6cds3.useEffect)(()=>{
        if (dependency) {
            cb(null);
            retrieveData();
        }
    }, [
        dependency
    ]);
    if (loading) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ea27d83049e40393$var$LoadingIndicator, {});
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
        disabled: !dependency,
        style: {
            flex: 1
        },
        onChange: (e)=>{
            cb(e.target.value);
            setQueryObject({
                ...queryObject,
                casa: dependency,
                modello: e.target.value
            });
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                selected: true,
                disabled: true,
                children: locale === "it" ? "Modello" : "Model"
            }),
            [
                ...new Set(data?.map((d)=>d.modello))
            ]?.sort((a, b)=>a.localeCompare(b)).map((modello, id)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                    value: modello,
                    children: modello
                }, "modello-" + id))
        ]
    });
};
const $ea27d83049e40393$var$PorteSelect = ({ cb: cb, dependency: dependency, queryObject: queryObject, setQueryObject: setQueryObject })=>{
    const [data, setData] = (0, $6cds3.useState)();
    const [locale, setLocale] = (0, $6cds3.useState)("it");
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        const _loc = window?.Shopify?.locale;
        if (_loc) setLocale(_loc);
    }, []);
    const retrieveData = async ()=>{
        setLoading(true);
        try {
            const response = await $ea27d83049e40393$var$retryRequest(()=>(0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://gp.bkt.studio/entity/find", {
                    casa: queryObject.casa,
                    modello: queryObject.modello
                }));
            setData(response.data);
        } catch (e) {
            console.log("Final error retrieving porte data", e);
        }
        setLoading(false);
    };
    (0, $6cds3.useEffect)(()=>{
        if (dependency) {
            cb(null);
            retrieveData();
        }
    }, [
        dependency
    ]);
    if (loading) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ea27d83049e40393$var$LoadingIndicator, {});
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
        disabled: !dependency,
        style: {
            flex: 1
        },
        onChange: (e)=>{
            cb(e.target.value);
            setQueryObject({
                ...queryObject,
                porte: e.target.value
            });
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                selected: true,
                disabled: true,
                children: locale === "it" ? "Porte" : "Doors"
            }),
            [
                ...new Set(data?.map((d)=>d.porte))
            ]?.sort((a, b)=>a.localeCompare(b)).map((porte, id)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                    value: porte,
                    children: porte
                }, "porte-" + id))
        ]
    });
};
const $ea27d83049e40393$var$AnnoSelect = ({ cb: cb, dependency: dependency, queryObject: queryObject, setQueryObject: setQueryObject })=>{
    const [data, setData] = (0, $6cds3.useState)();
    const [loading, setLoading] = (0, $6cds3.useState)(false);
    const [locale, setLocale] = (0, $6cds3.useState)("it");
    (0, $6cds3.useEffect)(()=>{
        const _loc = window?.Shopify?.locale;
        if (_loc) setLocale(_loc);
    }, []);
    const retrieveData = async ()=>{
        setLoading(true);
        try {
            const response = await $ea27d83049e40393$var$retryRequest(()=>(0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://gp.bkt.studio/entity/find", {
                    casa: queryObject.casa,
                    modello: queryObject.modello,
                    porte: queryObject.porte
                }));
            setData(response.data);
        } catch (e) {
            console.log("Final error retrieving anno data", e);
        }
        setLoading(false);
    };
    (0, $6cds3.useEffect)(()=>{
        if (dependency) {
            cb(null);
            retrieveData();
        }
    }, [
        dependency
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (data && data.length === 1) {
            cb(data[0].metaId);
            setQueryObject({
                ...queryObject,
                anno: data[0].name
            });
        }
    }, [
        data
    ]);
    if (loading) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ea27d83049e40393$var$LoadingIndicator, {});
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
        disabled: !dependency,
        style: {
            flex: 1
        },
        onChange: (e)=>{
            cb(e.target.value);
            setQueryObject({
                ...queryObject,
                anno: e.target.value
            });
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                selected: true,
                disabled: true,
                children: locale === "it" ? "Anno" : "Year"
            }),
            [
                ...new Set(data?.map((d)=>d.anno))
            ]?.sort((a, b)=>a.localeCompare(b)).map((anno, id)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                    value: anno,
                    children: anno
                }, "anno-" + id))
        ]
    });
};
const $ea27d83049e40393$var$LoadingIndicator = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        style: {
            flex: 1,
            justifyContent: "center",
            display: "flex",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ba60cbdac98c6712$export$2e2bcd8739ae039), {})
    });
function $ea27d83049e40393$export$2e2bcd8739ae039() {
    const { handleSubmit: handleSubmit } = (0, $ba34d1ebd6528b77$export$87c0cf8eb5a167e0)();
    const [locale, setLocale] = (0, $6cds3.useState)("it");
    (0, $6cds3.useEffect)(()=>{
        const _loc = window?.Shopify?.locale;
        if (_loc) setLocale(_loc);
    }, []);
    const [brand, setBrand] = (0, $6cds3.useState)();
    const [modelli, setModelli] = (0, $6cds3.useState)();
    const [porte, setPorte] = (0, $6cds3.useState)();
    const [anno, setAnno] = (0, $6cds3.useState)();
    const [queryObject, setQueryObject] = (0, $6cds3.useState)({});
    const generateHandle = (title)=>{
        try {
            return title.toLowerCase().replace(/[^a-z0-9-]/g, "") // rimuove caratteri non validi
            ;
        } catch (err) {
            return "";
        }
    };
    const onSubmit = async ()=>{
        try {
            const response = await $ea27d83049e40393$var$retryRequest(()=>(0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post("https://gp.bkt.studio/entity/find", queryObject));
            const result = response.data[0]?.slug?.replace("/", "").replace(".", "");
            if (result) {
                const basePath = locale === "it" ? "/collections/" : "/en/collections/";
                window.location.href = `${basePath}${generateHandle(result)}`;
            }
        } catch (e) {
            console.log("Final error in submit", e);
        }
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("form", {
            role: "search",
            method: "get",
            className: "searchform",
            onSubmit: handleSubmit(onSubmit),
            style: {
                display: "flex",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("fieldset", {
                    className: "fs-advanced-search",
                    style: {
                        display: "flex",
                        justifyContent: "space-around"
                    },
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ea27d83049e40393$var$BrandSelect, {
                            cb: setBrand,
                            queryObject: queryObject,
                            setQueryObject: setQueryObject
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ea27d83049e40393$var$ModelliSelect, {
                            dependency: brand,
                            cb: setModelli,
                            queryObject: queryObject,
                            setQueryObject: setQueryObject
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ea27d83049e40393$var$PorteSelect, {
                            dependency: modelli,
                            cb: setPorte,
                            queryObject: queryObject,
                            setQueryObject: setQueryObject
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($ea27d83049e40393$var$AnnoSelect, {
                            dependency: porte,
                            cb: setAnno,
                            queryObject: queryObject,
                            setQueryObject: setQueryObject
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                    type: "submit",
                    style: {
                        flex: 1
                    },
                    disabled: !anno,
                    value: locale === "it" ? "Cerca" : "Search"
                })
            ]
        })
    });
}


function $a198c5b7f78064c1$export$2e2bcd8739ae039() {
    const [searchType, setSearchType] = (0, $6cds3.useState)("advanced");
    const [locale, setLocale] = (0, $6cds3.useState)("it");
    (0, $6cds3.useEffect)(()=>{
        const _loc = window?.Shopify?.locale;
        if (_loc) setLocale(_loc);
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        style: {
            padding: "20px",
            backgroundColor: "rgb(0, 0, 0, .8)"
        },
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                children: locale === "it" ? "Cerca prodotto" : "Search product"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("scroll-shadow", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("collection-tabs", {
                    className: "collection-tabs__list",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            type: "button",
                            className: "collection-tabs__list-link" + (searchType === "advanced" ? " active" : ""),
                            onClick: ()=>setSearchType("advanced"),
                            children: locale === "it" ? "per veicolo" : "by vehicle"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            type: "button",
                            className: "collection-tabs__list-link" + (searchType === "sku" ? " active" : ""),
                            onClick: ()=>setSearchType("sku"),
                            children: locale === "it" ? "per codice" : "by code"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            type: "button",
                            className: "collection-tabs__list-link" + (searchType === "name" ? " active" : ""),
                            onClick: ()=>setSearchType("name"),
                            children: locale === "it" ? "per nome" : "by name"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                style: {
                    marginTop: "20px"
                },
                children: [
                    searchType === "sku" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a0bba175813fd04$export$2e2bcd8739ae039), {}),
                    searchType === "name" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8dfcdff4de2a5aa7$export$2e2bcd8739ae039), {}),
                    searchType === "advanced" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ea27d83049e40393$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}



const $ea833559f5a67bb4$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("hj6t9")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $ea833559f5a67bb4$export$2e2bcd8739ae039 = $ea833559f5a67bb4$var$reportWebVitals;



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");
var $40fa4cd77afb028d$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $40fa4cd77afb028d$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $896bd52db03f136c$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $896bd52db03f136c$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($40fa4cd77afb028d$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($896bd52db03f136c$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $896bd52db03f136c$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $896bd52db03f136c$var$i = /^\s*$/, $896bd52db03f136c$var$s = Object.create(null);
function $896bd52db03f136c$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($896bd52db03f136c$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $896bd52db03f136c$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $896bd52db03f136c$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($896bd52db03f136c$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $896bd52db03f136c$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $896bd52db03f136c$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $896bd52db03f136c$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $896bd52db03f136c$var$a("", t);
        }, "");
    }
};
var $896bd52db03f136c$export$2e2bcd8739ae039 = $896bd52db03f136c$var$c;


function $49ea87b4af2317b9$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $49ea87b4af2317b9$var$alreadyWarned = {};
function $49ea87b4af2317b9$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $49ea87b4af2317b9$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $49ea87b4af2317b9$var$alreadyWarned[args[0]] = new Date();
    $49ea87b4af2317b9$export$c106dd0671a0fc2d(...args);
}
const $49ea87b4af2317b9$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
function $49ea87b4af2317b9$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $49ea87b4af2317b9$var$loadedClb(i18n, cb));
}
function $49ea87b4af2317b9$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === 'string') ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $49ea87b4af2317b9$var$loadedClb(i18n, cb));
}
function $49ea87b4af2317b9$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $49ea87b4af2317b9$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $49ea87b4af2317b9$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $49ea87b4af2317b9$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $49ea87b4af2317b9$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}


const $300cd1a82955ff52$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $300cd1a82955ff52$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $300cd1a82955ff52$var$unescapeHtmlEntity = (m)=>$300cd1a82955ff52$var$htmlEntities[m];
const $300cd1a82955ff52$export$e8bacd2802a88316 = (text)=>text.replace($300cd1a82955ff52$var$matchHtmlEntity, $300cd1a82955ff52$var$unescapeHtmlEntity);


let $5e110d92b402282f$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $300cd1a82955ff52$export$e8bacd2802a88316
};
function $5e110d92b402282f$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $5e110d92b402282f$var$defaultOptions = {
        ...$5e110d92b402282f$var$defaultOptions,
        ...options
    };
}
function $5e110d92b402282f$export$212bb2fc580a90a8() {
    return $5e110d92b402282f$var$defaultOptions;
}


let $eed3bb1ccb9dbe57$var$i18nInstance;
function $eed3bb1ccb9dbe57$export$a039134f2fc7e0(instance) {
    $eed3bb1ccb9dbe57$var$i18nInstance = instance;
}
function $eed3bb1ccb9dbe57$export$64af334f494c2f47() {
    return $eed3bb1ccb9dbe57$var$i18nInstance;
}


function $a857e53380da75df$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $a857e53380da75df$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $a857e53380da75df$var$getAsArray(children) : children;
}
function $a857e53380da75df$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== '[object Array]') return false;
    return children.every((child)=>(0, $6cds3.isValidElement)(child));
}
function $a857e53380da75df$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $a857e53380da75df$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $a857e53380da75df$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $a857e53380da75df$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === 'string') stringNode += `${child}`;
        else if ((0, $6cds3.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $a857e53380da75df$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $49ea87b4af2317b9$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === 'object') {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $49ea87b4af2317b9$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $49ea87b4af2317b9$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $a857e53380da75df$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $a857e53380da75df$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === 'string') return;
            if ($a857e53380da75df$var$hasChildren(child)) getData($a857e53380da75df$var$getChildren(child));
            else if (typeof child === 'object' && !(0, $6cds3.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $896bd52db03f136c$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $a857e53380da75df$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $a857e53380da75df$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $6cds3.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $6cds3.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $6cds3.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $a857e53380da75df$var$getAsArray(reactNode);
        const astNodes = $a857e53380da75df$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $a857e53380da75df$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $6cds3.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $a857e53380da75df$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === 'object' && child.dummy && !isElement;
                const isKnownComponent = typeof children === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === 'string') {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($a857e53380da75df$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $6cds3.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $6cds3.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === 'object' && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $6cds3.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $a857e53380da75df$var$getAsArray(children || []));
    return $a857e53380da75df$var$getChildren(result[0]);
}
function $a857e53380da75df$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $eed3bb1ccb9dbe57$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $49ea87b4af2317b9$export$5b28268982f175ba)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $5e110d92b402282f$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $a857e53380da75df$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === 'function' || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, $6cds3.createElement)((0, $6cds3.Fragment), null, comp);
        }
        components[c] = (0, $6cds3.createElement)(Componentized);
    });
    const content = $a857e53380da75df$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $6cds3.createElement)(useAsParent, additionalProps, content) : content;
}



var $6cds3 = parcelRequire("6cds3");




const $49625fe5399c2d37$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $5e110d92b402282f$export$2e2366488d12e20d)(instance.options.react);
        (0, $eed3bb1ccb9dbe57$export$a039134f2fc7e0)(instance);
    }
};


const $41506188a9ed6c03$export$5603ab5ced17ce64 = (0, $6cds3.createContext)();
class $41506188a9ed6c03$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $41506188a9ed6c03$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $41506188a9ed6c03$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $41506188a9ed6c03$export$704200e5d0b9e8f() {
    const i18n = (0, $eed3bb1ccb9dbe57$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $3d08a8ef781feb06$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $6cds3.useContext)((0, $41506188a9ed6c03$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $eed3bb1ccb9dbe57$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $a857e53380da75df$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $6cds3 = parcelRequire("6cds3");


const $86374ceabf1cf454$var$usePrevious = (value, ignore)=>{
    const ref = (0, $6cds3.useRef)();
    (0, $6cds3.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $86374ceabf1cf454$var$alwaysNewT(i18n, language, namespace, keyPrefix) {
    return i18n.getFixedT(language, namespace, keyPrefix);
}
function $86374ceabf1cf454$var$useMemoizedT(i18n, language, namespace, keyPrefix) {
    return (0, $6cds3.useCallback)($86374ceabf1cf454$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
}
function $86374ceabf1cf454$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $6cds3.useContext)((0, $41506188a9ed6c03$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $eed3bb1ccb9dbe57$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $41506188a9ed6c03$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $49ea87b4af2317b9$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $49ea87b4af2317b9$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $5e110d92b402282f$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $49ea87b4af2317b9$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $86374ceabf1cf454$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$86374ceabf1cf454$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $6cds3.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $86374ceabf1cf454$var$usePrevious(joinedNS);
    const isMounted = (0, $6cds3.useRef)(true);
    (0, $6cds3.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $49ea87b4af2317b9$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $49ea87b4af2317b9$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        function boundReset() {
            if (isMounted.current) setT(getNewT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $49ea87b4af2317b9$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $49ea87b4af2317b9$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}



var $6cds3 = parcelRequire("6cds3");


function $f0244be04c051c25$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $86374ceabf1cf454$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $6cds3.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $49ea87b4af2317b9$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $6cds3.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $6cds3.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}



function $431b7a6175ab8f37$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $86374ceabf1cf454$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $6cds3 = parcelRequire("6cds3");

function $96fae657dd539aec$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $6cds3.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $6cds3.createElement)((0, $41506188a9ed6c03$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $6cds3 = parcelRequire("6cds3");

var $6cds3 = parcelRequire("6cds3");

function $421dde02c088f632$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $6cds3.useContext)((0, $41506188a9ed6c03$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $eed3bb1ccb9dbe57$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $12a57bf327545142$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $421dde02c088f632$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $6cds3.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $41506188a9ed6c03$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $49ea87b4af2317b9$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $b8185f8aa433232c$export$324d90190a8b822a = ()=>'';
const $b8185f8aa433232c$export$2da9be4cfdb689b1 = ()=>'';
const $b8185f8aa433232c$export$98e628dec113755e = ()=>'';
const $b8185f8aa433232c$export$2e6c959c16ff56b8 = ()=>'';
const $b8185f8aa433232c$export$4e35d5c922a95490 = ()=>'';
const $b8185f8aa433232c$export$720a3b9db04b7a0f = ()=>'';


const $05ab9eeed7a27669$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $05ab9eeed7a27669$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $05ab9eeed7a27669$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === 'string') args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $05ab9eeed7a27669$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $05ab9eeed7a27669$var$Logger(this.logger, options);
    }
}
var $05ab9eeed7a27669$var$baseLogger = new $05ab9eeed7a27669$var$Logger();
class $05ab9eeed7a27669$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $05ab9eeed7a27669$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $05ab9eeed7a27669$var$makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function $05ab9eeed7a27669$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
const $05ab9eeed7a27669$var$lastOfPathSeparatorRegExp = /###/g;
function $05ab9eeed7a27669$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace($05ab9eeed7a27669$var$lastOfPathSeparatorRegExp, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    const stack = typeof path !== 'string' ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack[stackIndex])
    };
}
function $05ab9eeed7a27669$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $05ab9eeed7a27669$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $05ab9eeed7a27669$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $05ab9eeed7a27669$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
}
function $05ab9eeed7a27669$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $05ab9eeed7a27669$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $05ab9eeed7a27669$var$getPath(object, path) {
    const { obj: obj, k: k } = $05ab9eeed7a27669$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $05ab9eeed7a27669$var$getPathWithDefaults(data, defaultData, key) {
    const value = $05ab9eeed7a27669$var$getPath(data, key);
    if (value !== undefined) return value;
    return $05ab9eeed7a27669$var$getPath(defaultData, key);
}
function $05ab9eeed7a27669$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $05ab9eeed7a27669$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $05ab9eeed7a27669$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var $05ab9eeed7a27669$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function $05ab9eeed7a27669$var$escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, (s)=>$05ab9eeed7a27669$var$_entityMap[s]);
    return data;
}
class $05ab9eeed7a27669$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $05ab9eeed7a27669$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $05ab9eeed7a27669$var$looksLikeObjectPathRegExpCache = new $05ab9eeed7a27669$var$RegExpCache(20);
function $05ab9eeed7a27669$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $05ab9eeed7a27669$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $05ab9eeed7a27669$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $05ab9eeed7a27669$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
}
function $05ab9eeed7a27669$var$getCleanedCode(code) {
    if (code && code.indexOf('_') > 0) return code.replace('_', '-');
    return code;
}
class $05ab9eeed7a27669$var$ResourceStore extends $05ab9eeed7a27669$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if (typeof key === 'string' && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $05ab9eeed7a27669$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
        return $05ab9eeed7a27669$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $05ab9eeed7a27669$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $05ab9eeed7a27669$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $05ab9eeed7a27669$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $05ab9eeed7a27669$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $05ab9eeed7a27669$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $05ab9eeed7a27669$var$checkedLoadedFor = {};
class $05ab9eeed7a27669$var$Translator extends $05ab9eeed7a27669$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $05ab9eeed7a27669$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $05ab9eeed7a27669$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$05ab9eeed7a27669$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === 'string') namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === '[object Array]';
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
            const hasDefaultValue = $05ab9eeed7a27669$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === 'string' ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $05ab9eeed7a27669$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === 'string') keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$05ab9eeed7a27669$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $05ab9eeed7a27669$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== 'string';
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $05ab9eeed7a27669$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $05ab9eeed7a27669$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $05ab9eeed7a27669$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $05ab9eeed7a27669$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $05ab9eeed7a27669$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === 'string' && code.indexOf('-') > -1) {
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $05ab9eeed7a27669$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $05ab9eeed7a27669$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $05ab9eeed7a27669$var$capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if (typeof fallbacks === 'string') fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === 'string' && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $05ab9eeed7a27669$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $05ab9eeed7a27669$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $05ab9eeed7a27669$var$nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const $05ab9eeed7a27669$var$intlVersions = [
    'v4'
];
const $05ab9eeed7a27669$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $05ab9eeed7a27669$var$createRules() {
    const rules = {};
    $05ab9eeed7a27669$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $05ab9eeed7a27669$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $05ab9eeed7a27669$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $05ab9eeed7a27669$var$baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || $05ab9eeed7a27669$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = $05ab9eeed7a27669$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($05ab9eeed7a27669$var$getCleanedCode(code === 'dev' ? 'en' : code), {
                type: options.ordinal ? 'ordinal' : 'cardinal'
            });
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$05ab9eeed7a27669$var$suffixesOrder[pluralCategory1] - $05ab9eeed7a27669$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$05ab9eeed7a27669$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $05ab9eeed7a27669$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $05ab9eeed7a27669$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === 'string') {
        path = $05ab9eeed7a27669$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $05ab9eeed7a27669$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $05ab9eeed7a27669$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $05ab9eeed7a27669$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $05ab9eeed7a27669$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $05ab9eeed7a27669$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
        this.suffix = iOpts.suffix ? $05ab9eeed7a27669$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
        this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
        this.nestingPrefix = iOpts.nestingPrefix ? $05ab9eeed7a27669$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $05ab9eeed7a27669$var$regexEscape('$t(');
        this.nestingSuffix = iOpts.nestingSuffix ? $05ab9eeed7a27669$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $05ab9eeed7a27669$var$regexEscape(')');
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, '$$$$');
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $05ab9eeed7a27669$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($05ab9eeed7a27669$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === 'string' ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (typeof value !== 'string' && !this.useRawValueToEscape) value = $05ab9eeed7a27669$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== 'string') return value;
            if (typeof value !== 'string') value = $05ab9eeed7a27669$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $05ab9eeed7a27669$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(':');
                const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === 'false') formatOptions[key.trim()] = false;
                if (val === 'true') formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $05ab9eeed7a27669$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($05ab9eeed7a27669$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $05ab9eeed7a27669$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $05ab9eeed7a27669$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $05ab9eeed7a27669$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $05ab9eeed7a27669$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $05ab9eeed7a27669$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $05ab9eeed7a27669$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $05ab9eeed7a27669$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $05ab9eeed7a27669$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $05ab9eeed7a27669$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $05ab9eeed7a27669$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $05ab9eeed7a27669$var$Connector extends $05ab9eeed7a27669$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $05ab9eeed7a27669$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $05ab9eeed7a27669$var$pushPath(q.loaded, [
                lng
            ], ns);
            $05ab9eeed7a27669$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === 'string') namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $05ab9eeed7a27669$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $05ab9eeed7a27669$var$transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function $05ab9eeed7a27669$var$noop() {}
function $05ab9eeed7a27669$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
}
class $05ab9eeed7a27669$var$I18n extends $05ab9eeed7a27669$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $05ab9eeed7a27669$var$transformOptions(options);
        this.services = {};
        this.logger = $05ab9eeed7a27669$var$baseLogger;
        this.modules = {
            external: []
        };
        $05ab9eeed7a27669$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === 'string') options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $05ab9eeed7a27669$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$05ab9eeed7a27669$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $05ab9eeed7a27669$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $05ab9eeed7a27669$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = $05ab9eeed7a27669$var$Formatter;
            const lu = new $05ab9eeed7a27669$var$LanguageUtil(this.options);
            this.store = new $05ab9eeed7a27669$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $05ab9eeed7a27669$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $05ab9eeed7a27669$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $05ab9eeed7a27669$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $05ab9eeed7a27669$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $05ab9eeed7a27669$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $05ab9eeed7a27669$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $05ab9eeed7a27669$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $05ab9eeed7a27669$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === 'string' ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $05ab9eeed7a27669$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $05ab9eeed7a27669$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $05ab9eeed7a27669$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $05ab9eeed7a27669$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === 'string' ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === 'string') fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $05ab9eeed7a27669$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === 'string') ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $05ab9eeed7a27669$var$defer();
        if (typeof lngs === 'string') lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new $05ab9eeed7a27669$var$LanguageUtil($05ab9eeed7a27669$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $05ab9eeed7a27669$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $05ab9eeed7a27669$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $05ab9eeed7a27669$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $05ab9eeed7a27669$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $05ab9eeed7a27669$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $05ab9eeed7a27669$export$2e2bcd8739ae039 = $05ab9eeed7a27669$var$I18n.createInstance();
$05ab9eeed7a27669$export$2e2bcd8739ae039.createInstance = $05ab9eeed7a27669$var$I18n.createInstance;
const $05ab9eeed7a27669$export$99152e8d49ca4e7d = $05ab9eeed7a27669$export$2e2bcd8739ae039.createInstance;
const $05ab9eeed7a27669$export$147ec2801e896265 = $05ab9eeed7a27669$export$2e2bcd8739ae039.dir;
const $05ab9eeed7a27669$export$2cd8252107eb640b = $05ab9eeed7a27669$export$2e2bcd8739ae039.init;
const $05ab9eeed7a27669$export$d3d08d944062d7e = $05ab9eeed7a27669$export$2e2bcd8739ae039.loadResources;
const $05ab9eeed7a27669$export$a5d9bf5d83fcab09 = $05ab9eeed7a27669$export$2e2bcd8739ae039.reloadResources;
const $05ab9eeed7a27669$export$1f96ae73734a86cc = $05ab9eeed7a27669$export$2e2bcd8739ae039.use;
const $05ab9eeed7a27669$export$61465194746e7fd2 = $05ab9eeed7a27669$export$2e2bcd8739ae039.changeLanguage;
const $05ab9eeed7a27669$export$f90d180fc7da3b3b = $05ab9eeed7a27669$export$2e2bcd8739ae039.getFixedT;
const $05ab9eeed7a27669$export$625550452a3fa3ec = $05ab9eeed7a27669$export$2e2bcd8739ae039.t;
const $05ab9eeed7a27669$export$f7e9f41ea797a17 = $05ab9eeed7a27669$export$2e2bcd8739ae039.exists;
const $05ab9eeed7a27669$export$2b4b218e406d2d00 = $05ab9eeed7a27669$export$2e2bcd8739ae039.setDefaultNamespace;
const $05ab9eeed7a27669$export$93d9ee97c1ad3f31 = $05ab9eeed7a27669$export$2e2bcd8739ae039.hasLoadedNamespace;
const $05ab9eeed7a27669$export$83be934b53fff43b = $05ab9eeed7a27669$export$2e2bcd8739ae039.loadNamespaces;
const $05ab9eeed7a27669$export$8cd7e7a54fa865bc = $05ab9eeed7a27669$export$2e2bcd8739ae039.loadLanguages;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c2a37736a53c5f6$var$extendStatics = function(d, b) {
    $5c2a37736a53c5f6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c2a37736a53c5f6$var$extendStatics(d, b);
};
function $5c2a37736a53c5f6$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c2a37736a53c5f6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c2a37736a53c5f6$export$18ce0697a983be9b = function() {
    $5c2a37736a53c5f6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c2a37736a53c5f6$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c2a37736a53c5f6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c2a37736a53c5f6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c2a37736a53c5f6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c2a37736a53c5f6$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c2a37736a53c5f6$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c2a37736a53c5f6$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c2a37736a53c5f6$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c2a37736a53c5f6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c2a37736a53c5f6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c2a37736a53c5f6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c2a37736a53c5f6$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c2a37736a53c5f6$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c2a37736a53c5f6$export$45d3717a4c69092e(o, m, p);
}
function $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c2a37736a53c5f6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c2a37736a53c5f6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c2a37736a53c5f6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c2a37736a53c5f6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c2a37736a53c5f6$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c2a37736a53c5f6$export$10c90e4f7922046c(v) {
    return this instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? (this.v = v, this) : new $5c2a37736a53c5f6$export$10c90e4f7922046c(v);
}
function $5c2a37736a53c5f6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c2a37736a53c5f6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c2a37736a53c5f6$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c2a37736a53c5f6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c2a37736a53c5f6$export$19a8beecd37a4c45 === "function" ? $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c2a37736a53c5f6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c2a37736a53c5f6$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c2a37736a53c5f6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c2a37736a53c5f6$export$45d3717a4c69092e(result, mod, k);
    }
    $5c2a37736a53c5f6$var$__setModuleDefault(result, mod);
    return result;
}
function $5c2a37736a53c5f6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c2a37736a53c5f6$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c2a37736a53c5f6$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c2a37736a53c5f6$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c2a37736a53c5f6$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c2a37736a53c5f6$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c2a37736a53c5f6$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c2a37736a53c5f6$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c2a37736a53c5f6$export$2e2bcd8739ae039 = {
    __extends: $5c2a37736a53c5f6$export$a8ba968b8961cb8a,
    __assign: $5c2a37736a53c5f6$export$18ce0697a983be9b,
    __rest: $5c2a37736a53c5f6$export$3c9a16f847548506,
    __decorate: $5c2a37736a53c5f6$export$29e00dfd3077644b,
    __param: $5c2a37736a53c5f6$export$d5ad3fd78186038f,
    __metadata: $5c2a37736a53c5f6$export$f1db080c865becb9,
    __awaiter: $5c2a37736a53c5f6$export$1050f835b63b671e,
    __generator: $5c2a37736a53c5f6$export$67ebef60e6f28a6,
    __createBinding: $5c2a37736a53c5f6$export$45d3717a4c69092e,
    __exportStar: $5c2a37736a53c5f6$export$f33643c0debef087,
    __values: $5c2a37736a53c5f6$export$19a8beecd37a4c45,
    __read: $5c2a37736a53c5f6$export$8d051b38c9118094,
    __spread: $5c2a37736a53c5f6$export$afc72e2116322959,
    __spreadArrays: $5c2a37736a53c5f6$export$6388937ca91ccae8,
    __spreadArray: $5c2a37736a53c5f6$export$1216008129fb82ed,
    __await: $5c2a37736a53c5f6$export$10c90e4f7922046c,
    __asyncGenerator: $5c2a37736a53c5f6$export$e427f37a30a4de9b,
    __asyncDelegator: $5c2a37736a53c5f6$export$bbd80228419bb833,
    __asyncValues: $5c2a37736a53c5f6$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c2a37736a53c5f6$export$4fb47efe1390b86f,
    __importStar: $5c2a37736a53c5f6$export$c21735bcef00d192,
    __importDefault: $5c2a37736a53c5f6$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c2a37736a53c5f6$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c2a37736a53c5f6$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c2a37736a53c5f6$export$81fdc39f203e4e04,
    __addDisposableResource: $5c2a37736a53c5f6$export$88ac25d8e944e405,
    __disposeResources: $5c2a37736a53c5f6$export$8f076105dc360e92
};



var $d02c9055aa36b4b0$var$genericMessage = "Invariant Violation";
var $d02c9055aa36b4b0$var$_a = Object.setPrototypeOf, $d02c9055aa36b4b0$var$setPrototypeOf = $d02c9055aa36b4b0$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $d02c9055aa36b4b0$var$_a;
var $d02c9055aa36b4b0$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $d02c9055aa36b4b0$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $d02c9055aa36b4b0$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $d02c9055aa36b4b0$var$genericMessage;
        $d02c9055aa36b4b0$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $d02c9055aa36b4b0$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $d02c9055aa36b4b0$export$cea12affaee22fe8(message);
}
var $d02c9055aa36b4b0$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $d02c9055aa36b4b0$var$verbosityLevel = $d02c9055aa36b4b0$var$verbosityLevels.indexOf("log");
function $d02c9055aa36b4b0$var$wrapConsoleMethod(name) {
    return function() {
        if ($d02c9055aa36b4b0$var$verbosityLevels.indexOf(name) >= $d02c9055aa36b4b0$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $d02c9055aa36b4b0$var$wrapConsoleMethod("debug");
    invariant.log = $d02c9055aa36b4b0$var$wrapConsoleMethod("log");
    invariant.warn = $d02c9055aa36b4b0$var$wrapConsoleMethod("warn");
    invariant.error = $d02c9055aa36b4b0$var$wrapConsoleMethod("error");
})($d02c9055aa36b4b0$export$f5708dca728d7177 || ($d02c9055aa36b4b0$export$f5708dca728d7177 = {}));
function $d02c9055aa36b4b0$export$a80e09f2cd325fb8(level) {
    var old = $d02c9055aa36b4b0$var$verbosityLevels[$d02c9055aa36b4b0$var$verbosityLevel];
    $d02c9055aa36b4b0$var$verbosityLevel = Math.max(0, $d02c9055aa36b4b0$var$verbosityLevels.indexOf(level));
    return old;
}
var $d02c9055aa36b4b0$export$2e2bcd8739ae039 = $d02c9055aa36b4b0$export$f5708dca728d7177;


var $119b34ff2b3530e4$export$83d89fbfd8236492 = "3.9.7";


function $d60ad807eacd6810$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $a9d4b6985b788da6$export$2e2bcd8739ae039 = (0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $eeb94b2a0137b911$var$prefixCounts = new Map();
function $eeb94b2a0137b911$export$d0c8ec0fe1b18b70(prefix) {
    var count = $eeb94b2a0137b911$var$prefixCounts.get(prefix) || 1;
    $eeb94b2a0137b911$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $1fc4800207ae15ec$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $eeb94b2a0137b911$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $0489aed6bc3d2ffd$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $0489aed6bc3d2ffd$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $0489aed6bc3d2ffd$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $0489aed6bc3d2ffd$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $d02c9055aa36b4b0$export$f5708dca728d7177)(condition, $0489aed6bc3d2ffd$var$getHandledErrorMsg(message, args) || $0489aed6bc3d2ffd$var$getFallbackErrorMsg(message, args));
}, {
    debug: $0489aed6bc3d2ffd$var$wrap((0, $d02c9055aa36b4b0$export$f5708dca728d7177).debug),
    log: $0489aed6bc3d2ffd$var$wrap((0, $d02c9055aa36b4b0$export$f5708dca728d7177).log),
    warn: $0489aed6bc3d2ffd$var$wrap((0, $d02c9055aa36b4b0$export$f5708dca728d7177).warn),
    error: $0489aed6bc3d2ffd$var$wrap((0, $d02c9055aa36b4b0$export$f5708dca728d7177).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $0489aed6bc3d2ffd$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $d02c9055aa36b4b0$export$cea12affaee22fe8)($0489aed6bc3d2ffd$var$getHandledErrorMsg(message, optionalParams) || $0489aed6bc3d2ffd$var$getFallbackErrorMsg(message, optionalParams));
}
var $0489aed6bc3d2ffd$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $119b34ff2b3530e4$export$83d89fbfd8236492));
function $0489aed6bc3d2ffd$var$stringify(arg) {
    return typeof arg == "string" ? arg : (0, $1fc4800207ae15ec$export$f341b4883239463f)(arg, 2).slice(0, 1000);
}
function $0489aed6bc3d2ffd$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $a9d4b6985b788da6$export$2e2bcd8739ae039)[$0489aed6bc3d2ffd$export$b8ca975fa04efdf3] && (0, $a9d4b6985b788da6$export$2e2bcd8739ae039)[$0489aed6bc3d2ffd$export$b8ca975fa04efdf3](message, messageArgs.map($0489aed6bc3d2ffd$var$stringify));
}
function $0489aed6bc3d2ffd$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $119b34ff2b3530e4$export$83d89fbfd8236492),
        message: message,
        args: messageArgs.map($0489aed6bc3d2ffd$var$stringify)
    })));
}




var $416d371f5450e728$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;



function $02cae19fe6259dbb$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $02cae19fe6259dbb$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $02cae19fe6259dbb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $02cae19fe6259dbb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $02cae19fe6259dbb$var$_arrayLikeToArray(o, minLen);
}
function $02cae19fe6259dbb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $02cae19fe6259dbb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $02cae19fe6259dbb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $02cae19fe6259dbb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $02cae19fe6259dbb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $02cae19fe6259dbb$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $02cae19fe6259dbb$var$hasSymbol = function(name) {
    return $02cae19fe6259dbb$var$hasSymbols() && Boolean(Symbol[name]);
};
var $02cae19fe6259dbb$var$getSymbol = function(name) {
    return $02cae19fe6259dbb$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($02cae19fe6259dbb$var$hasSymbols() && !$02cae19fe6259dbb$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $02cae19fe6259dbb$var$SymbolIterator = $02cae19fe6259dbb$var$getSymbol('iterator');
var $02cae19fe6259dbb$var$SymbolObservable = $02cae19fe6259dbb$var$getSymbol('observable');
var $02cae19fe6259dbb$var$SymbolSpecies = $02cae19fe6259dbb$var$getSymbol('species'); // === Abstract Operations ===
function $02cae19fe6259dbb$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $02cae19fe6259dbb$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$02cae19fe6259dbb$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $02cae19fe6259dbb$export$77cea355fa80b5f4;
}
function $02cae19fe6259dbb$var$isObservable(x) {
    return x instanceof $02cae19fe6259dbb$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $02cae19fe6259dbb$var$hostReportError(e) {
    if ($02cae19fe6259dbb$var$hostReportError.log) $02cae19fe6259dbb$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $02cae19fe6259dbb$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $02cae19fe6259dbb$var$hostReportError(e);
        }
    });
}
function $02cae19fe6259dbb$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $02cae19fe6259dbb$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $02cae19fe6259dbb$var$hostReportError(e);
    }
}
function $02cae19fe6259dbb$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $02cae19fe6259dbb$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $02cae19fe6259dbb$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $02cae19fe6259dbb$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $02cae19fe6259dbb$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $02cae19fe6259dbb$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $02cae19fe6259dbb$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $02cae19fe6259dbb$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $02cae19fe6259dbb$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $02cae19fe6259dbb$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $02cae19fe6259dbb$var$enqueue(function() {
            return $02cae19fe6259dbb$var$flushSubscription(subscription);
        });
        return;
    }
    $02cae19fe6259dbb$var$notifySubscription(subscription, type, value);
}
var $02cae19fe6259dbb$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $02cae19fe6259dbb$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $02cae19fe6259dbb$var$closeSubscription(this);
            $02cae19fe6259dbb$var$cleanupSubscription(this);
        }
    };
    $02cae19fe6259dbb$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $02cae19fe6259dbb$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $02cae19fe6259dbb$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $02cae19fe6259dbb$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $02cae19fe6259dbb$var$onNotify(this._subscription, 'complete');
    };
    $02cae19fe6259dbb$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $02cae19fe6259dbb$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $02cae19fe6259dbb$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $02cae19fe6259dbb$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $02cae19fe6259dbb$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $02cae19fe6259dbb$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $02cae19fe6259dbb$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $02cae19fe6259dbb$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$02cae19fe6259dbb$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $02cae19fe6259dbb$var$getMethod(x, $02cae19fe6259dbb$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($02cae19fe6259dbb$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($02cae19fe6259dbb$var$hasSymbol('iterator')) {
            method = $02cae19fe6259dbb$var$getMethod(x, $02cae19fe6259dbb$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $02cae19fe6259dbb$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $02cae19fe6259dbb$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $02cae19fe6259dbb$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $02cae19fe6259dbb$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $02cae19fe6259dbb$var$_createClass(Observable, null, [
        {
            key: $02cae19fe6259dbb$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($02cae19fe6259dbb$var$hasSymbols()) Object.defineProperty($02cae19fe6259dbb$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $02cae19fe6259dbb$var$SymbolObservable,
        hostReportError: $02cae19fe6259dbb$var$hostReportError
    },
    configurable: true
});


parcelRequire("g8ZYZ");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $0550366f6e26c257$var$prototype = (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).prototype;
var $0550366f6e26c257$var$fakeObsSymbol = "@@observable";
if (!$0550366f6e26c257$var$prototype[$0550366f6e26c257$var$fakeObsSymbol]) // @ts-expect-error
$0550366f6e26c257$var$prototype[$0550366f6e26c257$var$fakeObsSymbol] = function() {
    return this;
};



function $5d3688c4fff158a7$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}



function $1937899ec4a35235$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $1937899ec4a35235$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}




function $28a2319727232c81$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(71, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(fragments.length === 1, 72, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $28a2319727232c81$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $28a2319727232c81$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(fragment, 73, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}


function $169b970ce932f843$var$defaultDispose() {}
class $169b970ce932f843$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $169b970ce932f843$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

function $89284a9272570c0b$var$noop() {}
const $89284a9272570c0b$var$defaultDispose = $89284a9272570c0b$var$noop;
const $89284a9272570c0b$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $89284a9272570c0b$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $89284a9272570c0b$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $89284a9272570c0b$var$noop,
        unregister: $89284a9272570c0b$var$noop
    };
};
const $89284a9272570c0b$var$finalizationBatchSize = 10024;
class $89284a9272570c0b$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $89284a9272570c0b$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $89284a9272570c0b$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $89284a9272570c0b$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $89284a9272570c0b$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $89284a9272570c0b$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}


var $8e29fc57e38c5c41$var$scheduledCleanup = new WeakSet();
function $8e29fc57e38c5c41$var$schedule(cache) {
    if (!$8e29fc57e38c5c41$var$scheduledCleanup.has(cache)) {
        $8e29fc57e38c5c41$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $8e29fc57e38c5c41$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $8e29fc57e38c5c41$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $89284a9272570c0b$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        $8e29fc57e38c5c41$var$schedule(this);
        return (0, $89284a9272570c0b$export$87b462129af3b7d4).prototype.set.call(this, key, value);
    };
    return cache;
};
var $8e29fc57e38c5c41$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $169b970ce932f843$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        $8e29fc57e38c5c41$var$schedule(this);
        return (0, $169b970ce932f843$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
    };
    return cache;
};



var $ec5f72070599e7f6$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $ec5f72070599e7f6$export$f29926b23b28936b = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, (0, $a9d4b6985b788da6$export$2e2bcd8739ae039)[$ec5f72070599e7f6$var$cacheSizeSymbol]);




var $d169a8b9aeea29e8$var$globalCaches = {};
function $d169a8b9aeea29e8$export$a8fcd406d9e37621(name, getSize) {
    $d169a8b9aeea29e8$var$globalCaches[name] = getSize;
}
var $d169a8b9aeea29e8$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $d169a8b9aeea29e8$var$_getApolloClientMemoryInternals : undefined;
var $d169a8b9aeea29e8$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $d169a8b9aeea29e8$var$_getInMemoryCacheMemoryInternals : undefined;
var $d169a8b9aeea29e8$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $d169a8b9aeea29e8$var$_getApolloCacheMemoryInternals : undefined;
function $d169a8b9aeea29e8$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $ec5f72070599e7f6$export$f29926b23b28936b)[k] || v
        ];
    }));
}
function $d169a8b9aeea29e8$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $d169a8b9aeea29e8$var$getCurrentCacheSizes(),
        sizes: (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({
            print: (_a = $d169a8b9aeea29e8$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($d169a8b9aeea29e8$var$globalCaches),
            parser: (_b = $d169a8b9aeea29e8$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($d169a8b9aeea29e8$var$globalCaches),
            canonicalStringify: (_c = $d169a8b9aeea29e8$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($d169a8b9aeea29e8$var$globalCaches),
            links: $d169a8b9aeea29e8$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $d169a8b9aeea29e8$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $d169a8b9aeea29e8$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $d169a8b9aeea29e8$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $d169a8b9aeea29e8$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, $d169a8b9aeea29e8$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $d169a8b9aeea29e8$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $d169a8b9aeea29e8$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $d169a8b9aeea29e8$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $d169a8b9aeea29e8$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $d169a8b9aeea29e8$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $d169a8b9aeea29e8$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $d169a8b9aeea29e8$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $d169a8b9aeea29e8$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $d169a8b9aeea29e8$var$getWrapperInformation(f) {
    return $d169a8b9aeea29e8$var$isWrapper(f) ? f.size : undefined;
}
function $d169a8b9aeea29e8$var$isDefined(value) {
    return value != null;
}
function $d169a8b9aeea29e8$var$transformInfo(transform) {
    return $d169a8b9aeea29e8$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $d169a8b9aeea29e8$var$recurseTransformInfo(transform) {
    return transform ? (0, $5c2a37736a53c5f6$export$1216008129fb82ed)((0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
        $d169a8b9aeea29e8$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $d169a8b9aeea29e8$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $d169a8b9aeea29e8$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($d169a8b9aeea29e8$var$isDefined) : [];
}
function $d169a8b9aeea29e8$var$linkInfo(link) {
    var _a;
    return link ? (0, $5c2a37736a53c5f6$export$1216008129fb82ed)((0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $d169a8b9aeea29e8$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $d169a8b9aeea29e8$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($d169a8b9aeea29e8$var$isDefined) : [];
}


var $7b2abb9cdc1dc3a0$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $7b2abb9cdc1dc3a0$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $7b2abb9cdc1dc3a0$var$sortingMap = new (0, $8e29fc57e38c5c41$export$5b4f745137d91413)((0, $ec5f72070599e7f6$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $d169a8b9aeea29e8$export$a8fcd406d9e37621)("canonicalStringify", function() {
    return $7b2abb9cdc1dc3a0$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $7b2abb9cdc1dc3a0$var$sortingMap;
$7b2abb9cdc1dc3a0$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $7b2abb9cdc1dc3a0$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($7b2abb9cdc1dc3a0$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $7b2abb9cdc1dc3a0$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $7b2abb9cdc1dc3a0$var$sortingMap.get(sortedKey) || keys;
                $7b2abb9cdc1dc3a0$var$sortingMap.set(unsortedKey, sortedKeys);
                $7b2abb9cdc1dc3a0$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $7b2abb9cdc1dc3a0$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}


function $4ea8a38c7ff48415$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $4ea8a38c7ff48415$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $4ea8a38c7ff48415$export$540432d49fcec6c9(value) {
    return (0, $1937899ec4a35235$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $4ea8a38c7ff48415$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $4ea8a38c7ff48415$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $4ea8a38c7ff48415$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $4ea8a38c7ff48415$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $4ea8a38c7ff48415$var$isVariable(value) {
    return value.kind === "Variable";
}
function $4ea8a38c7ff48415$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $4ea8a38c7ff48415$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $4ea8a38c7ff48415$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $4ea8a38c7ff48415$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $4ea8a38c7ff48415$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($4ea8a38c7ff48415$var$isIntValue(value) || $4ea8a38c7ff48415$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($4ea8a38c7ff48415$var$isBooleanValue(value) || $4ea8a38c7ff48415$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($4ea8a38c7ff48415$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $4ea8a38c7ff48415$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($4ea8a38c7ff48415$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($4ea8a38c7ff48415$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $4ea8a38c7ff48415$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($4ea8a38c7ff48415$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($4ea8a38c7ff48415$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(82, name.value, value.kind);
}
function $4ea8a38c7ff48415$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $4ea8a38c7ff48415$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $4ea8a38c7ff48415$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $4ea8a38c7ff48415$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $4ea8a38c7ff48415$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $4ea8a38c7ff48415$var$storeKeyNameStringify = (0, $7b2abb9cdc1dc3a0$export$88a0ad9b6f961b51);
var $4ea8a38c7ff48415$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($4ea8a38c7ff48415$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $4ea8a38c7ff48415$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($4ea8a38c7ff48415$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($4ea8a38c7ff48415$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $4ea8a38c7ff48415$var$storeKeyNameStringify;
        $4ea8a38c7ff48415$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $4ea8a38c7ff48415$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $4ea8a38c7ff48415$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $4ea8a38c7ff48415$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $4ea8a38c7ff48415$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($4ea8a38c7ff48415$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$4ea8a38c7ff48415$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $4ea8a38c7ff48415$export$cf7bf7e4f289cc26(result, (0, $28a2319727232c81$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $4ea8a38c7ff48415$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $4ea8a38c7ff48415$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $733ac22812c6d269$export$a7d0d8111d2386df(doc) {
    (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(doc && doc.kind === "Document", 74);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(75, definition.kind);
        return definition;
    });
    (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(operations.length <= 1, 76, operations.length);
    return doc;
}
function $733ac22812c6d269$export$7a5b1fa979d2c158(doc) {
    $733ac22812c6d269$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $733ac22812c6d269$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $733ac22812c6d269$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $733ac22812c6d269$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $733ac22812c6d269$export$7a5b1fa979d2c158(doc);
    (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 77);
    return queryDef;
}
function $733ac22812c6d269$export$772111caef41b3f5(doc) {
    (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(doc.kind === "Document", 78);
    (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(doc.definitions.length <= 1, 79);
    var fragmentDef = doc.definitions[0];
    (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 80);
    return fragmentDef;
}
function $733ac22812c6d269$export$f431198736b7f96d(queryDoc) {
    $733ac22812c6d269$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(81);
}
function $733ac22812c6d269$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $4ea8a38c7ff48415$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $cec70e864559c5ea$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $733ac22812c6d269$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $563d64be7db3a28f$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(43, key);
    }
    return operation;
}


function $9cac3fd081aed538$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of();
}
function $9cac3fd081aed538$var$toLink(handler) {
    return typeof handler === "function" ? new $9cac3fd081aed538$export$2fed3d61f740bc7f(handler) : handler;
}
function $9cac3fd081aed538$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $9cac3fd081aed538$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($9cac3fd081aed538$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $9cac3fd081aed538$var$toLink(left);
        var rightLink = $9cac3fd081aed538$var$toLink(right || new ApolloLink($9cac3fd081aed538$var$passthrough));
        var ret;
        if ($9cac3fd081aed538$var$isTerminating(leftLink) && $9cac3fd081aed538$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $5d3688c4fff158a7$export$f29bedd62f56fcb2)(operation.context, (0, $cec70e864559c5ea$export$4f3f7df1b558c729)((0, $563d64be7db3a28f$export$a92a48117d546c9)(operation)))) || (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $9cac3fd081aed538$var$toLink(first);
        if ($9cac3fd081aed538$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(35, firstLink);
            return firstLink;
        }
        var nextLink = $9cac3fd081aed538$var$toLink(second);
        var ret;
        if ($9cac3fd081aed538$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of();
            }) || (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of();
            }) || (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($9cac3fd081aed538$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(36);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $d021482990d49d37$export$51396ec711da548b = (0, $9cac3fd081aed538$export$2fed3d61f740bc7f).execute;









function $459105d9452f06b2$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $b2c739a511a84f33$var$MAX_ARRAY_LENGTH = 10;
const $b2c739a511a84f33$var$MAX_RECURSIVE_DEPTH = 2;
function $b2c739a511a84f33$export$9dec5d1b3b6a130d(value) {
    return $b2c739a511a84f33$var$formatValue(value, []);
}
function $b2c739a511a84f33$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $b2c739a511a84f33$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $b2c739a511a84f33$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($b2c739a511a84f33$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $b2c739a511a84f33$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $b2c739a511a84f33$var$formatArray(value, seenValues);
    return $b2c739a511a84f33$var$formatObject(value, seenValues);
}
function $b2c739a511a84f33$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $b2c739a511a84f33$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $b2c739a511a84f33$var$MAX_RECURSIVE_DEPTH) return '[' + $b2c739a511a84f33$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $b2c739a511a84f33$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $b2c739a511a84f33$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $b2c739a511a84f33$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($b2c739a511a84f33$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($b2c739a511a84f33$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $b2c739a511a84f33$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $da9fa5e591be44e0$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $da9fa5e591be44e0$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $da9fa5e591be44e0$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $da9fa5e591be44e0$var$kindValues = new Set(Object.keys($da9fa5e591be44e0$export$4fcd777a40ccf407));
function $da9fa5e591be44e0$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $da9fa5e591be44e0$var$kindValues.has(maybeKind);
}
/** Name */ var $da9fa5e591be44e0$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($da9fa5e591be44e0$export$f58c50edb4aef9d4 || ($da9fa5e591be44e0$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed kind values for AST nodes.
 */ var $753e21ebe0b0b700$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($753e21ebe0b0b700$export$a84bdc57c5122798 || ($753e21ebe0b0b700$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 

const $eae79035baa6cc4b$export$a89c95c098ac2a58 = Object.freeze({});
function $eae79035baa6cc4b$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $da9fa5e591be44e0$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $753e21ebe0b0b700$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $eae79035baa6cc4b$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $da9fa5e591be44e0$export$8ee0fc9ee280b4ee)(node) || (0, $459105d9452f06b2$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $b2c739a511a84f33$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $eae79035baa6cc4b$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $da9fa5e591be44e0$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $eae79035baa6cc4b$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $753e21ebe0b0b700$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $eae79035baa6cc4b$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $eae79035baa6cc4b$export$a89c95c098ac2a58) skipping[i] = $eae79035baa6cc4b$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $eae79035baa6cc4b$export$a89c95c098ac2a58) skipping[i] = $eae79035baa6cc4b$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $eae79035baa6cc4b$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $eae79035baa6cc4b$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $eae79035baa6cc4b$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $1d23945e8dc67f21$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $1d23945e8dc67f21$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(evaledValue !== void 0, 67, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $1d23945e8dc67f21$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $1d23945e8dc67f21$export$528b5e7d8ba07fbf = function(names, root) {
    return $1d23945e8dc67f21$export$2dafb573e282fe8d(names, root, false);
};
var $1d23945e8dc67f21$export$ad1b63b26c1a9b76 = function(names, root) {
    return $1d23945e8dc67f21$export$2dafb573e282fe8d(names, root, true);
};
function $1d23945e8dc67f21$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $eae79035baa6cc4b$export$a89c95c098ac2a58;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $1d23945e8dc67f21$export$8d1e9e5bbfa5d09a(document) {
    return document && $1d23945e8dc67f21$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $1d23945e8dc67f21$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $1d23945e8dc67f21$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$1d23945e8dc67f21$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 68, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 69, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 70, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}







// A version of Array.isArray that works better with readonly arrays.
var $03017244ed48560d$export$43bee75e5e14138e = Array.isArray;
function $03017244ed48560d$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}


var $b38df9efe4e75320$var$TYPENAME_FIELD = {
    kind: (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $753e21ebe0b0b700$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $b38df9efe4e75320$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FRAGMENT_SPREAD && $b38df9efe4e75320$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $b38df9efe4e75320$var$nullIfDocIsEmpty(doc) {
    return $b38df9efe4e75320$var$isEmpty((0, $733ac22812c6d269$export$7a5b1fa979d2c158)(doc) || (0, $733ac22812c6d269$export$772111caef41b3f5)(doc), (0, $28a2319727232c81$export$193789b4c8246dd4)((0, $733ac22812c6d269$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $b38df9efe4e75320$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $b38df9efe4e75320$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $b38df9efe4e75320$export$e5ae0530da5fe96c(directives, doc) {
    (0, $733ac22812c6d269$export$a7d0d8111d2386df)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $b38df9efe4e75320$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $b38df9efe4e75320$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $03017244ed48560d$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).error(83);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $b38df9efe4e75320$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $03017244ed48560d$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $b38df9efe4e75320$var$nullIfDocIsEmpty((0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $b38df9efe4e75320$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $4ea8a38c7ff48415$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $4ea8a38c7ff48415$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $5c2a37736a53c5f6$export$1216008129fb82ed)((0, $5c2a37736a53c5f6$export$1216008129fb82ed)([], selections, true), [
                        $b38df9efe4e75320$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $b38df9efe4e75320$var$TYPENAME_FIELD;
    }
});
var $b38df9efe4e75320$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(84);
        }
        return willRemove;
    }
};
function $b38df9efe4e75320$export$74985f3324559867(doc) {
    return $b38df9efe4e75320$export$e5ae0530da5fe96c([
        $b38df9efe4e75320$var$connectionRemoveConfig
    ], (0, $733ac22812c6d269$export$a7d0d8111d2386df)(doc));
}
function $b38df9efe4e75320$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $b38df9efe4e75320$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $b38df9efe4e75320$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $4ea8a38c7ff48415$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($b38df9efe4e75320$var$getDirectiveMatcher(directives)) || nestedCheck && $b38df9efe4e75320$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $b38df9efe4e75320$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $b38df9efe4e75320$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $b38df9efe4e75320$var$getArgumentMatcher(config);
    return $b38df9efe4e75320$var$nullIfDocIsEmpty((0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $b38df9efe4e75320$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $b38df9efe4e75320$var$nullIfDocIsEmpty((0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $b38df9efe4e75320$export$57c368c23873f32b(document) {
    var definition = (0, $733ac22812c6d269$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $b38df9efe4e75320$export$8eae69e876ee321e(document) {
    (0, $733ac22812c6d269$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $b38df9efe4e75320$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}



var $4e0c106dff0688c3$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $0489aed6bc3d2ffd$export$3991762405098ea)(39, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $543770453340b5f6$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};



/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
var $e508a8b27183dcee$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !(0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product == "ReactNative" && !$parcel$global.HermesInternal;
});
var $e508a8b27183dcee$export$7293b8a0b474028d = typeof WeakSet === "function";
var $e508a8b27183dcee$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $e508a8b27183dcee$export$c34f882e9f1c1637 = $e508a8b27183dcee$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $e508a8b27183dcee$export$71594e8a50f746f4 = typeof (0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $e508a8b27183dcee$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $e508a8b27183dcee$export$4001f6cd4a62405b = $e508a8b27183dcee$export$71594e8a50f746f4 && !$e508a8b27183dcee$var$usingJSDOM;


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $9437085da30dbdfe$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
function $953a3939d4694b55$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $e508a8b27183dcee$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
function $73012d61999f88b1$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $e508a8b27183dcee$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
function $094cfede3f643d60$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $e508a8b27183dcee$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $36f76f302faf6ed5$var$isNodeResponse(value) {
    return !!value.body;
}
function $36f76f302faf6ed5$var$isReadableStream(value) {
    return !!value.getReader;
}
function $36f76f302faf6ed5$var$isAsyncIterableIterator(value) {
    return !!((0, $e508a8b27183dcee$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $36f76f302faf6ed5$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $36f76f302faf6ed5$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $36f76f302faf6ed5$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $36f76f302faf6ed5$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($36f76f302faf6ed5$var$isNodeResponse(response)) body = response.body;
    if ($36f76f302faf6ed5$var$isAsyncIterableIterator(body)) return (0, $9437085da30dbdfe$export$2e2bcd8739ae039)(body);
    if ($36f76f302faf6ed5$var$isReadableStream(body)) return (0, $094cfede3f643d60$export$2e2bcd8739ae039)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($36f76f302faf6ed5$var$isStreamableBlob(body)) return (0, $094cfede3f643d60$export$2e2bcd8739ae039)(body.stream().getReader());
    if ($36f76f302faf6ed5$var$isBlob(body)) return (0, $73012d61999f88b1$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ($36f76f302faf6ed5$var$isNodeReadableStream(body)) return (0, $953a3939d4694b55$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


var $35c2a169e6f34884$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};





var $21c12e1a9818ab2c$export$4995664c1b49842e = Symbol();
function $21c12e1a9818ab2c$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$21c12e1a9818ab2c$export$4995664c1b49842e]);
    return false;
}
function $21c12e1a9818ab2c$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $21c12e1a9818ab2c$var$generateErrorMessage = function(err) {
    var errors = (0, $5c2a37736a53c5f6$export$1216008129fb82ed)((0, $5c2a37736a53c5f6$export$1216008129fb82ed)((0, $5c2a37736a53c5f6$export$1216008129fb82ed)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $1937899ec4a35235$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $21c12e1a9818ab2c$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $21c12e1a9818ab2c$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);






var $082679cd84e94918$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $082679cd84e94918$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $082679cd84e94918$export$160070228be94b08(sources);
}
function $082679cd84e94918$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $082679cd84e94918$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $082679cd84e94918$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $082679cd84e94918$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $082679cd84e94918$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $1937899ec4a35235$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $1937899ec4a35235$export$417207af72fad9c9)(source) && (0, $1937899ec4a35235$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($082679cd84e94918$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $1937899ec4a35235$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $55294d24f844c965$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $55294d24f844c965$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $55294d24f844c965$export$f90dc0a3531b8b83(value) {
    return $55294d24f844c965$export$879767c5cdf33cb3(value) || $55294d24f844c965$export$6c17a45d8c64ff02(value);
}
function $55294d24f844c965$export$3f32b6369f408f33(value) {
    return (0, $1937899ec4a35235$export$417207af72fad9c9)(value) && "payload" in value;
}
function $55294d24f844c965$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $082679cd84e94918$export$509e11c221f576c0)();
    if ($55294d24f844c965$export$879767c5cdf33cb3(result) && (0, $03017244ed48560d$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $dabf929067d3ecb2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $dabf929067d3ecb2$export$ccb60864026baf09(response, nextValue) {
    return (0, $5c2a37736a53c5f6$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $5c2a37736a53c5f6$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $36f76f302faf6ed5$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $dabf929067d3ecb2$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $dabf929067d3ecb2$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $55294d24f844c965$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, next), {
                                        extensions: (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $21c12e1a9818ab2c$export$4995664c1b49842e] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $dabf929067d3ecb2$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $dabf929067d3ecb2$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $35c2a169e6f34884$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $dabf929067d3ecb2$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $dabf929067d3ecb2$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $dabf929067d3ecb2$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$dabf929067d3ecb2$var$hasOwnProperty.call(result, "data") && !$dabf929067d3ecb2$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $35c2a169e6f34884$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $2233fa72b80049b6$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(37);
};



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $17f85b64b3eb9a60$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $17f85b64b3eb9a60$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $17f85b64b3eb9a60$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $17f85b64b3eb9a60$export$45a677ea7cb6d5c8(code) {
    return $17f85b64b3eb9a60$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $17f85b64b3eb9a60$export$d3f406ff46035894(code) {
    return $17f85b64b3eb9a60$export$79c5d5217943d6a7(code) || $17f85b64b3eb9a60$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $d24bcac2e4a322c7$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $d24bcac2e4a322c7$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $d24bcac2e4a322c7$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $17f85b64b3eb9a60$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $d24bcac2e4a322c7$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $d24bcac2e4a322c7$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $17f85b64b3eb9a60$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $17f85b64b3eb9a60$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $dcb75688508c5702$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($dcb75688508c5702$var$escapedRegExp, $dcb75688508c5702$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $dcb75688508c5702$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $dcb75688508c5702$var$escapedReplacer(str) {
    return $dcb75688508c5702$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $dcb75688508c5702$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];



function $334563673236d995$export$c2d084dc44961371(ast) {
    return (0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(ast, $334563673236d995$var$printDocASTReducer);
}
const $334563673236d995$var$MAX_LINE_LENGTH = 80;
const $334563673236d995$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$334563673236d995$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $334563673236d995$var$wrap('(', $334563673236d995$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $334563673236d995$var$join([
                node.operation,
                $334563673236d995$var$join([
                    node.name,
                    varDefs
                ]),
                $334563673236d995$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $334563673236d995$var$wrap(' = ', defaultValue) + $334563673236d995$var$wrap(' ', $334563673236d995$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$334563673236d995$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $334563673236d995$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $334563673236d995$var$wrap('(', $334563673236d995$var$join(args, ', '), ')');
            if (argsLine.length > $334563673236d995$var$MAX_LINE_LENGTH) argsLine = prefix + $334563673236d995$var$wrap('(\n', $334563673236d995$var$indent($334563673236d995$var$join(args, '\n')), '\n)');
            return $334563673236d995$var$join([
                argsLine,
                $334563673236d995$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $334563673236d995$var$wrap(' ', $334563673236d995$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$334563673236d995$var$join([
                '...',
                $334563673236d995$var$wrap('on ', typeCondition),
                $334563673236d995$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$334563673236d995$var$wrap('(', $334563673236d995$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$334563673236d995$var$wrap('', $334563673236d995$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $d24bcac2e4a322c7$export$adb6ca997eeb1f45)(value) : (0, $dcb75688508c5702$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $334563673236d995$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $334563673236d995$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $334563673236d995$var$wrap('(', $334563673236d995$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$334563673236d995$var$wrap('', description, '\n') + $334563673236d995$var$join([
                'schema',
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$334563673236d995$var$wrap('', description, '\n') + $334563673236d995$var$join([
                'scalar',
                name,
                $334563673236d995$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$334563673236d995$var$wrap('', description, '\n') + $334563673236d995$var$join([
                'type',
                name,
                $334563673236d995$var$wrap('implements ', $334563673236d995$var$join(interfaces, ' & ')),
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$334563673236d995$var$wrap('', description, '\n') + name + ($334563673236d995$var$hasMultilineItems(args) ? $334563673236d995$var$wrap('(\n', $334563673236d995$var$indent($334563673236d995$var$join(args, '\n')), '\n)') : $334563673236d995$var$wrap('(', $334563673236d995$var$join(args, ', '), ')')) + ': ' + type + $334563673236d995$var$wrap(' ', $334563673236d995$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$334563673236d995$var$wrap('', description, '\n') + $334563673236d995$var$join([
                name + ': ' + type,
                $334563673236d995$var$wrap('= ', defaultValue),
                $334563673236d995$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$334563673236d995$var$wrap('', description, '\n') + $334563673236d995$var$join([
                'interface',
                name,
                $334563673236d995$var$wrap('implements ', $334563673236d995$var$join(interfaces, ' & ')),
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$334563673236d995$var$wrap('', description, '\n') + $334563673236d995$var$join([
                'union',
                name,
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$wrap('= ', $334563673236d995$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$334563673236d995$var$wrap('', description, '\n') + $334563673236d995$var$join([
                'enum',
                name,
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$334563673236d995$var$wrap('', description, '\n') + $334563673236d995$var$join([
                name,
                $334563673236d995$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$334563673236d995$var$wrap('', description, '\n') + $334563673236d995$var$join([
                'input',
                name,
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$334563673236d995$var$wrap('', description, '\n') + 'directive @' + name + ($334563673236d995$var$hasMultilineItems(args) ? $334563673236d995$var$wrap('(\n', $334563673236d995$var$indent($334563673236d995$var$join(args, '\n')), '\n)') : $334563673236d995$var$wrap('(', $334563673236d995$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $334563673236d995$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$334563673236d995$var$join([
                'extend schema',
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$334563673236d995$var$join([
                'extend scalar',
                name,
                $334563673236d995$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$334563673236d995$var$join([
                'extend type',
                name,
                $334563673236d995$var$wrap('implements ', $334563673236d995$var$join(interfaces, ' & ')),
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$334563673236d995$var$join([
                'extend interface',
                name,
                $334563673236d995$var$wrap('implements ', $334563673236d995$var$join(interfaces, ' & ')),
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$334563673236d995$var$join([
                'extend union',
                name,
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$wrap('= ', $334563673236d995$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$334563673236d995$var$join([
                'extend enum',
                name,
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$334563673236d995$var$join([
                'extend input',
                name,
                $334563673236d995$var$join(directives, ' '),
                $334563673236d995$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $334563673236d995$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $334563673236d995$var$block(array) {
    return $334563673236d995$var$wrap('{\n', $334563673236d995$var$indent($334563673236d995$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $334563673236d995$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $334563673236d995$var$indent(str) {
    return $334563673236d995$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $334563673236d995$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}




var $99d11c6192bbecaf$var$printCache;
var $99d11c6192bbecaf$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $99d11c6192bbecaf$var$printCache.get(ast);
    if (!result) {
        result = (0, $334563673236d995$export$c2d084dc44961371)(ast);
        $99d11c6192bbecaf$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $99d11c6192bbecaf$var$printCache = new (0, $8e29fc57e38c5c41$export$8dbad6f439bb2331)((0, $ec5f72070599e7f6$export$f29926b23b28936b).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$99d11c6192bbecaf$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $d169a8b9aeea29e8$export$a8fcd406d9e37621)("print", function() {
    return $99d11c6192bbecaf$var$printCache ? $99d11c6192bbecaf$var$printCache.size : 0;
});


var $463e9b051953ad70$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $463e9b051953ad70$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $463e9b051953ad70$var$defaultOptions = {
    method: "POST"
};
var $463e9b051953ad70$export$dd86f00dc866e75d = {
    http: $463e9b051953ad70$var$defaultHttpOptions,
    headers: $463e9b051953ad70$var$defaultHeaders,
    options: $463e9b051953ad70$var$defaultOptions
};
var $463e9b051953ad70$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $463e9b051953ad70$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $463e9b051953ad70$export$12d90ccf75844275.apply(void 0, (0, $5c2a37736a53c5f6$export$1216008129fb82ed)([
        operation,
        $463e9b051953ad70$export$e88934976ca4fd65
    ], configs, false));
}
function $463e9b051953ad70$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, http), config.http);
    });
    if (options.headers) options.headers = $463e9b051953ad70$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $99d11c6192bbecaf$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $463e9b051953ad70$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}



function $893a66785a3aba3b$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $4e0c106dff0688c3$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $4e0c106dff0688c3$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}




function $9f0c1f2ff705a6c0$export$de246493ae27fe3f(variables, query) {
    var result = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}


function $5eb47f061b39dd9e$export$4fd972edbe7450d3(errorValue) {
    return new (0, $02cae19fe6259dbb$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $823dcae61181c620$var$backupFetch = (0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $823dcae61181c620$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $463e9b051953ad70$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $5c2a37736a53c5f6$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $2233fa72b80049b6$export$8423f0cd3773115e)(preferredFetch || $823dcae61181c620$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $9cac3fd081aed538$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $543770453340b5f6$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $1d23945e8dc67f21$export$2dafb573e282fe8d)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, $b38df9efe4e75320$export$8eae69e876ee321e)(operation.query);
            if (!transformedQuery) return (0, $5eb47f061b39dd9e$export$4fd972edbe7450d3)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $463e9b051953ad70$export$12d90ccf75844275)(operation, print, (0, $463e9b051953ad70$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $9f0c1f2ff705a6c0$export$de246493ae27fe3f)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $733ac22812c6d269$export$f431198736b7f96d)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $1d23945e8dc67f21$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(38);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $893a66785a3aba3b$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $5eb47f061b39dd9e$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $4e0c106dff0688c3$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $5eb47f061b39dd9e$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $02cae19fe6259dbb$export$77cea355fa80b5f4)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $d60ad807eacd6810$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $823dcae61181c620$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $dabf929067d3ecb2$export$ccb60864026baf09)(response, observerNext);
                else return (0, $dabf929067d3ecb2$export$d4051215bea0639f)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $dabf929067d3ecb2$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};


var $8f19175dc3cc846d$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $823dcae61181c620$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $9cac3fd081aed538$export$2fed3d61f740bc7f));




const { toString: $f316d589362b7354$var$toString, hasOwnProperty: $f316d589362b7354$var$hasOwnProperty } = Object.prototype;
const $f316d589362b7354$var$fnToStr = Function.prototype.toString;
const $f316d589362b7354$var$previousComparisons = new Map();
function $f316d589362b7354$export$411ce8e5a71e3069(a, b) {
    try {
        return $f316d589362b7354$var$check(a, b);
    } finally{
        $f316d589362b7354$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$f316d589362b7354$export$2e2bcd8739ae039 = $f316d589362b7354$export$411ce8e5a71e3069;
function $f316d589362b7354$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $f316d589362b7354$var$toString.call(a);
    const bTag = $f316d589362b7354$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($f316d589362b7354$var$previouslyCompared(a, b)) return true;
                const aKeys = $f316d589362b7354$var$definedKeys(a);
                const bKeys = $f316d589362b7354$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$f316d589362b7354$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$f316d589362b7354$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($f316d589362b7354$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$f316d589362b7354$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $f316d589362b7354$var$fnToStr.call(a);
                if (aCode !== $f316d589362b7354$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$f316d589362b7354$var$endsWith(aCode, $f316d589362b7354$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $f316d589362b7354$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($f316d589362b7354$var$isDefinedKey, obj);
}
function $f316d589362b7354$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $f316d589362b7354$var$nativeCodeSuffix = "{ [native code] }";
function $f316d589362b7354$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $f316d589362b7354$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $f316d589362b7354$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $f316d589362b7354$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}




function $b6244fd9c7dca117$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $02cae19fe6259dbb$export$77cea355fa80b5f4)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}



function $241e2425b7a386b1$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}




function $32179e4a64722fd4$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $02cae19fe6259dbb$export$77cea355fa80b5f4)
        });
    }
    if ((0, $e508a8b27183dcee$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}


function $6c4421b0c117868e$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $6c4421b0c117868e$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $241e2425b7a386b1$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $241e2425b7a386b1$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $241e2425b7a386b1$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($6c4421b0c117868e$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $02cae19fe6259dbb$export$77cea355fa80b5f4)(sources)
        ];
        if ($6c4421b0c117868e$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $02cae19fe6259dbb$export$77cea355fa80b5f4));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $32179e4a64722fd4$export$33c8bd820eece9b2)($6c4421b0c117868e$export$ae0cf2ec7a6fa78e);

// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $dd03b6e925874374$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $dd03b6e925874374$var$forEach, slice: $dd03b6e925874374$var$slice } = Array.prototype;
const { hasOwnProperty: $dd03b6e925874374$var$hasOwnProperty } = Object.prototype;
class $dd03b6e925874374$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $dd03b6e925874374$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $dd03b6e925874374$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $dd03b6e925874374$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($dd03b6e925874374$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($dd03b6e925874374$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $dd03b6e925874374$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $dd03b6e925874374$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $dd03b6e925874374$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}






// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $8e0049d63073c1ca$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $8e0049d63073c1ca$var$forEach, slice: $8e0049d63073c1ca$var$slice } = Array.prototype;
const { hasOwnProperty: $8e0049d63073c1ca$var$hasOwnProperty } = Object.prototype;
class $8e0049d63073c1ca$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $8e0049d63073c1ca$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        $8e0049d63073c1ca$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $8e0049d63073c1ca$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($8e0049d63073c1ca$var$slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = this.weakness && $8e0049d63073c1ca$var$isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && $8e0049d63073c1ca$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child) map.set(key, child = new $8e0049d63073c1ca$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
}
function $8e0049d63073c1ca$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}



// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $2e19f052d204b2c3$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $2e19f052d204b2c3$var$MISSING_VALUE = {};
let $2e19f052d204b2c3$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $2e19f052d204b2c3$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $2e19f052d204b2c3$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $2e19f052d204b2c3$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $2e19f052d204b2c3$var$MISSING_VALUE) break;
                if (context !== $2e19f052d204b2c3$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $2e19f052d204b2c3$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($2e19f052d204b2c3$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $2e19f052d204b2c3$var$currentContext.slots[this.id] = $2e19f052d204b2c3$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $2e19f052d204b2c3$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $2e19f052d204b2c3$var$currentContext;
            $2e19f052d204b2c3$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $2e19f052d204b2c3$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $2e19f052d204b2c3$var$currentContext;
            return function() {
                const saved = $2e19f052d204b2c3$var$currentContext;
                try {
                    $2e19f052d204b2c3$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $2e19f052d204b2c3$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($2e19f052d204b2c3$var$currentContext) {
                const saved = $2e19f052d204b2c3$var$currentContext;
                try {
                    $2e19f052d204b2c3$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $2e19f052d204b2c3$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $2e19f052d204b2c3$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $2e19f052d204b2c3$var$globalKey = "@wry/context:Slot";
const $2e19f052d204b2c3$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$2e19f052d204b2c3$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$2e19f052d204b2c3$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $2e19f052d204b2c3$var$globalHost = $2e19f052d204b2c3$var$host;
const $2e19f052d204b2c3$export$8c6ed5c666ac1360 = $2e19f052d204b2c3$var$globalHost[$2e19f052d204b2c3$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$2e19f052d204b2c3$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($2e19f052d204b2c3$var$globalHost, $2e19f052d204b2c3$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($2e19f052d204b2c3$var$makeSlotClass());


const { bind: $25062c15c6188225$export$2385a24977818dd0, noContext: $25062c15c6188225$export$9fa6f2e300a97f8 } = (0, $2e19f052d204b2c3$export$8c6ed5c666ac1360);
function $25062c15c6188225$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($25062c15c6188225$export$2385a24977818dd0(callback), delay);
}
function $25062c15c6188225$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $25062c15c6188225$export$2385a24977818dd0(gen.next);
        const boundThrow = $25062c15c6188225$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($25062c15c6188225$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $25062c15c6188225$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $25062c15c6188225$var$wrappedFibers = [];
function $25062c15c6188225$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($25062c15c6188225$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $25062c15c6188225$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $25062c15c6188225$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $a50b4bb16dc4a8c7$export$11fa9682b6ba79b1 = new (0, $2e19f052d204b2c3$export$8c6ed5c666ac1360)();
function $a50b4bb16dc4a8c7$export$d906efd39458576(fn) {
    return $a50b4bb16dc4a8c7$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $2a45e03bcc0f4aa3$export$5a15a386532a5ea4 } = Object.prototype;
const $2a45e03bcc0f4aa3$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $2a45e03bcc0f4aa3$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $e603e7eaf9df76ac$var$emptySetPool = [];
const $e603e7eaf9df76ac$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $e603e7eaf9df76ac$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $e603e7eaf9df76ac$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $e603e7eaf9df76ac$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $e603e7eaf9df76ac$var$valueCopy(value) {
    return value.slice(0);
}
class $e603e7eaf9df76ac$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$e603e7eaf9df76ac$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$e603e7eaf9df76ac$var$mightBeDirty(this)) {
            $e603e7eaf9df76ac$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $e603e7eaf9df76ac$var$assert(!this.recomputing, "already recomputing");
        $e603e7eaf9df76ac$var$rememberParent(this);
        return $e603e7eaf9df76ac$var$mightBeDirty(this) ? $e603e7eaf9df76ac$var$reallyRecompute(this, args) : $e603e7eaf9df76ac$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $e603e7eaf9df76ac$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $2a45e03bcc0f4aa3$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $e603e7eaf9df76ac$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $e603e7eaf9df76ac$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $e603e7eaf9df76ac$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $e603e7eaf9df76ac$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $2a45e03bcc0f4aa3$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $e603e7eaf9df76ac$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$e603e7eaf9df76ac$export$3bb977b3ba9d3b59.count = 0;
function $e603e7eaf9df76ac$var$rememberParent(child) {
    const parent = (0, $a50b4bb16dc4a8c7$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($e603e7eaf9df76ac$var$mightBeDirty(child)) $e603e7eaf9df76ac$var$reportDirtyChild(parent, child);
        else $e603e7eaf9df76ac$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $e603e7eaf9df76ac$var$reallyRecompute(entry, args) {
    $e603e7eaf9df76ac$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $a50b4bb16dc4a8c7$export$11fa9682b6ba79b1).withValue(entry, $e603e7eaf9df76ac$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($e603e7eaf9df76ac$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $e603e7eaf9df76ac$var$setClean(entry);
    return $e603e7eaf9df76ac$var$valueGet(entry.value);
}
function $e603e7eaf9df76ac$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $e603e7eaf9df76ac$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$e603e7eaf9df76ac$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $e603e7eaf9df76ac$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $e603e7eaf9df76ac$var$setClean(entry) {
    entry.dirty = false;
    if ($e603e7eaf9df76ac$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $e603e7eaf9df76ac$var$reportClean(entry);
}
function $e603e7eaf9df76ac$var$reportDirty(child) {
    $e603e7eaf9df76ac$var$eachParent(child, $e603e7eaf9df76ac$var$reportDirtyChild);
}
function $e603e7eaf9df76ac$var$reportClean(child) {
    $e603e7eaf9df76ac$var$eachParent(child, $e603e7eaf9df76ac$var$reportCleanChild);
}
function $e603e7eaf9df76ac$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $2a45e03bcc0f4aa3$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $e603e7eaf9df76ac$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $e603e7eaf9df76ac$var$assert(parent.childValues.has(child));
    $e603e7eaf9df76ac$var$assert($e603e7eaf9df76ac$var$mightBeDirty(child));
    const parentWasClean = !$e603e7eaf9df76ac$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $e603e7eaf9df76ac$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $e603e7eaf9df76ac$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $e603e7eaf9df76ac$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $e603e7eaf9df76ac$var$assert(parent.childValues.has(child));
    $e603e7eaf9df76ac$var$assert(!$e603e7eaf9df76ac$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $e603e7eaf9df76ac$var$valueCopy(child.value));
    else if (!$e603e7eaf9df76ac$var$valueIs(childValue, child.value)) parent.setDirty();
    $e603e7eaf9df76ac$var$removeDirtyChild(parent, child);
    if ($e603e7eaf9df76ac$var$mightBeDirty(parent)) return;
    $e603e7eaf9df76ac$var$reportClean(parent);
}
function $e603e7eaf9df76ac$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($e603e7eaf9df76ac$var$emptySetPool.length < $e603e7eaf9df76ac$var$POOL_TARGET_SIZE) $e603e7eaf9df76ac$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $e603e7eaf9df76ac$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $e603e7eaf9df76ac$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $e603e7eaf9df76ac$var$assert(parent.dirtyChildren === null);
}
function $e603e7eaf9df76ac$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $e603e7eaf9df76ac$var$removeDirtyChild(parent, child);
}
function $e603e7eaf9df76ac$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $2a45e03bcc0f4aa3$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $eeba3f635b2d6d0b$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $eeba3f635b2d6d0b$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $a50b4bb16dc4a8c7$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $2a45e03bcc0f4aa3$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $2a45e03bcc0f4aa3$export$5a15a386532a5ea4).call($eeba3f635b2d6d0b$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $2a45e03bcc0f4aa3$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $2a45e03bcc0f4aa3$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $790245ce44667f92$var$defaultKeyTrie;
function $790245ce44667f92$export$cd3144f8dd136006(...args) {
    const trie = $790245ce44667f92$var$defaultKeyTrie || ($790245ce44667f92$var$defaultKeyTrie = new (0, $8e0049d63073c1ca$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $790245ce44667f92$var$caches = new Set();
function $790245ce44667f92$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $790245ce44667f92$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $169b970ce932f843$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $e603e7eaf9df76ac$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $790245ce44667f92$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $a50b4bb16dc4a8c7$export$11fa9682b6ba79b1).hasValue()) {
            $790245ce44667f92$var$caches.forEach((cache)=>cache.clean());
            $790245ce44667f92$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



function $83c4d59f2c3d0de8$var$identity(document) {
    return document;
}
var $83c4d59f2c3d0de8$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $e508a8b27183dcee$export$7293b8a0b474028d) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($83c4d59f2c3d0de8$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $dd03b6e925874374$export$73571c50d0f2507e)((0, $e508a8b27183dcee$export$772fbc04a0ad4ce9));
            this.performWork = (0, $790245ce44667f92$export$4997ffc0176396a6)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(Array.isArray(cacheKeys), 66);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $ec5f72070599e7f6$export$f29926b23b28936b)["documentTransform.cache"],
                cache: (0, $89284a9272570c0b$export$87b462129af3b7d4)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $733ac22812c6d269$export$a7d0d8111d2386df)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();



function $e475fc2afb9e6506$export$b4df399e879e53ab(result) {
    var errors = $e475fc2afb9e6506$export$a163557155188b6e(result);
    return (0, $03017244ed48560d$export$d307f5934e447d0e)(errors);
}
function $e475fc2afb9e6506$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $03017244ed48560d$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $55294d24f844c965$export$879767c5cdf33cb3)(result) && (0, $03017244ed48560d$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}








/**
 * The current status of a query’s execution in our system.
 */ var $a7e449070b5220d2$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($a7e449070b5220d2$export$bd096ddbd246c79c || ($a7e449070b5220d2$export$bd096ddbd246c79c = {}));
function $a7e449070b5220d2$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $a7e449070b5220d2$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}


var $f5fe3d92b36126ea$var$toString = Object.prototype.toString;
function $f5fe3d92b36126ea$export$629a2bd3f5a49ecc(value) {
    return $f5fe3d92b36126ea$var$cloneDeepHelper(value);
}
function $f5fe3d92b36126ea$var$cloneDeepHelper(val, seen) {
    switch($f5fe3d92b36126ea$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $f5fe3d92b36126ea$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $f5fe3d92b36126ea$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $c7d8710b4a0f0a7f$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}





function $b0ca96d259b408f9$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $5c2a37736a53c5f6$export$3c9a16f847548506)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $5c2a37736a53c5f6$export$3c9a16f847548506)(_b, [
        "data"
    ]);
    return (0, $f316d589362b7354$export$2e2bcd8739ae039)(aRest, bRest) && $b0ca96d259b408f9$var$equalBySelectionSet((0, $733ac22812c6d269$export$f431198736b7f96d)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $28a2319727232c81$export$193789b4c8246dd4)((0, $733ac22812c6d269$export$5320a7ba9466a3df)(query)),
        variables: variables
    });
}
function $b0ca96d259b408f9$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $1d23945e8dc67f21$export$3dc388a5f013b4a5)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($b0ca96d259b408f9$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $4ea8a38c7ff48415$export$fb56ad75dd311c12)(selection)) {
            var resultKey = (0, $4ea8a38c7ff48415$export$7d1ad22471852218)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $f316d589362b7354$export$2e2bcd8739ae039)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$b0ca96d259b408f9$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $b0ca96d259b408f9$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $28a2319727232c81$export$f80bdb85f299186)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($b0ca96d259b408f9$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $b0ca96d259b408f9$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $b0ca96d259b408f9$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($b0ca96d259b408f9$var$directiveIsNonreactive);
}
function $b0ca96d259b408f9$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}


var $4c7daee63820cadb$var$assign = Object.assign, $4c7daee63820cadb$var$hasOwnProperty = Object.hasOwnProperty;
var $4c7daee63820cadb$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $4c7daee63820cadb$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $4c7daee63820cadb$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $733ac22812c6d269$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $a7e449070b5220d2$export$bd096ddbd246c79c).ready;
        var result = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $a7e449070b5220d2$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $4c7daee63820cadb$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $f316d589362b7354$export$411ce8e5a71e3069)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $a7e449070b5220d2$export$bd096ddbd246c79c).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $a7e449070b5220d2$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $4c7daee63820cadb$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !(0, $b0ca96d259b408f9$export$5e40714c5ad44445)(this.query, this.last.result, newResult, this.variables) : !(0, $f316d589362b7354$export$411ce8e5a71e3069)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $f316d589362b7354$export$411ce8e5a71e3069)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $f316d589362b7354$export$411ce8e5a71e3069)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $4c7daee63820cadb$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $733ac22812c6d269$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(20, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $f316d589362b7354$export$411ce8e5a71e3069)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $a7e449070b5220d2$export$bd096ddbd246c79c).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $a7e449070b5220d2$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $a7e449070b5220d2$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $a7e449070b5220d2$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (!updatedQuerySet.has(_this.query)) $4c7daee63820cadb$export$419171d60552792a(_this);
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).error(21, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $c7d8710b4a0f0a7f$export$8e16b83750b44988)(this.options, newOptions || {});
        $4c7daee63820cadb$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $f316d589362b7354$export$411ce8e5a71e3069)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $a7e449070b5220d2$export$bd096ddbd246c79c).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(pollInterval, 22);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $a7e449070b5220d2$export$37509604341a3464)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $a7e449070b5220d2$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $f316d589362b7354$export$411ce8e5a71e3069)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $f5fe3d92b36126ea$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $a7e449070b5220d2$export$bd096ddbd246c79c).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $a7e449070b5220d2$export$bd096ddbd246c79c).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $a7e449070b5220d2$export$bd096ddbd246c79c).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $c7d8710b4a0f0a7f$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $4c7daee63820cadb$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $f316d589362b7354$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $a7e449070b5220d2$export$bd096ddbd246c79c).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $4c7daee63820cadb$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $f316d589362b7354$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $f316d589362b7354$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $241e2425b7a386b1$export$9f6c99ae166dbeca)(this.observers, "next", result);
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $a7e449070b5220d2$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $241e2425b7a386b1$export$9f6c99ae166dbeca)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}((0, $02cae19fe6259dbb$export$77cea355fa80b5f4));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $32179e4a64722fd4$export$33c8bd820eece9b2)($4c7daee63820cadb$export$6c1b56eac59c9584);
function $4c7daee63820cadb$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(currentFetchPolicy, context) {
            // Replace this nextFetchPolicy function in the options object with the
            // original this.options.nextFetchPolicy value.
            this.nextFetchPolicy = nextFetchPolicy;
            // If the original nextFetchPolicy value was a function, give it a
            // chance to decide what happens here.
            if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
            // Otherwise go back to the original this.options.fetchPolicy.
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $4c7daee63820cadb$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).error(23, error.message, error.stack);
}
function $4c7daee63820cadb$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).debug(24, missing);
}
function $4c7daee63820cadb$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}






function $fff656c6ad75d9d4$export$e7ecd7c16613ccfd(node) {
    return $fff656c6ad75d9d4$export$4cedd8740794bd78(node) || $fff656c6ad75d9d4$export$b05c7141ec7770ba(node) || $fff656c6ad75d9d4$export$fbc18e88163d676d(node);
}
function $fff656c6ad75d9d4$export$4cedd8740794bd78(node) {
    return node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).OPERATION_DEFINITION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
}
function $fff656c6ad75d9d4$export$65772b71e1d017ba(node) {
    return node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FIELD || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FRAGMENT_SPREAD || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).INLINE_FRAGMENT;
}
function $fff656c6ad75d9d4$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).VARIABLE || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).INT || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FLOAT || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).STRING || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).BOOLEAN || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).NULL || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).ENUM || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).LIST || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).OBJECT;
}
function $fff656c6ad75d9d4$export$f95bfad9e6aea45f(node) {
    return $fff656c6ad75d9d4$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).LIST ? node.values.some($fff656c6ad75d9d4$export$f95bfad9e6aea45f) : node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).OBJECT ? node.fields.some((field)=>$fff656c6ad75d9d4$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $753e21ebe0b0b700$export$a84bdc57c5122798).VARIABLE);
}
function $fff656c6ad75d9d4$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).NAMED_TYPE || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).LIST_TYPE || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).NON_NULL_TYPE;
}
function $fff656c6ad75d9d4$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).SCHEMA_DEFINITION || $fff656c6ad75d9d4$export$a3584bba04f5bfe0(node) || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).DIRECTIVE_DEFINITION;
}
function $fff656c6ad75d9d4$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).UNION_TYPE_DEFINITION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION;
}
function $fff656c6ad75d9d4$export$fbc18e88163d676d(node) {
    return node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).SCHEMA_EXTENSION || $fff656c6ad75d9d4$export$d7907721b241e11f(node);
}
function $fff656c6ad75d9d4$export$d7907721b241e11f(node) {
    return node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).UNION_TYPE_EXTENSION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION || node.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION;
}




var $9fba573353f18c1e$export$ac9723609f5c76c2 = new (0, $2e19f052d204b2c3$export$8c6ed5c666ac1360)();
var $9fba573353f18c1e$var$cacheInfoMap = new WeakMap();
function $9fba573353f18c1e$var$getCacheInfo(cache) {
    var info = $9fba573353f18c1e$var$cacheInfoMap.get(cache);
    if (!info) $9fba573353f18c1e$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $eeba3f635b2d6d0b$export$c723b7eff9d8f870)()
    });
    return info;
}
function $9fba573353f18c1e$export$cbe12faed7725318(cache) {
    $9fba573353f18c1e$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $9fba573353f18c1e$export$f342bdd61b3e9412(cache) {
    $9fba573353f18c1e$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $9fba573353f18c1e$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $9fba573353f18c1e$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $9fba573353f18c1e$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $9fba573353f18c1e$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $9fba573353f18c1e$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $9fba573353f18c1e$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $9fba573353f18c1e$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


var $f6495e6f9dbd3da2$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $082679cd84e94918$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $082679cd84e94918$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        return (0, $5c2a37736a53c5f6$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return (0, $5c2a37736a53c5f6$export$67ebef60e6f28a6)(this, function(_d) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $1d23945e8dc67f21$export$2dafb573e282fe8d)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $b38df9efe4e75320$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document_1) {
        return (0, $5c2a37736a53c5f6$export$1050f835b63b671e)(this, arguments, void 0, function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, $5c2a37736a53c5f6$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $eae79035baa6cc4b$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $b38df9efe4e75320$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document_1, rootValue_1) {
        return (0, $5c2a37736a53c5f6$export$1050f835b63b671e)(this, arguments, void 0, function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, $5c2a37736a53c5f6$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $733ac22812c6d269$export$f431198736b7f96d)(document);
                fragments = (0, $733ac22812c6d269$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $28a2319727232c81$export$193789b4c8246dd4)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $5c2a37736a53c5f6$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $5c2a37736a53c5f6$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $5c2a37736a53c5f6$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $5c2a37736a53c5f6$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $1d23945e8dc67f21$export$3dc388a5f013b4a5)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $4ea8a38c7ff48415$export$fb56ad75dd311c12)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $4ea8a38c7ff48415$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $4ea8a38c7ff48415$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(fragment, 18, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $082679cd84e94918$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $5c2a37736a53c5f6$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $5c2a37736a53c5f6$export$67ebef60e6f28a6)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $4ea8a38c7ff48415$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $9fba573353f18c1e$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $4ea8a38c7ff48415$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $eae79035baa6cc4b$export$bf638b60ea8b89b7)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $fff656c6ad75d9d4$export$65772b71e1d017ba)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(fragment, 19, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $fff656c6ad75d9d4$export$65772b71e1d017ba)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();







var $39a9fcd5d49abd6d$var$destructiveMethodCounts = new ((0, $e508a8b27183dcee$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $39a9fcd5d49abd6d$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $39a9fcd5d49abd6d$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($39a9fcd5d49abd6d$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
function $39a9fcd5d49abd6d$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $39a9fcd5d49abd6d$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$39a9fcd5d49abd6d$var$destructiveMethodCounts.has(cache)) {
            $39a9fcd5d49abd6d$var$destructiveMethodCounts.set(cache, 0);
            $39a9fcd5d49abd6d$var$wrapDestructiveCacheMethod(cache, "evict");
            $39a9fcd5d49abd6d$var$wrapDestructiveCacheMethod(cache, "modify");
            $39a9fcd5d49abd6d$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $a7e449070b5220d2$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $a7e449070b5220d2$export$bd096ddbd246c79c).loading && !(0, $f316d589362b7354$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $a7e449070b5220d2$export$bd096ddbd246c79c).setVariables;
        if (!(0, $f316d589362b7354$export$411ce8e5a71e3069)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $39a9fcd5d49abd6d$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $f316d589362b7354$export$411ce8e5a71e3069)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we do not tolerate partial results, skip this update to prevent it
        // from being reported. This prevents a situtuation where a query that
        // errors and another succeeds with overlapping data does not report the
        // partial data result to the errored query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && !((_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.returnPartialData) && // In the case of a cache eviction, the diff will become partial so we
        // schedule a notification to send a network request (this.oqListener) to
        // go and fetch the missing data.
        !(oldDiff && oldDiff.complete)) return;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $f316d589362b7354$export$411ce8e5a71e3069)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                oq["observe"]();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                (0, $4c7daee63820cadb$export$419171d60552792a)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $39a9fcd5d49abd6d$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $a7e449070b5220d2$export$37509604341a3464)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $f316d589362b7354$export$411ce8e5a71e3069)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $39a9fcd5d49abd6d$var$destructiveMethodCounts.get(this.cache) && (0, $f316d589362b7354$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $f316d589362b7354$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $082679cd84e94918$export$509e11c221f576c0)();
        var graphQLErrors = (0, $03017244ed48560d$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && (0, $03017244ed48560d$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData = (0, $55294d24f844c965$export$9a905f57d6393874)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($39a9fcd5d49abd6d$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $39a9fcd5d49abd6d$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $f316d589362b7354$export$411ce8e5a71e3069)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $a7e449070b5220d2$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $a7e449070b5220d2$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $39a9fcd5d49abd6d$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $e475fc2afb9e6506$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}



var $6d1ba14627ce6535$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6d1ba14627ce6535$var$IGNORE = Object.create(null);
var $6d1ba14627ce6535$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, documentTransform = _a.documentTransform, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, _e = _a.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? !!cache.assumeImmutableResults : _e, defaultContext = _a.defaultContext;
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $8e29fc57e38c5c41$export$8dbad6f439bb2331)((0, $ec5f72070599e7f6$export$f29926b23b28936b)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $dd03b6e925874374$export$73571c50d0f2507e)(false);
        var defaultDocumentTransform = new (0, $83c4d59f2c3d0de8$export$f887060e48e5dc1b)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $f6495e6f9dbd3da2$export$19901bcd339c3ded)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = assumeImmutableResults;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = defaultContext || Object.create(null);
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $0489aed6bc3d2ffd$export$3991762405098ea)(25));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        return (0, $5c2a37736a53c5f6$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return (0, $5c2a37736a53c5f6$export$67ebef60e6f28a6)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(mutation, 26);
                        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 27);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $b6244fd9c7dca117$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, false), function(result) {
                                    if ((0, $e475fc2afb9e6506$export$b4df399e879e53ab)(result) && errorPolicy === "none") throw new (0, $21c12e1a9818ab2c$export$26a337512320b8c6)({
                                        graphQLErrors: (0, $e475fc2afb9e6506$export$a163557155188b6e)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $e475fc2afb9e6506$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $21c12e1a9818ab2c$export$26a337512320b8c6) ? err : new (0, $21c12e1a9818ab2c$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $39a9fcd5d49abd6d$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            if (!(0, $55294d24f844c965$export$879767c5cdf33cb3)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $55294d24f844c965$export$879767c5cdf33cb3)(result) && (0, $03017244ed48560d$export$d307f5934e447d0e)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $55294d24f844c965$export$9a905f57d6393874)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$6d1ba14627ce6535$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $733ac22812c6d269$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $55294d24f844c965$export$f90dc0a3531b8b83)(result) || (0, $55294d24f844c965$export$879767c5cdf33cb3)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $6d1ba14627ce6535$var$IGNORE
        }) : optimisticResponse;
        if (data === $6d1ba14627ce6535$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $1d23945e8dc67f21$export$8d1e9e5bbfa5d09a)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $1d23945e8dc67f21$export$2dafb573e282fe8d)([
                    "nonreactive"
                ], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $b38df9efe4e75320$export$e5ae0530da5fe96c)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    }
                ], document),
                defaultVars: (0, $733ac22812c6d269$export$84c19026e616569e)((0, $733ac22812c6d269$export$7a5b1fa979d2c158)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $39a9fcd5d49abd6d$export$79a6120a39c90b6a)(this);
        var observable = new (0, $4c7daee63820cadb$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(options.query, 28);
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(options.query.kind === "Document", 29);
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(!options.returnPartialData, 30);
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(!options.pollInterval, 31);
        return this.fetchQuery(queryId, (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
            query: this.transform(options.query)
        })).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $0489aed6bc3d2ffd$export$3991762405098ea)(32));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $a7e449070b5220d2$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $4ea8a38c7ff48415$export$540432d49fcec6c9)(desc)) queryNamesAndDocs.set(_this.transform(desc), false);
            else if ((0, $1937899ec4a35235$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $eeb94b2a0137b911$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $4c7daee63820cadb$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(typeof nameOrDoc === "string" ? 33 : 34, nameOrDoc);
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $39a9fcd5d49abd6d$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $e475fc2afb9e6506$export$b4df399e879e53ab)(result);
                var hasProtocolErrors = (0, $21c12e1a9818ab2c$export$345f95cc6b6b9b0b)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $21c12e1a9818ab2c$export$4995664c1b49842e];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $21c12e1a9818ab2c$export$26a337512320b8c6)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $02cae19fe6259dbb$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $733ac22812c6d269$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $99d11c6192bbecaf$export$c2d084dc44961371)(serverQuery);
                var varJson_1 = (0, $7b2abb9cdc1dc3a0$export$88a0ad9b6f961b51)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast = new (0, $6c4421b0c117868e$export$ae0cf2ec7a6fa78e)([
                        (0, $d021482990d49d37$export$51396ec711da548b)(link, operation)
                    ]);
                    observable = entry.observable = concast;
                    concast.beforeNext(function() {
                        inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $6c4421b0c117868e$export$ae0cf2ec7a6fa78e)([
                (0, $d021482990d49d37$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $6c4421b0c117868e$export$ae0cf2ec7a6fa78e)([
                (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $b6244fd9c7dca117$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $b6244fd9c7dca117$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $e475fc2afb9e6506$export$a163557155188b6e)(result);
            var hasErrors = graphQLErrors.length > 0;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $21c12e1a9818ab2c$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $a7e449070b5220d2$export$bd096ddbd246c79c).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $a7e449070b5220d2$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $21c12e1a9818ab2c$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $21c12e1a9818ab2c$export$26a337512320b8c6)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $a7e449070b5220d2$export$bd096ddbd246c79c).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $6c4421b0c117868e$export$ae0cf2ec7a6fa78e)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $6c4421b0c117868e$export$ae0cf2ec7a6fa78e)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $eeb94b2a0137b911$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $39a9fcd5d49abd6d$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset(); // Force info.getDiff() to read from cache.
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $a7e449070b5220d2$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $f316d589362b7354$export$411ce8e5a71e3069)(data, {})) (0, $4c7daee63820cadb$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $02cae19fe6259dbb$export$77cea355fa80b5f4).of((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $a7e449070b5220d2$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $a7e449070b5220d2$export$bd096ddbd246c79c).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $a7e449070b5220d2$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $a7e449070b5220d2$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $39a9fcd5d49abd6d$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();





function $503262748d6f3f59$export$235b7fc70b9fc359(defaults, options) {
    return (0, $c7d8710b4a0f0a7f$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $c7d8710b4a0f0a7f$export$8e16b83750b44988)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, defaults && defaults.variables), options.variables))
    });
}



var $30b27712e065fa64$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an {@link ApolloLink} instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through {@link Observable} instances.
 */ var $30b27712e065fa64$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of {@link ApolloClient}.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(15);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        _c = options.connectToDevTools, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = _c === void 0 ? typeof window === "object" && !window.__APOLLO_CLIENT__ && globalThis.__DEV__ !== false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $8f19175dc3cc846d$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $9cac3fd081aed538$export$2fed3d61f740bc7f).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $119b34ff2b3530e4$export$83d89fbfd8236492);
        this.localState = new (0, $f6495e6f9dbd3da2$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $6d1ba14627ce6535$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (connectToDevTools) this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "object") {
            var windowWithDevTools = window;
            var devtoolsSymbol = Symbol.for("apollo.devtools");
            (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
            windowWithDevTools.__APOLLO_CLIENT__ = this;
        }
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$30b27712e065fa64$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $30b27712e065fa64$var$hasSuggestedDevtools = true;
            setTimeout(function() {
                if (typeof window !== "undefined" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an {@link ObservableQuery}. We can subscribe to this {@link ObservableQuery} and
     * receive updated results through a GraphQL observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $503262748d6f3f59$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type {@link QueryOptions} that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $503262748d6f3f59$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 16);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $503262748d6f3f59$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * {@link Observable} which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $d021482990d49d37$export$51396ec711da548b)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).debug(17, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $30b27712e065fa64$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $d169a8b9aeea29e8$export$dfdba94ce46d2ea5);



var $b239c6c5b99ad476$exports = {};
"use strict";

$b239c6c5b99ad476$exports = (parcelRequire("6cds3"));





// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $c4fc24b001ee104c$var$contextKey = (0, $e508a8b27183dcee$export$23ba675b4b838b92) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $c4fc24b001ee104c$export$a47505d961ee3a1() {
    (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)("createContext" in $b239c6c5b99ad476$exports, 45);
    var context = $b239c6c5b99ad476$exports.createContext[$c4fc24b001ee104c$var$contextKey];
    if (!context) {
        Object.defineProperty($b239c6c5b99ad476$exports.createContext, $c4fc24b001ee104c$var$contextKey, {
            value: context = $b239c6c5b99ad476$exports.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $c4fc24b001ee104c$export$c2ee824bcc89ca6a = $c4fc24b001ee104c$export$a47505d961ee3a1;


var $d233e958281d3d37$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $c4fc24b001ee104c$export$a47505d961ee3a1)();
    var parentContext = $b239c6c5b99ad476$exports.useContext(ApolloContext);
    var context = $b239c6c5b99ad476$exports.useMemo(function() {
        return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(context.client, 46);
    return $b239c6c5b99ad476$exports.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};











var $4bff17c8abfba151$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $790245ce44667f92$export$4997ffc0176396a6)((0, $28a2319727232c81$export$abbf37c7cf644e41), {
            max: (0, $ec5f72070599e7f6$export$f29926b23b28936b)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $89284a9272570c0b$export$87b462129af3b7d4)
        });
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $5c2a37736a53c5f6$export$3c9a16f847548506)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $5c2a37736a53c5f6$export$3c9a16f847548506)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $4bff17c8abfba151$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $d169a8b9aeea29e8$export$e7ed438e82606689);



var $c70ec078051e520e$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);








function $ef495836dbb1023d$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $1937899ec4a35235$export$417207af72fad9c9)(obj) && $ef495836dbb1023d$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $1937899ec4a35235$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $ef495836dbb1023d$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $ef495836dbb1023d$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $ef495836dbb1023d$var$deepFreeze(obj);
    return obj;
}









var $6365cee98ce6b1ca$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $6365cee98ce6b1ca$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $6365cee98ce6b1ca$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$6365cee98ce6b1ca$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$6365cee98ce6b1ca$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($6365cee98ce6b1ca$export$b931b78cbb3caf86(id) && !$6365cee98ce6b1ca$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$6365cee98ce6b1ca$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $6365cee98ce6b1ca$var$defaultConfig = {
    dataIdFromObject: $6365cee98ce6b1ca$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $6365cee98ce6b1ca$export$fa542f9ee3f7f4e2(config) {
    return (0, $c7d8710b4a0f0a7f$export$8e16b83750b44988)($6365cee98ce6b1ca$var$defaultConfig, config);
}
function $6365cee98ce6b1ca$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $6365cee98ce6b1ca$var$defaultConfig.canonizeResults : value;
}
function $6365cee98ce6b1ca$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $6365cee98ce6b1ca$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $6365cee98ce6b1ca$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($6365cee98ce6b1ca$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $6365cee98ce6b1ca$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $1937899ec4a35235$export$417207af72fad9c9)(result)) return (0, $03017244ed48560d$export$43bee75e5e14138e)(result) ? result.every(function(item) {
        return $6365cee98ce6b1ca$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $4ea8a38c7ff48415$export$fb56ad75dd311c12)(field) && (0, $1d23945e8dc67f21$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $4ea8a38c7ff48415$export$7d1ad22471852218)(field);
            return $6365cee98ce6b1ca$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $6365cee98ce6b1ca$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $6365cee98ce6b1ca$export$4f39afca21bd938e(value) {
    return (0, $1937899ec4a35235$export$417207af72fad9c9)(value) && !(0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(value) && !(0, $03017244ed48560d$export$43bee75e5e14138e)(value);
}
function $6365cee98ce6b1ca$export$b874a818f7a2fa6d() {
    return new (0, $082679cd84e94918$export$509e11c221f576c0)();
}
function $6365cee98ce6b1ca$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $28a2319727232c81$export$193789b4c8246dd4)((0, $733ac22812c6d269$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


var $fb8eab763b88ea45$var$DELETE = Object.create(null);
var $fb8eab763b88ea45$var$delModifier = function() {
    return $fb8eab763b88ea45$var$DELETE;
};
var $fb8eab763b88ea45$var$INVALIDATE = Object.create(null);
var $fb8eab763b88ea45$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $ef495836dbb1023d$export$7f9c177735b71f18)((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $4ea8a38c7ff48415$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $4ea8a38c7ff48415$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $fb8eab763b88ea45$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $fb8eab763b88ea45$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(typeof dataId === "string", 1);
        var merged = new (0, $082679cd84e94918$export$509e11c221f576c0)($fb8eab763b88ea45$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $6365cee98ce6b1ca$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $fb8eab763b88ea45$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $fb8eab763b88ea45$var$DELETE,
                INVALIDATE: $fb8eab763b88ea45$var$INVALIDATE,
                isReference: (0, $4ea8a38c7ff48415$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $4ea8a38c7ff48415$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $6365cee98ce6b1ca$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $fb8eab763b88ea45$var$delModifier ? $fb8eab763b88ea45$var$DELETE : modify((0, $ef495836dbb1023d$export$7f9c177735b71f18)(fieldValue), (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $fb8eab763b88ea45$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $fb8eab763b88ea45$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(2, ref);
                                        return true;
                                    }
                                };
                                if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(3, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $fb8eab763b88ea45$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $fb8eab763b88ea45$var$delModifier, _a) : $fb8eab763b88ea45$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $fb8eab763b88ea45$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $5c2a37736a53c5f6$export$3c9a16f847548506)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $fb8eab763b88ea45$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $fb8eab763b88ea45$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                if ((0, $1937899ec4a35235$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $1937899ec4a35235$export$417207af72fad9c9)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $fb8eab763b88ea45$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $eeba3f635b2d6d0b$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $dd03b6e925874374$export$73571c50d0f2507e)((0, $e508a8b27183dcee$export$772fbc04a0ad4ce9));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($fb8eab763b88ea45$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $6365cee98ce6b1ca$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($fb8eab763b88ea45$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($fb8eab763b88ea45$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $fb8eab763b88ea45$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $fb8eab763b88ea45$export$f8068a30967ddc18(store, entityId) {
    if ($fb8eab763b88ea45$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $fb8eab763b88ea45$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $fb8eab763b88ea45$var$Stump(_this);
            _this.storageTrie = new (0, $dd03b6e925874374$export$73571c50d0f2507e)((0, $e508a8b27183dcee$export$772fbc04a0ad4ce9));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($fb8eab763b88ea45$export$cb507f57054c7321 || ($fb8eab763b88ea45$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $fb8eab763b88ea45$var$Layer = /** @class */ function(_super) {
    (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $f316d589362b7354$export$411ce8e5a71e3069)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($fb8eab763b88ea45$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $fb8eab763b88ea45$var$Stump = /** @class */ function(_super) {
    (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $fb8eab763b88ea45$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($fb8eab763b88ea45$var$Layer);
function $fb8eab763b88ea45$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $f316d589362b7354$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $fb8eab763b88ea45$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $fb8eab763b88ea45$export$cb507f57054c7321 && store.group.caching);
}








function $7f9e882920d61de2$var$shallowCopy(value) {
    if ((0, $1937899ec4a35235$export$417207af72fad9c9)(value)) return (0, $03017244ed48560d$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $7f9e882920d61de2$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $e508a8b27183dcee$export$7293b8a0b474028d) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $dd03b6e925874374$export$73571c50d0f2507e)((0, $e508a8b27183dcee$export$772fbc04a0ad4ce9));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $1937899ec4a35235$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $1937899ec4a35235$export$417207af72fad9c9)(value)) {
            var copy = $7f9e882920d61de2$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $1937899ec4a35235$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();


function $55cf85a8eb68f69b$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $55cf85a8eb68f69b$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $e508a8b27183dcee$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.config = (0, $c7d8710b4a0f0a7f$export$8e16b83750b44988)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $6365cee98ce6b1ca$export$3ac2a95fbd99c479)(config)
        });
        this.canon = config.canon || new (0, $7f9e882920d61de2$export$c2e7fdd82233f4a4)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $790245ce44667f92$export$4997ffc0176396a6)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $55cf85a8eb68f69b$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $fb8eab763b88ea45$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $ec5f72070599e7f6$export$f29926b23b28936b)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $55cf85a8eb68f69b$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $fb8eab763b88ea45$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $790245ce44667f92$export$4997ffc0176396a6)(function(options) {
            (0, $fb8eab763b88ea45$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $ec5f72070599e7f6$export$f29926b23b28936b)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $fb8eab763b88ea45$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $7f9e882920d61de2$export$c2e7fdd82233f4a4)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, (0, $733ac22812c6d269$export$84c19026e616569e)((0, $733ac22812c6d269$export$d96b2213c1b9d3a9)(query))), variables);
        var rootRef = (0, $4ea8a38c7ff48415$export$634ae0e932e9be99)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $733ac22812c6d269$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $7b2abb9cdc1dc3a0$export$88a0ad9b6f961b51)(variables),
                canonizeResults: canonizeResults
            }, (0, $6365cee98ce6b1ca$export$3a33c00f0ae4a480)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $c70ec078051e520e$export$257c68286583b0f9)($55cf85a8eb68f69b$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $fb8eab763b88ea45$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $082679cd84e94918$export$509e11c221f576c0)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $1d23945e8dc67f21$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $4ea8a38c7ff48415$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $4ea8a38c7ff48415$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $b38df9efe4e75320$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $03017244ed48560d$export$43bee75e5e14138e)(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    enclosingRef: enclosingRef,
                    context: context
                }), resultName);
                else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $28a2319727232c81$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(9, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $082679cd84e94918$export$160070228be94b08)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $ef495836dbb1023d$export$7f9c177735b71f18)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $082679cd84e94918$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $03017244ed48560d$export$43bee75e5e14138e)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $55cf85a8eb68f69b$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $55cf85a8eb68f69b$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $55cf85a8eb68f69b$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $1937899ec4a35235$export$417207af72fad9c9)(value)) {
                (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(!(0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(value), 10, (0, $6365cee98ce6b1ca$export$fdef206c83ff2c09)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

















// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $d6bbd9a31dc4ca24$var$specifierInfoCache = Object.create(null);
function $d6bbd9a31dc4ca24$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $d6bbd9a31dc4ca24$var$specifierInfoCache[cacheKey] || ($d6bbd9a31dc4ca24$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $d6bbd9a31dc4ca24$export$f1953a0407594d2c(specifier) {
    var info = $d6bbd9a31dc4ca24$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $d6bbd9a31dc4ca24$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $d6bbd9a31dc4ca24$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $d6bbd9a31dc4ca24$export$e8f64f7a025887d3(object, schemaKeyPath, $d6bbd9a31dc4ca24$var$extractKey);
            (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(extracted !== void 0, 4, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $d6bbd9a31dc4ca24$export$550737ee0cc371ac(specifier) {
    var info = $d6bbd9a31dc4ca24$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $d6bbd9a31dc4ca24$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $03017244ed48560d$export$d307f5934e447d0e)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $4ea8a38c7ff48415$export$3f5a60fb6a781b4f)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $d6bbd9a31dc4ca24$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $d6bbd9a31dc4ca24$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $d6bbd9a31dc4ca24$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $d6bbd9a31dc4ca24$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $082679cd84e94918$export$509e11c221f576c0)();
    return $d6bbd9a31dc4ca24$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $d6bbd9a31dc4ca24$export$eca459f173e85801(spec) {
    var info = $d6bbd9a31dc4ca24$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $03017244ed48560d$export$43bee75e5e14138e)(s)) {
                $d6bbd9a31dc4ca24$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $03017244ed48560d$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $d6bbd9a31dc4ca24$var$extractKey(object, key) {
    return object[key];
}
function $d6bbd9a31dc4ca24$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $d6bbd9a31dc4ca24$var$extractKey;
    return $d6bbd9a31dc4ca24$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $03017244ed48560d$export$43bee75e5e14138e)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $d6bbd9a31dc4ca24$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $1937899ec4a35235$export$417207af72fad9c9)(value)) {
        if ((0, $03017244ed48560d$export$43bee75e5e14138e)(value)) return value.map($d6bbd9a31dc4ca24$var$normalize);
        return $d6bbd9a31dc4ca24$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $d6bbd9a31dc4ca24$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}


function $0d8ba78c64e91a1b$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $4ea8a38c7ff48415$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $0d8ba78c64e91a1b$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $0d8ba78c64e91a1b$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $0d8ba78c64e91a1b$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $0d8ba78c64e91a1b$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $0d8ba78c64e91a1b$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({
            dataIdFromObject: (0, $6365cee98ce6b1ca$export$bd03c5a9c99d6bce)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $0d8ba78c64e91a1b$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, object), storeObject), context);
            if ((0, $03017244ed48560d$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $d6bbd9a31dc4ca24$export$f1953a0407594d2c)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $5c2a37736a53c5f6$export$3c9a16f847548506)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $0d8ba78c64e91a1b$var$mergeTrueFn : merge === false ? $0d8ba78c64e91a1b$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $0d8ba78c64e91a1b$var$nullKeyFieldsFn : (0, $03017244ed48560d$export$43bee75e5e14138e)(keyFields) ? (0, $d6bbd9a31dc4ca24$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $0d8ba78c64e91a1b$var$simpleKeyArgsFn : (0, $03017244ed48560d$export$43bee75e5e14138e)(keyArgs) ? (0, $d6bbd9a31dc4ca24$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $0d8ba78c64e91a1b$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(!old || old === which, 5, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $6365cee98ce6b1ca$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $5c2a37736a53c5f6$export$3c9a16f847548506)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(6, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $6365cee98ce6b1ca$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $0d8ba78c64e91a1b$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $03017244ed48560d$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $d6bbd9a31dc4ca24$export$550737ee0cc371ac)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $4ea8a38c7ff48415$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $4ea8a38c7ff48415$export$3cdb6c178b88cabe)(fieldName, $0d8ba78c64e91a1b$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $6365cee98ce6b1ca$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $6365cee98ce6b1ca$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $0d8ba78c64e91a1b$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $9fba573353f18c1e$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $0d8ba78c64e91a1b$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $0d8ba78c64e91a1b$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $0d8ba78c64e91a1b$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $0d8ba78c64e91a1b$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $0d8ba78c64e91a1b$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $6365cee98ce6b1ca$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $0d8ba78c64e91a1b$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $4ea8a38c7ff48415$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($0d8ba78c64e91a1b$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $0d8ba78c64e91a1b$var$makeMergeObjectsFunction(context.store)
    };
}
function $0d8ba78c64e91a1b$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(7, (0, $1fc4800207ae15ec$export$f341b4883239463f)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $0d8ba78c64e91a1b$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $03017244ed48560d$export$43bee75e5e14138e)(existing) || (0, $03017244ed48560d$export$43bee75e5e14138e)(incoming)) throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(8);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $1937899ec4a35235$export$417207af72fad9c9)(existing) && (0, $1937899ec4a35235$export$417207af72fad9c9)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(existing) && (0, $6365cee98ce6b1ca$export$4f39afca21bd938e)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $6365cee98ce6b1ca$export$4f39afca21bd938e)(existing) && (0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $6365cee98ce6b1ca$export$4f39afca21bd938e)(existing) && (0, $6365cee98ce6b1ca$export$4f39afca21bd938e)(incoming)) return (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, existing), incoming);
        }
        return incoming;
    };
}


// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $b466551bf7a65900$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $b466551bf7a65900$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $733ac22812c6d269$export$7a5b1fa979d2c158)(query);
        var merger = (0, $6365cee98ce6b1ca$export$b874a818f7a2fa6d)();
        variables = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, (0, $733ac22812c6d269$export$84c19026e616569e)(operationDefinition)), variables);
        var context = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $7b2abb9cdc1dc3a0$export$88a0ad9b6f961b51)(variables)
        }, (0, $6365cee98ce6b1ca$export$3a33c00f0ae4a480)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(ref)) throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(11, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $4ea8a38c7ff48415$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $6365cee98ce6b1ca$export$37874422037b6029)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $b466551bf7a65900$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $4ea8a38c7ff48415$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $0d8ba78c64e91a1b$export$1ad7a877581bdf2e)(arguments, incoming, context.variables);
            if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $4ea8a38c7ff48415$export$7d1ad22471852218)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $b466551bf7a65900$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $b466551bf7a65900$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(incomingValue) || (0, $6365cee98ce6b1ca$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $b466551bf7a65900$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $b38df9efe4e75320$export$43b332f87950a467).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).error(12, (0, $4ea8a38c7ff48415$export$7d1ad22471852218)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $4ea8a38c7ff48415$export$634ae0e932e9be99)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $b466551bf7a65900$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $b466551bf7a65900$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $f5fe3d92b36126ea$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $03017244ed48560d$export$43bee75e5e14138e)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $b466551bf7a65900$var$getChildMergeTree(mergeTree, i));
            $b466551bf7a65900$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $4ea8a38c7ff48415$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $dd03b6e925874374$export$73571c50d0f2507e)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $1d23945e8dc67f21$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $03017244ed48560d$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $4ea8a38c7ff48415$export$3f5a60fb6a781b4f)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $4ea8a38c7ff48415$export$fb56ad75dd311c12)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $b466551bf7a65900$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $28a2319727232c81$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $753e21ebe0b0b700$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $0489aed6bc3d2ffd$export$3991762405098ea)(13, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $b466551bf7a65900$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $03017244ed48560d$export$43bee75e5e14138e)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(existing) || (0, $6365cee98ce6b1ca$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $03017244ed48560d$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $0489aed6bc3d2ffd$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $03017244ed48560d$export$43bee75e5e14138e)(i_1) ? i_1.slice(0) : (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $b466551bf7a65900$var$emptyMergeTreePool = [];
function $b466551bf7a65900$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $b466551bf7a65900$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $b466551bf7a65900$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $b466551bf7a65900$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $b466551bf7a65900$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $b466551bf7a65900$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $b466551bf7a65900$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $b466551bf7a65900$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $b466551bf7a65900$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $b466551bf7a65900$var$mergeTreeIsEmpty(childTree)) {
        $b466551bf7a65900$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $b466551bf7a65900$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $b466551bf7a65900$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $f316d589362b7354$export$411ce8e5a71e3069)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $6365cee98ce6b1ca$export$37874422037b6029)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($b466551bf7a65900$var$warnings.has(typeDotName)) return;
    $b466551bf7a65900$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $03017244ed48560d$export$43bee75e5e14138e)(existing) && !(0, $03017244ed48560d$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(14, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, existing, incoming);
}







var $f9d263c4f7f1b567$export$467265324939f47f = /** @class */ function(_super) {
    (0, $5c2a37736a53c5f6$export$a8ba968b8961cb8a)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $83c4d59f2c3d0de8$export$f887060e48e5dc1b)((0, $b38df9efe4e75320$export$43b332f87950a467));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $9fba573353f18c1e$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        _this.config = (0, $6365cee98ce6b1ca$export$fa542f9ee3f7f4e2)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $0d8ba78c64e91a1b$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $fb8eab763b88ea45$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $b466551bf7a65900$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $55cf85a8eb68f69b$export$628ef07ba8965f12)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $6365cee98ce6b1ca$export$3ac2a95fbd99c479)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $790245ce44667f92$export$4997ffc0176396a6)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $ec5f72070599e7f6$export$f29926b23b28936b)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $fb8eab763b88ea45$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $7b2abb9cdc1dc3a0$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $c70ec078051e520e$export$257c68286583b0f9)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $9fba573353f18c1e$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $9fba573353f18c1e$export$cbe12faed7725318)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        var _a;
        (0, $7b2abb9cdc1dc3a0$export$88a0ad9b6f961b51).reset();
        (0, $99d11c6192bbecaf$export$c2d084dc44961371).reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 || _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $4ea8a38c7ff48415$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $0489aed6bc3d2ffd$export$f5708dca728d7177).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $6365cee98ce6b1ca$export$b5a638e9b3fff9f3).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $7b2abb9cdc1dc3a0$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $9fba573353f18c1e$export$cbe12faed7725318)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)((0, $5c2a37736a53c5f6$export$18ce0697a983be9b)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $f316d589362b7354$export$411ce8e5a71e3069)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $4bff17c8abfba151$export$5fc74f25506aa9c));
if (globalThis.__DEV__ !== false) $f9d263c4f7f1b567$export$467265324939f47f.prototype.getMemoryInternals = (0, $d169a8b9aeea29e8$export$e95a5a2210e62466);


const $f25e85c08ff84b11$var$client = new (0, $30b27712e065fa64$export$13f5a5f0f1dbab88)({
    uri: "https://gp-storefront.myshopify.com/admin/api/2023-10/graphql.json",
    cache: new (0, $f9d263c4f7f1b567$export$467265324939f47f)(),
    fetchOptions: {
        mode: "no-cors"
    },
    request: (operation)=>{
        operation.setContext({
            headers: {
                "X-Shopify-Access-Token": "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",
                "Content-type": "application/json"
            }
        });
    },
    credentials: "include"
});
(0, $05ab9eeed7a27669$export$2e2bcd8739ae039).init({
    interpolation: {
        escapeValue: false
    },
    lng: "en",
    fallbackLng: [
        "it",
        "de"
    ],
    resources: {
        en: {
            translation: {
                widget: {
                    title: "Buying and Re-selling has never been easier!",
                    description: `Resellify is the perfect platform to resell your luxury items. Automatically add a new product you are purchasing to your digital Wardrobe and choose to resell it whenever you want with a simple click! Easy, fast and responsible.`,
                    cta: "Learn more",
                    disclaimer: `You are about to share your personal data and purchases with the Resellify marketplace platform. For more details see our`,
                    terms: "I agree"
                },
                modal: {
                    title: "How it works",
                    step1: `<p><strong>1. Add to Resellify</strong></p> We have partnered with Resellify to enable you to join the circular fashion movement. Resell your purchases on the Resellify platform with a simple click. Together, we can do our part to keep fashion out of landfills.`,
                    step2: `<p><strong>2. Resell After</strong></p>
          After you have worn and loved your item, log into app.resellify.it to list your item on the Resellify marketplace with a single click.`,
                    step3: `<p><strong>\u{1F4A1} What if I don't have a Resellify account?</strong></p>
          No worries! You will be directed to set up your free account on the order confirmation page.`,
                    step4: ` You are about to share your personal data and purchases with the Resellify marketplace platform. For more details see our &nbsp;
          <a href="https://app.resellify.it/privacy-policy" target="blank">
            Privacy Policy
          </a>`
                }
            }
        },
        de: {
            translation: {
                widget: {
                    title: "Kaufen und Wiederverkaufen war noch nie so einfach!",
                    description: `Resellify ist die perfekte Plattform, um Ihre Luxusartikel weiterzuverkaufen. F\xfcgen Sie automatisch ein neues Produkt, das Sie kaufen, zu Ihrem digitalen Kleiderschrank hinzu und entscheiden Sie sich mit einem einfachen Klick, es wann immer Sie m\xf6chten weiterzuverkaufen! Einfach, schnell und verantwortungsbewusst.`,
                    cta: "Erfahre mehr",
                    disclaimer: `Sie sind dabei, Ihre pers\xf6nlichen Daten und Eink\xe4ufe mit der Resellify-Marktplattform zu teilen. Weitere Details finden Sie in unserer`,
                    terms: "Ich stimme zu"
                },
                modal: {
                    title: "Wie es funktioniert",
                    step1: `<p><strong>1. Zu Resellify hinzuf\xfcgen</strong></p> Wir haben uns mit Resellify zusammengetan, um Ihnen die Teilnahme an der Kreislaufbewegung der Mode zu erm\xf6glichen. Verkaufen Sie Ihre Eink\xe4ufe auf der Resellify-Plattform mit einem einfachen Klick. Gemeinsam k\xf6nnen wir unseren Teil dazu beitragen, die Mode aus Deponien herauszuhalten.`,
                    step2: `<p><strong>2. Nach dem Verkauf</strong></p>
          Nachdem Sie Ihren Artikel getragen und geliebt haben, melden Sie sich unter app.resellify.it an, um Ihren Artikel mit einem einzigen Klick auf dem Resellify-Marktplatz aufzulisten.`,
                    step3: `<p><strong>\u{1F4A1} Was ist, wenn ich kein Resellify-Konto habe?</strong></p>
          Keine Sorge! Sie werden aufgefordert, Ihr kostenloses Konto auf der Bestellbest\xe4tigungsseite einzurichten.`,
                    step4: ` Sie sind dabei, Ihre pers\xf6nlichen Daten und Eink\xe4ufe mit der Resellify-Marktplattform zu teilen. Weitere Details finden Sie in unserer &nbsp;
          <a href="https://app.resellify.it/privacy-policy" target="blank">
            Datenschutz-Bestimmungen
          </a>`
                }
            }
        },
        es: {
            translation: {
                widget: {
                    title: "\xa1Comprar y revender nunca ha sido tan f\xe1cil!",
                    description: `Resellify es la plataforma perfecta para revender sus art\xedculos de lujo. \xa1Agregue autom\xe1ticamente un nuevo producto que est\xe1 comprando a su guardarropa digital y elija revenderlo cuando quiera con un simple clic! \xa1F\xe1cil, r\xe1pido y responsable!`,
                    cta: "Aprende m\xe1s",
                    disclaimer: `Est\xe1 a punto de compartir sus datos personales y compras con la plataforma del mercado de Resellify. Para m\xe1s detalles ver nuestro`,
                    terms: "Estoy de acuerdo"
                },
                modal: {
                    title: "C\xf3mo funciona",
                    step1: `<p><strong>1. Agregar a Resellify</strong></p> Nos hemos asociado con Resellify para permitirle unirse al movimiento de moda circular. Revenda sus compras en la plataforma Resellify con un simple clic. Juntos, podemos hacer nuestra parte para mantener la moda fuera de los vertederos.`,
                    step2: `<p><strong>2. Revender despu\xe9s</strong></p>
          Despu\xe9s de usar y amar su art\xedculo, inicie sesi\xf3n en app.resellify.it para enumerar su art\xedculo en el mercado de Resellify con un solo clic.`,
                    step3: `<p><strong>\u{1F4A1} \xbfQu\xe9 pasa si no tengo una cuenta de Resellify?</strong></p>
          \xa1No te preocupes! Se le dirigir\xe1 a configurar su cuenta gratuita en la p\xe1gina de confirmaci\xf3n del pedido.`,
                    step4: ` Est\xe1 a punto de compartir sus datos personales y compras con la plataforma del mercado de Resellify. Para m\xe1s detalles ver nuestro &nbsp;
          <a href="https://app.resellify.it/privacy-policy" target="blank">
            Pol\xedtica de privacidad
          </a>`
                }
            }
        },
        pt: {
            translation: {
                widget: {
                    title: "Comprar e revender nunca foi t\xe3o f\xe1cil!",
                    description: `Resellify \xe9 a plataforma perfeita para revender seus itens de luxo. Adicione automaticamente um novo produto que voc\xea est\xe1 comprando ao seu guarda-roupa digital e escolha revend\xea-lo sempre que quiser com um simples clique! F\xe1cil, r\xe1pido e respons\xe1vel.`,
                    cta: "Saiba mais",
                    disclaimer: `Voc\xea est\xe1 prestes a compartilhar seus dados pessoais e compras com a plataforma do mercado Resellify. Para mais detalhes, consulte o nosso`,
                    terms: "Eu concordo"
                },
                modal: {
                    title: "Como funciona",
                    step1: `<p><strong>1. Adicionar ao Resellify</strong></p> N\xf3s nos associamos \xe0 Resellify para permitir que voc\xea participe do movimento de moda circular. Revenda suas compras na plataforma Resellify com um simples clique. Juntos, podemos fazer nossa parte para manter a moda fora dos aterros sanit\xe1rios.`,
                    step2: `<p><strong>2. Revender depois</strong></p>
          Depois de usar e amar seu item, fa\xe7a login em app.resellify.it para listar seu item no mercado Resellify com um \xfanico clique.`,
                    step3: `<p><strong>\u{1F4A1} E se eu n\xe3o tiver uma conta Resellify?</strong></p>
          Sem problemas! Voc\xea ser\xe1 direcionado para configurar sua conta gratuita na p\xe1gina de confirma\xe7\xe3o do pedido.`,
                    step4: ` Voc\xea est\xe1 prestes a compartilhar seus dados pessoais e compras com a plataforma do mercado Resellify. Para mais detalhes, consulte o nosso &nbsp;
          <a href="https://app.resellify.it/privacy-policy" target="blank">
            Pol\xedtica de Privacidade
          </a>`
                }
            }
        },
        fr: {
            translation: {
                widget: {
                    title: "Acheter et revendre n'a jamais \xe9t\xe9 aussi facile!",
                    description: `Resellify est la plateforme id\xe9ale pour revendre vos articles de luxe. Ajoutez automatiquement un nouveau produit que vous achetez \xe0 votre garde-robe num\xe9rique et choisissez de le revendre quand vous voulez d'un simple clic! Facile, rapide et responsable.`,
                    cta: "En savoir plus",
                    disclaimer: `Vous \xeates sur le point de partager vos donn\xe9es personnelles et vos achats avec la plateforme de march\xe9 Resellify. Pour plus de d\xe9tails, voir notre`,
                    terms: "J'accepte"
                },
                modal: {
                    title: "Comment \xe7a marche",
                    step1: `<p><strong>1. Ajouter \xe0 Resellify</strong></p> Nous nous sommes associ\xe9s \xe0 Resellify pour vous permettre de rejoindre le mouvement de la mode circulaire. Revendez vos achats sur la plateforme Resellify en un simple clic. Ensemble, nous pouvons faire notre part pour garder la mode hors des d\xe9charges.`,
                    step2: `<p><strong>2. Revendre apr\xe8s</strong></p>
          Apr\xe8s avoir port\xe9 et aim\xe9 votre article, connectez-vous \xe0 app.resellify.it pour r\xe9pertorier votre article sur le march\xe9 Resellify en un seul clic.`,
                    step3: `<p><strong>\u{1F4A1} Que se passe-t-il si je n'ai pas de compte Resellify?</strong></p>
          Pas de soucis! Vous serez dirig\xe9 pour configurer votre compte gratuit sur la page de confirmation de commande.`,
                    step4: ` Vous \xeates sur le point de partager vos donn\xe9es personnelles et vos achats avec la plateforme de march\xe9 Resellify. Pour plus de d\xe9tails, voir notre &nbsp;
          <a href="https://app.resellify.it/privacy-policy" target="blank">
            Politique de confidentialit\xe9
          </a>`
                }
            }
        },
        it: {
            translation: {
                widget: {
                    title: "Comprare e Ri-vendere non \xe8 mai stato cosi facile!",
                    description: `Resellify \xe8 la piattaforma perfetta per rivendere i Tuoi articoli di
          lusso. Aggiungi automaticamente un prodotto nuovo che stai
          acquistando al tuo Guardaroba digitale e scegli di rivenderlo quando
          vuoi con un semplice click! Facile, veloce e responsabile.`,
                    cta: "Ulteriori informazioni",
                    disclaimer: `Stai per condividere i tuoi dati personali e i tuoi acquisti con la
          piattaforma marketplace Resellify. Per maggiori dettagli vedi la
          nostra`,
                    terms: "Acconsento"
                },
                modal: {
                    title: "Come funziona",
                    step1: `<p><strong>1. Aggiungi a Resellify</strong></p> Abbiamo stretto una partnership con Resellify
          per consentirti di aderire al movimento circolare della moda. Rivendi
          i tuoi acquisti sulla piattaforma Resellify con un semplice clic.
          Insieme, possiamo fare la nostra parte per tenere la moda fuori dalle
          discariche.`,
                    step2: `<p><strong>2. Rivendi Dopo</strong></p>
          Dopo aver indossato e donato amore al tuo articolo, accedi all' app.resellify.it per mettere in vendita il tuo articolo sul marketplace di Resellify con un solo click.`,
                    step3: `<p><strong>\u{1F4A1} Cosa succede se non ho un account Resellify?</strong></p>
          Niente panico! Verrai indirizzato a configurare il tuo account gratuito sulla pagina di conferma dell'ordine.`,
                    step4: ` Stai per condividere i tuoi dati personali e i
          tuoi acquisti con la piattaforma marketplace Resellify. Per maggiori
          dettagli vedi la nostra &nbsp;
          <a href="https://app.resellify.it/privacy-policy" target="blank">
            Privacy Policy
          </a>`
                }
            }
        }
    }
});
const $f25e85c08ff84b11$var$widgetDivs = document.querySelectorAll(".gp-widget");
$f25e85c08ff84b11$var$widgetDivs.forEach((widgetDiv)=>{
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(widgetDiv);
    root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $96fae657dd539aec$export$1325e8699caa160f), {
            i18n: (0, $05ab9eeed7a27669$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d233e958281d3d37$export$c16b04c8a9956446), {
                client: $f25e85c08ff84b11$var$client,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a198c5b7f78064c1$export$2e2bcd8739ae039), {
                    dataset: widgetDiv.dataset
                })
            })
        })
    }));
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $ea833559f5a67bb4$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.js.map
